import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  vi: {
    policyObj: {
      text1:
        "Chính sách hoàn hủy tuân thủ theo chính sách hoàn hủy của từng sân golf, được quy định chi tiết trong bảng dưới đây.",
      text2:
        "Mỗi sân golf sẽ có quy định về thời gian được phép hoàn hủy. Nếu khách hàng yêu cầu hủy trong thời gian quy định của sân golf. Chúng tôi sẽ thực hiện hoàn tiền cho khách hàng trong vòng 02 ngày làm việc kể từ lúc thời điểm nhận được yêu cầu hoàn hủy hợp lệ của khách hàng.",
      text3:
        "Nếu khách hàng đặt và thanh toán luôn trên website thì có thể giờ chơi đó đã bị hết.",
      text4:
        "Quy trình của bên Công ty chúng tôi: Khách đặt trên website -> Nhân viên liên hệ để xác nhận -> Sales nhập thông tin trên CMS (thì mới có  mã booking và thông tin chính xác) -> Khách hàng thanh toán.",
      text5:
        "Khách hành sử dụng 1 trong 2 hình thức thanh toán dưới đây để thực hiện thanh toán tiền đặt sân:",
      text6: "1. Chuyển khoản.",
      text7:
        "Khách hàng lựa chọn hình thức thanh toán này tại phần thông tin thanh toán khi đặt đơn đặt sân trên Nền tảng của chúng tôi. Khách hàng chuyển khoản trực tiếp vào tài khoản ngân hàng của wBooking theo đúng thông tin hướng dẫn khi lựa chọn hình thức thanh toán này.",
      text8: ` Khách hàng khi lựa chọn phương thức thanh toán chuyển khoản sẽ thực
          hiện thanh toán theo thông tin số tài khoản ngân hàng chuyển khoản như
          sau:`,
      text9: `- Tên tài khoản thụ hưởng: Công ty cổ phần dịch vụ đặt sân Golf WGHN`,
      text10: `- Số tài khoản: 888899988`,
      text11: `- Ngân hàng thụ hưởng: Ngân hàng thương mại cổ phần Nam Á`,
      text12: `2. Thẻ tín dụng/ ghi nợ.`,
      text13: `Khách hàng lựa chọn hình thức thanh toán này tại phần thông tin thanh
          toán khi đặt đơn đặt sân trên Nền tảng của chúng tôi. Sau khi lựa chọn
          hình thức thanh toán này, Khách hàng sẽ thực hiện trực tiếp các bước
          thanh toán qua Cổng thanh toán Epay. Khi sử dụng hình thức thanh toán
          này, Khách hàng sẽ phải trả phí dịch vụ cho Cổng thanh toán Epay.`,

      text14: `Các phương thức cung ứng dịch vụ và thời hạn ước tính cho việc cung ứng dịch vụ:`,
      text15: `Khi Bạn ấn đặt thành công, nhân viên chúng tôi sẽ nhận được thông tin
          và liên hệ lại để chốt lại giờ chơi và giá chơi.`,
      text16: `Sau đó, nhân viên CSKH bên công ty chúng tôi sẽ nhập thông tin đặt sân
          của khách lên phần mềm CMS, sẽ có thông báo tự động gửi về zalo theo
          số điện thoại hoặc cuộc gọi xác nhận trong 1 giờ để quý khách xác nhận
          thông tin.`,
      text17: `Lưu ý.`,
      text18: `Trường hợp phát sinh chậm trễ trong
          việc cung ứng dịch vụ chúng tôi sẽ thông tin kịp thời cho khách hàng
          và khách hàng có thể lựa chọn giữa việc Hủy hoặc tiếp tục chờ thông
          tin từ email.`,

      text19: `Điều khoản bảo mật`,
      text20: `Chính sách bảo vệ thông tin cá nhân người tiêu dùng`,
      text21: `1. Mục đích và phạm vi thu thập thông tin`,
      text22: `Công ty thu thập thông tin của người tiêu dùng nhằm mục đích sử dụng
          để cung cấp dịch vụ thương mại điện tử, khi người dùng đăng ký tài
          khoản, thông tin cá nhân mà`,
      text23: `Họ và tên`,
      text24: `Địa chỉ Email`,
      text25: `Số điện thoại`,
      text26: `Địa chỉ liên lạc`,
      text27: `Tên và địa chỉ trụ sở chính đối với tổ chức, doanh nghiệp`,
      text28: `Số, ngày cấp và nơi cấp giấy chứng nhận đăng ký kinh doanh của
            thương nhân, hoặc số, ngày cấp và đơn vị cấp quyết định thành lập
            của tổ chức, hoặc mã số thuế cá nhân của cá nhân.`,
      text29: `Dữ liệu tổng hợp về nội dung người dùng sử dụng.`,
      text30: `Thông tin được gửi bởi hoặc liên quan đến (các) thiết bị được sử
            dụng để truy cập vào`,
      text31: `2. Phạm vi sử dụng thông tin`,
      text32: `Đối với nội bộ công ty`,
      text33: `Cung cấp các dịch vụ đến Thành viên`,
      text34: `Gửi các thông báo về các hoạt động trao đổi thông tin giữa thành
            viên và Công ty`,
      text35: `Cung cấp thông tin về sản phẩm đến khách hàng nếu có yêu cầu từ
            khách hàng`,
      text36: `Gửi email tiếp thị, khuyến mại về hàng hóa do chúng tôi bán;`,
      text37: `Gửi các thông báo về các hoạt động trên website`,
      text38: `Ngăn ngừa các hoạt động phá hủy tài khoản người dùng của thành
            viên hoặc các hoạt động giả mạo Thành viên;`,
      text39: `Liên lạc và giải quyết với thành viên trong những trường hợp đặc
            biệt;`,
      text40: `Không sử dụng thông tin cá nhân của thành viên ngoài mục đích xác
            nhận và liên hệ có liên quan đến giao dịch tại website`,
      text41: `Trong trường hợp có yêu cầu của pháp luật`,
      text42: `có trách nhiệm hợp tác
            cung cấp thông tin cá nhân thành viên khi có yêu cầu từ cơ quan tư
            pháp bao gồm: Viện kiểm sát, tòa án, cơ quan công an điều tra liên
            quan đến hành vi vi phạm pháp luật nào đó của khách hàng. Ngoài ra,
            không ai có quyền xâm phạm vào thông tin cá nhân của thành viên`,
      text43: `Thời gian lưu trữ thông tin`,
      text44: `Đối với thông tin cá nhân, Website chỉ xóa đi dữ liệu này nếu
            Khách hàng có yêu cầu, Khách hàng yêu cầu gửi mail về email
            booking@booking.wghn.net;`,
      text45: `Ngoài trường hợp trên, Thông tin cá nhân Thành viên sẽ được bảo
            mật trên máy chủ của Booking.`,
      text46: `Những người hoặc tổ chức có thể được tiếp cận với thông tin cá nhân`,
      text47: `Đối tượng được tiếp cận với thông tin cá nhân của Khách hàng thuộc một
          trong những trường hợp sau:`,
      text48: `CÔNG TY CỔ PHẦN DỊCH VỤ ĐẶT SÂN GOLF WGHN`,
      text49: `Các đối tác có ký hợp động thực hiện 1 phần dịch vụ do Công ty
            cung cấp, các đối tác này sẽ nhận được những thông tin theo thỏa
            thuận hợp đồng (có thể một phần hoặc toàn bộ thông tin tuy theo điều
            khoản hợp đồng) để tiến hành hỗ trợ người dùng sử dụng dịch vụ do
            Công ty cung cấp.`,
      text50: `Địa chỉ của đơn vị thu thập và quản lý thông tin cá nhân`,
      text51: `Địa chỉ: Số 20 Võ Chí Công, phường Tây Hồ, thành phố Hà Nội, Việt Nam`,
      text52: `Hotline: 02471001088`,
      text53: `Email: booking@booking.wghn.net`,
      text54: `3. Phương thức và công cụ để người tiêu dùng tiếp cận và chỉnh sửa dữ
          liệu cá nhân của mình trên hệ thống thương mại điện tử của đơn vị thu
          thập thông tin.`,
      text55: `Để chỉnh sửa dữ liệu cá nhân của mình trên hệ thống thương mại điện tử
          người sử dụng dịch vụ đăng nhập tài khoản truy cập vào trang cá nhân
          để cập nhật các thông tin cần chỉnh sửa, sau đó lưu lại thông tin, để
          chỉnh sửa thông tin cá nhân.`,
      text56: `Lưu ý khi thành viên đăng ký tài khoản thương mại điện tử của
          Checktee.com`,
      text57: `Thành viên sẽ tự chịu trách nhiệm về bảo mật và lưu giữ mọi hoạt động
          sử dụng dịch vụ dưới tên đăng ký, mật khẩu của mình. Thành viên có
          trách nhiệm thông báo kịp thời cho`,
      text58: `về những hành vi sử dụng
          trái phép, lạm dụng, vi phạm bảo mật, lưu giữ tên đăng ký và mật khẩu
          khi bị xâm phạm để có biện pháp giải quyết phù hợp.`,
      text59: `Thành viên không sử dụng dịch vụ của`,
      text60: `vào những mục đích bất
          hợp pháp, không hợp lý, lừa đảo, đe doạ, thăm dò thông tin bất hợp
          pháp, phá hoại, tạo ra và phát tán virus gây hư hại tới hệ thống, cấu
          hình, truyền tải thông tin của Trang`,
      text61: `hay sử dụng dịch vụ của
          mình vào mục đích đầu cơ, lũng đoạn thị trường tạo những đơn đặt hàng,
          chào hàng giả, kể cả phục vụ cho việc phán đoán nhu cầu thị trường.
          Trong trường hợp vi phạm thì thành viên phải chịu trách nhiệm về các
          hành vi của mình trước pháp luật.`,
      text62: `Thành viên không được hành động gây mất uy tín của Trang thương mại
          điện tử`,
      text63: `dưới mọi hình
          thức như gây mất đoàn kết giữa các thành viên bằng cách sử dụng tên
          đăng ký thứ hai, thông qua một bên thứ ba hoặc tuyên truyền, phổ biến
          những thông tin không có lợi cho uy tín của Website`,
      text64: `4. Cam kết bảo mật thông tin khách hàng:`,
      text65: `Khi thu thập các thông tin cá nhân của khách hàng,`,
      text66: `cam kết:`,
      text67: `- Không bán, chia sẻ hay trao đổi thông tin cá nhân của khách hàng
            khi thu thập trên trang`,
      text68: `cho một bên thứ ba nào
            khác. Trừ trường hợp:`,
      text69: `Các bên thứ 3 ký hợp đồng hợp tác với`,
      text70: `để cung cấp dịch vụ thương
              mại điện tử như: Đơn vị cung cấp Ví điện tử, đơn vị cung cấp dịch
              vụ trung gian thanh toán.`,
      text71: `Theo yêu cầu của cơ quan nhà nước: Viện kiểm sát, tòa án, cơ
              quan công an điều tra liên quan đến hành vi vi phạm pháp luật nào
              đó của khách hàng.`,
      text72: `Khi thu thập thông tin khách hàng, Booking chỉ dùng để phục vụ cho
            quá trình cung cấp dịch vụ thương mại điện tử trên Booking. Không sử
            dụng thông tin khách hàng vì bất kỳ mục đích nào khác ngoài hoạt
            động cung cấp dịch vụ thương mại điện tử;`,
      text73: `Thông tin cá nhân Thành viên sẽ được bảo mật trên máy chủ của ứng
            dụng Booking. Booking chỉ xóa đi dữ liệu này nếu Khách hàng có yêu
            cầu, Khách hàng yêu cầu chọn mục “Xóa tài khoản” trong trang cá nhân
            hoặc gửi thông tin đến email booking@booking.wghn.net;`,
      text74: `Cơ chế tiếp nhận phản ánh liên quan tới việc sử dụng thông tin cá nhân
          trái với mục đích thu thập thông tin đã công bố`,
      text75: `Khi khách hàng có căn cứ cho rằng các thông tin cá nhân do`,
      text76: `thu thập được sử dụng
          trái với mục đích đã công bố. Khách hàng khiếu nại trực tiếp với ban
          quản trị`,
      text77: `thông qua các
          kênh sau:`,
      text78: `Gọi điện đến số điện thoại: 02471001088`,
      text79: `Gửi email về địa chỉ: booking@booking.wghn.net`,
      text80: `Đến trực tiếp trụ sở chính của Handeee hoặc gửi thư phản ánh, kiến
            nghị về địa chỉ: Số 20 Võ Chí Công, phường Tây Hồ, thành phố Hà Nội CÔNG TY CỔ PHẦN DỊCH VỤ ĐẶT SÂN GOLF WGHN. Địa chỉ: Số 20 Võ Chí Công, phường Tây Hồ, thành phố Hà Nội, Việt Nam.`,
      text81: `5. Quy trình giải quyết phản ánh liên quan tới việc sử dụng thông tin
          cá nhân trái với mục đích thu thập thông tin đã công bố của ban quản
          trị Checktee.com`,
      text82: `Bước 1:`,
      text83: `Bộ phận chăm sóc khách hàng tiếp
          nhận thông tin phản ánh.`,
      text84: `Bước 2:`,
      text85: `Liên hệ với bộ phận kỹ thuật kiểm
          tra thông tin khách hàng được lưu trữ trong máy chủ của ứng dụng có bị
          lộ lọt, hack, đánh cắp hay không.`,
      text86: `Bước 3:`,
      text87: `Báo cáo với Tổng giám đốc – người
          chịu trách nhiệm quản lý ứng dụng và thông báo với khách hàng trong
          thời gian 8 giờ về tình hình và phương án giải quyết khi thông tin cá
          nhân bị sử dụng trái mục đích thu thập thông tin.`,
      text88: `Bước 4:`,
      text89: `Đối với trường hợp đơn giản phát
          sinh trong nội bộ công ty, Booking sẽ xử lý và khắc phục. Trong trường
          nằm ngoài khả năng và thẩm quyền của Booking thì ban quản trị sẽ yêu
          cầu cơ quan công an có thẩm quyền giải quyết, đồng thời phối hợp với
          cơ quan công an để điều tra và gải quyết.`,
      text90: `thu thập bao gồm:`,
      text91: "1. Cam kết bảo mật.",
      text92:
        "Hệ thống thanh toán thẻ được cung cấp bởi các đối tác cổng thanh toán (“Đối Tác Cổng Thanh Toán”) đã được cấp phép hoạt động hợp pháp tại Việt Nam. Theo đó, các tiêu chuẩn bảo mật thanh toán thẻ tại website checkktee.com đảm bảo tuân thủ theo các tiêu chuẩn bảo mật ngành.",
      text93: `2. Quy định bảo mật.`,
      text94: `2.1. Chính sách giao dịch thanh toán bằng thẻ quốc tế và thẻ nội địa (internet banking) đảm bảo tuân thủ các tiêu chuẩn bảo mật của các Đối Tác Cổng Thanh Toán gồm:`,
      text95: `- Thông tin tài chính của Khách hàng sẽ được bảo vệ trong suốt quá trình giao dịch bằng giao thức SSL (Secure Sockets Layer).`,
      text96: `- Đảm bảo tiêu chuẩn bảo mật dữ liệu thông tin thanh toán.`,
      text97: `- Mật khẩu sử dụng một lần (OTP) được gửi qua SMS để đảm bảo việc truy cập tài khoản được xác thực.`,
      text98: `- Các nguyên tắc và quy định bảo mật thông tin trong ngành tài chính ngân hàng theo quy định của Ngân hàng nhà nước Việt Nam.`,
      text99: `2.2. Chính sách bảo mật giao dịch trong thanh toán của website checktee.com áp dụng với Khách hàng:`,
      text100: `- Công ty cung cấp tiện ích lưu giữ token - chỉ lưu chuỗi đã được mã hóa bởi Đối Tác Cổng Thanh Toán cung cấp cho Công ty. Công ty không trực tiếp lưu trữ thông tin thẻ khách hàng. Việc bảo mật thông tin thẻ thanh toán Khách hàng được thực hiện bởi Đối Tác Cổng Thanh Toán đã được cấp phép.`,
      text101: `- Đối với thẻ quốc tế: thông tin thẻ thanh toán của Khách hàng mà có khả năng sử dụng để xác lập giao dịch không được lưu trên hệ thống của website checktee.com Đối Tác Cổng Thanh Toán sẽ lưu trữ và bảo mật.`,
      text102: `- Đối với thẻ quốc tế: thông tin thẻ thanh toán của Khách hàng mà có khả năng sử dụng để xác lập giao dịch không được lưu trên hệ thống của website checktee.com Đối Tác Cổng Thanh Toán sẽ lưu trữ và bảo mật.`,
      text103: `- Đối với thẻ nội địa (internet banking), Công ty chỉ lưu trữ mã đơn hàng, mã giao dịch và tên ngân hàng. Công ty cam kết đảm bảo thực hiện nghiêm túc các biện pháp bảo mật cần thiết cho mọi hoạt động thanh toán thực hiện trên sàn giao dịch thương mại điện tử website checktee.com`,
      text104: `Giải quyết tranh chấp khiếu nại`,
      text105: `Cơ chế giải quyết tranh chấp khiếu nại`,
      text106: `Bước 1: Tiếp nhận thông tin khiếu nại:`,
      text107: `Khách hàng có thể gửi thông tin khiếu nại đến wBooking bằng một trong các hình thức sau:`,
      text108: `Gọi điện thoại đến tổng đài 02471001088 hoặc email tới booking@booking.wghn.net`,
      text109: `Khách hàng Cung cấp các thông tin kèm theo (số điện thoại, tên, sân chơi, ngày giờ chơi) và vấn đề cần hỗ trợ để được giải quyết khiếu nại.`,
      text110: `Bước 2: Xác thực thông tin:`,
      text111: ` Trong vòng 01 ngày (hoặc sớm hơn nếu có thể), wBooking sẽ xác thực thông tin khiếu nại, kiểm tra, xem xét và thông báo cho các bên liên quan.`,
      text112: `WBooking sẽ đề nghị Khách hàng cung cấp các bằng chứng liên quan đến nội dung khiếu nại và gửi khiếu nại cho Nhà cung cấp (nếu có).`,
      text113: `Bước 3: Giải quyết khiếu nại:`,
      text114: `Trong vòng 01 ngày (hoặc sớm hơn nếu có thể), wBooking liên hệ với Khách hàng và Nhà cung cấp để giải quyết khiếu nại.`,
      text115: `Bước 4: Thương lượng và hòa giải:`,
      text116: `Nếu có thể, wBooking sẽ hỗ trợ Khách hàng và Nhà cung cấp thương lượng và hòa giải để giải quyết tranh chấp trong thời gian hợp lý.`,
      text117: `Bước 5: Trọng tài hoặc Tòa án:`,
      text118: `Nếu thương lượng/hòa giải không thành, tranh chấp sẽ được giải quyết tại Tòa án có thẩm quyền theo quy định pháp luật.`,
      text119: `Cam kết của wBooking:`,
      text120: `WBooking cam kết giải quyết mọi tranh chấp, khiếu nại trên cơ sở khách quan, dựa trên thỏa thuận và quy định pháp luật trên tinh thần đảm bảo quyền lợi hợp pháp của Khách hàng.`,
      text121: `Bất kỳ tranh cãi, khiếu nại hoặc tranh chấp phát sinh từ hoặc liên quan đến giao dịch tại wBooking đều sẽ được giải quyết thông qua hình thức thương lượng, hòa giải giữa các bên trên tinh thần thiện chí cùng có lợi. Trường hợp không thể giải quyết bằng thương lượng, hòa giải các Bên quyết định đưa vấn đề khiếu nại giải quyết tại Tòa án nhân dân có thẩm quyền. Quyết định Tòa án là phán quyết cuối cùng cho các bên thực hiện.`,
      text122: `Căn cứ pháp lý:`,
      text123: ` Luật Bảo vệ quyền lợi người tiêu dùng năm 2010, Chương 4 về Giải quyết tranh chấp giữa người tiêu dùng và tổ chức, cá nhân kinh doanh hàng hóa, dịch vụ.`,
      text124: "Điều khoản và điều kiện giao dịch chung",
      text125: `I. QUY ĐỊNH CHUNG`,
      text126: `Công ty cổ phần dịch vụ đặt sân Golf WGHN (wBooking) thực hiện việc cung cấp dịch vụ thông qua website checktee.com. Bằng cách truy cập, đăng nhập và sử dụng website, người sử dụng dịch vụ (“Bạn” hoặc “Người dùng” đồng ý với các Điều khoản và Điều kiện này, các chính sách liên quan tới dịch vụ của wBooking và các chính sách khác được thông báo trên website tại từng thời điểm.`,
      text127: `Chúng tôi có thể sửa đổi, bổ sung, loại bỏ một số nội dung của Điều Khoản và Điều kiện này vào bất kỳ thời điểm nào mà không cần thông báo trước. Bằng việc tiếp tục đăng nhập, truy cập và sử dụng website, sử dụng dịch vụ của Chúng tôi, bạn đồng ý và chấp thuận với những nội dung thay đổi đó.`,
      text128: `Nếu Bạn sử dụng Dịch vụ trên website checktee.com để đặt dịch vụ cho cá nhân/tổ chức khác mà Bạn được ủy quyền hợp pháp để thực hiện yêu cầu (“Người Tiêu Dùng Cuối Cùng”), Bạn có nghĩa vụ thông báo các Điều khoản và Điều kiện này cho Người Tiêu Dùng Cuối Cùng.`,
      text129: `1. Phạm vi áp dụng`,
      text130: `Thông qua website, Chúng tôi cung cấp công cụ trực tuyến để Bạn có thể tìm kiếm, đưa ra yêu cầu sử dụng hoặc đặt mua các sản phẩm liên quan đến giờ chơi golf và các sản phẩm khác (“Dịch vụ”) với các hình thức thanh toán nhanh chóng, an toàn và tiện lợi`,
      text131: `Để tạo thuận lợi cho Bạn trong việc tìm kiếm thông tin, Chúng tôi sẽ hiển thị thông tin về các sản phẩm giờ chơi golf trên website.`,
      text132: `Yêu cầu của bạn được Chúng tôi xử lý và xác nhận khi bạn nhận được một Cuộc gọi Xác nhận qua số điện thoại mà Bạn đã đăng ký trên website hoặc thông báo qua Zalo OA theo số điện thoại của Bạn hoặc thông báo gửi vào tài khoản của bạn trên website.`,
      text133: `2. Không đảm bảo`,
      text134: `Chúng Tôi sẽ sử dụng những kỹ năng chuyên môn và sự cẩn trọng trong việc thực hiện Dịch Vụ. Tuy nhiên, Chúng Tôi không xác nhận và không đảm bảo rằng tất cả các thông tin được cung cấp là chính xác, đầy đủ, phù hợp và Chúng Tôi không chịu trách nhiệm cho bất kỳ sai sót (bao gồm cả lỗi sắp xếp và đánh máy), trở ngại (do sự hư hỏng, sửa chữa hoặc nâng cấp tạm thời đối với website), sự nhầm lẫn, thông tin sai lệch hoặc việc không thể chuyển thông tin. Chúng tôi sẽ luôn chịu trách nhiệm về tính chính xác, hoàn chỉnh của thông tin liên quan`,
      text135: `Nếu Bạn có khiếu nại về Dịch Vụ của Chúng Tôi, Bạn có thể liên hệ với bộ phận Chăm sóc Khách Hàng của Chúng Tôi. Chúng Tôi sẽ cố gắng tìm một phương án giải quyết hợp lý nhưng không đảm bảo một kết quả phù hợp với mong muốn của Bạn.`,
      text136: `3. Hủy, thay đổi yêu cầu`,
      text137: `Khi thực hiện đặt mua Dịch Vụ của Chúng tôi, Bạn chấp nhận và đồng ý tuân thủ chính sách liên quan đến Dịch Vụ đó bao gồm nhưng không giới hạn ở: phạm vi sử dụng và cung cấp Dịch Vụ, điều kiện sử dụng, chính sách hủy và thay đổi sân golf. Chính sách hủy và thay đổi sân golf được đăng trên Nền Tảng của Chúng Tôi ở các trang thông tin về chính sách hoãn hủy, trong quá trình Bạn yêu cầu sử dụng Dịch vụ và trong Thông Báo Thanh toán thành công (nếu có).`,
      text138: `Xin lưu ý rằng Bạn có thể bị tính phí nếu huỷ, thay đổi dịch vụ theo chính sách của Sân golf và/hoặc Bạn không được hoàn lại bất kỳ khoản tiền nào đã thanh toán trước. Một số phí hoặc ưu đãi đặc biệt không thể được huỷ bỏ, hoàn tiền hoặc thay đổi. Chúng Tôi khuyên Bạn nên đọc các chính sách hủy, thay đổi Sản Phẩm và các chính sách khác liên quan tới Sản Phẩm của Wbooking một cách cẩn thận. Nếu Bạn muốn xem lại, chỉnh sửa hoặc thay đổi hoặc hủy một yêu cầu, vui lòng liên hệ với bộ phận Chăm sóc Khách Hàng của Chúng Tôi.`,
      text139: `II. GIÁ, THUẾ, PHÍ`,
      text140: `1. Giá sản phẩm`,
      text141: `Giá sản phẩm có thể bao gồm các loại thuế bổ sung và các chi phí khác nhưng trong một số trường hợp giá có thể không bao gồm thuế và phí dịch vụ; Người Dùng đồng ý rằng họ có trách nhiệm xác minh tổng chi phí thanh toán và các điều khoản và các chi tiết khác khi thông báo xác nhận được gửi đến Người Dùng. Giá được hiển thị chi tiết để Người Dùng có thể thấy số tiền phải trả, bất kỳ chi phí bổ sung do việc sử dụng thẻ tín dụng hoặc phí liên ngân hàng sẽ được tính cho Người Dùng.. Nếu Người Dùng có bất kỳ nghi ngờ nào về dịch vụ, Người Dùng có thể liên hệ với bộ phận dịch vụ khách hàng của WBooking.`,
      text142: `Tùy từng thời điểm Chúng Tôi có thể cung cấp mức giá thấp hơn mức giá thông thường và/hoặc áp dụng các chương trình khuyến mại khác. Bạn phải tuân thủ các điều kiện nhất định để được tham gia chương trình khuyến mại.`,
      text143: `1. Phí thanh toán`,
      text144: `Phí thanh toán qua cổng thanh toán EPAY đối với Thẻ quốc tế phát hành trong nước`,
      text145: `là Giao dịch CTT được Ghi nhận thành công; GTGD: là tổng giá trị của các Giao dịch CTT được Ghi nhận thành công`,
      text146: `3. Phí hủy, hoặc bổ sung yêu cầu`,
      text147: `Bạn có thể hủy bỏ yêu cầu đặt sân bất cứ lúc nào trước khi thực hiện thanh toán. Tuy nhiên sau khi Bạn đã hoàn thành thanh toán và nhận được Thông Báo Thanh toán Thành công từ Chúng Tôi, nếu Bạn muốn hủy bỏ, bạn không được hoàn Phí giao dịch (bao gồm cả phần phí tính theo % giá trị Giao dịch và phần phí tính theo Giao dịch) theo quy định của Nhà Cung Cấp đối với Giao dịch sử dụng nguồn tiền thanh toán là Thẻ quốc tế. Bạn vui lòng đọc kỹ chính sách hoàn hủy trên Nền Tảng của chúng tôi.`,
      text148: `III. THANH TOÁN BẰNG THẺ TÍN DỤNG & GIAN LẬN`,
      text149: `1. Đối với việc thanh toán cho đặt sân thông qua Trang Web này, thẻ tín dụng của bạn sẽ được Wbooking lập biên nhận thanh toán cho giá đầy đủ tại thời điểm đặt sân và xác nhận đặt sân (bất kỳ sự hoàn trả nào có thể được đưa ra đều sẽ phụ thuộc vào các điều kiện của việc đặt sân hiện hữu). Bạn bắt buộc phải kiểm tra các thông tin đặt chỗ kỹ lưỡng trước mỗi lần bạn thực hiện đặt chỗ. Wbooking sẽ xử lý bất kỳ sự hoàn trả nào, nếu có, trong một thời hạn hợp lý. Để bảo vệ và mã hóa các thông tin thẻ tín dụng của bạn khi các thông tin đó được chuyển cho chúng tôi, chúng tôi sử dụng công nghệ mã hóa như chuẩn PCI DSS (Payment Card Industry Data Security Standard) hoặc Secure Sockets Layer (“SSL”) cho các dịch vụ của chúng tôi.`,
      text150: `2. Trong trường hợp bị gian lận thẻ tín dụng hoặc người khác sử dụng trái phép thẻ tín dụng của bạn, bạn có trách nhiệm liên hệ ngân hàng hoặc đơn vị phát hành thẻ của mình ngay lập tức ngay khi nhận biết về hành vi gian lận hoặc sử dụng trái phép thẻ tín dụng này. Trong trường hợp này, Wbooking khước từ trách nhiệm đối với bất kỳ trường hợp gian lận thẻ tín dụng hoặc việc sử dụng trái phép thẻ tín dụng của bạn do người khác gây ra, bất kể trong trường hợp gian lận hoặc việc sử dụng trái phép này được tiến hành thông qua các dịch vụ của Wbooking. Wbooking không có nghĩa vụ bồi thường hoặc hoàn trả khoản tiền thanh toán được xem như là kết quả của việc gian lận này. Chúng tôi có thể xem xét và chấp thuận bù đắp cho bạn dưới một hình thức khác như là cách thể hiện thiện chí của chúng tôi. Bạn chỉ có thể yêu cầu bồi thường khi việc đặt chỗ được thực hiện thông qua máy chủ bảo mật của chúng tôi và việc sử dụng trái phép thẻ tín dụng của bạn là hậu quả từ sự vắng mặt hoặc lơ là của chúng tôi và không có lỗi nào do bạn gây ra khi sử dụng máy chủ bảo mật. Chúng tôi không có trách nhiệm pháp lý đối với gian lận hoặc việc sử dụng trái phép thẻ tín dụng của bạn trong trường hợp gian lận được thực hiện thông qua các ứng dụng hoặc máy chủ không phải của chúng tôi hoặc việc sử dụng trái phép thẻ tín dụng của bạn là hậu quả từ sự lơ đễnh và lỗi của chính bạn. Trong trường hợp bạn nghi ngờ bất kỳ đặt chỗ trái phép hoặc hành vi gian lận nào được thực hiện trên Wbooking, bạn phải liên hệ với bộ phận Hỗ trợ khách hàng của chúng tôi ngay lập tức.`,
      text151: `3. Để thực hiện việc đặt chỗ, yêu cầu bạn phải trên mười tám (18) tuổi và có đầy đủ năng lực pháp luật để thực hiện giao dịch (hoặc có sự ủy quyền từ người giám hộ hợp pháp của bạn). Bạn phải sử dụng thẻ tín dụng hoặc thẻ ghi nợ mà bạn sở hữu, được phát hành mang tên bạn, và chắc chắn rằng có đủ tiền để chi trả các khoản phí giao dịch. Bạn chịu trách nhiệm tài chính cho tất cả các giao dịch được thực hiện trên danh nghĩa của bạn hoặc trên tài khoản của bạn.`,
      text152: `4. Bạn phải đảm bảo rằng các chi tiết mà bạn cung cấp cho chúng tôi là hoàn toàn đúng sự thật, thích hợp và chính xác. WBookinh chỉ chấp nhận thẻ tín dụng phát hành tại Việt Nam. Wbooking có thể bổ sung hoặc loại bỏ các phương thức thanh toán khác theo quyết định của chúng tôi`,
      text153: `5. Trong một số trường hợp, chúng tôi có thể yêu cầu cung cấp hoặc xác minh thêm thông tin để phê duyệt hiệu lực và xác nhận đặt chỗ, như được mô tả chi tiết hơn trên Nền tảng của chúng tôi. Việc đặt sân không được xác nhận cho đến khi bạn đã nhận được email xác nhận, và có khả năng là Nhà Cung Cấp có thể thực hiện các cơ chế kiểm tra gian lận trong quá trình đặt chỗ. Nếu có sự gian lận xảy ra hoặc được xác định xảy ra thì đặt sân sẽ không còn tồn tại hoặc tự động trở nên vô hiệu. Wbooking sẽ không chịu bất cứ trách nhiệm nào. Nếu bạn chọn cách không cấp thêm thông tin, việc đặt trước sẽ không được hoàn thành và sẽ trở nên vô hiệu.`,
      text154: `IV. QUYỀN VÀ TRÁCH NHIỆM CỦA WBOOKING`,
      text155: `1. Quyền của Ban quản lý (BQL) website`,
      text156: `a. Yêu cầu đối tác thực hiện các quyền và nghĩa vụ theo đúng nội dung tại Hợp đồng cung cấp dịch vụ trang checktee.com trên cũng như Quy chế hoạt động của WBooking được công khai trên website: Checktee.com`,
      text157: `b. Checktee.com có thể chấm dứt quyền sử dụng một hoặc tất cả các dịch vụ của đối tác; khách hàng và sẽ thông báo cho đối tác; khách hàng trong thời hạn ít nhất là một (01) tháng trong trường hợp đối tác; khách hàng vi phạm các Quy chế của Website cung cấp dịch vụ checktee.com hoặc có những hành vi ảnh hưởng đến hoạt động kinh doanh trên checktee.com`,
      text158: `c. Checktee.com có thể chấm dứt ngay quyền sử dụng dịch vụ và quyền thành viên của đối tác; khách hàng nếu Website Checktee.com phát hiện đối tác; khách hàng bị kết án hoặc đang trong thời gian thụ án, trong trường hợp đối tác; khác hàng tiếp tục hoạt động có thể gây cho Website Checktee.com trách nhiệm pháp lý, có những hoạt động lừa đảo, giả mạo, gây rối loạn thị trường, gây mất đoàn kết đối với các đối tác; khách hàng khác của Website Checktee.com, hoạt động vi phạm pháp luật hiện hành của Việt Nam.`,
      text159: `d. Checktee.com giữ bản quyền sử dụng dịch vụ và các nội dung trên Website Checktee.com theo các quy định pháp luật về bảo hộ sở hữu trí tuệ tại Việt Nam. Tất cả các biểu tượng, nội dung theo các ngôn ngữ khác nhau đều thuộc quyền sở hữu của Website Checktee.com. Nghiêm cấm mọi hành vi sao chép, sử dụng và phổ biến bất hợp pháp các quyền sở hữu trên.`,
      text160: `2. Trách nhiệm:`,
      text161: `a. Checktee.com có trách nhiệm xây dựng, thực hiện “Cơ chế kiểm tra, giám sát” để đảm bảo việc cung cấp thông tin trên Website Checktee.com được thực hiện chính xác đầy đủ.`,
      text162: `b. Cung cấp đầy đủ, chính xác và kịp thời các thông tin của khách hàng cho đối tác để có thể cung cấp dịch vụ.`,
      text163: `c. Checktee.com sẽ có biện pháp xử lý kịp thời khi phát hiện hoặc nhận được phản ánh về hành vi kinh doanh vi phạm pháp luật trên website đồng thời sẽ hỗ trợ cơ quan quản lý nhà nước điều tra các hành vi kinh doanh vi phạm pháp luật, cung cấp thông tin đăng ký, lịch sử giao dịch và các tài liệu khác về đối tượng có hành vi vi phạm pháp luật trên Website Checktee.com`,
      text164: `d. Checktee.com sẽ có trách nhiệm công bố công khai cơ chế giải quyết các tranh chấp phát sinh trong quá trình giao dịch trên Website Checktee.com. Khi khách hàng trên Website Checktee.com phát sinh mâu thuẫn với người bán (đối tác) hoặc tổn hại lợi ích hợp pháp. Checktee.com sẽ cung cấp cho khách hàng thông tin về người bán (đối tác), tích cực hỗ trợ khách hàng bảo vệ quyền và lợi ích hợp pháp của mình.`,
      text165: `e. Checktee.com chịu trách nhiệm ngăn chặn và loại bỏ khỏi website những thông tin cung cấp dịch vụ không phù hợp theo quy định của pháp luật.`,
      text166: `f. Checktee.com chịu trách nhiệm xây dựng website bao gồm một số công việc chính như: Nghiên cứu, thiết kế, mua sắm các thiết bị phần cứng và phần mềm, kết nối Internet, xây dựng chính sách phục vụ cho hoạt động của Website Checktee.com trong điều kiện và phạm vi cho phép. Website Checktee.com sẽ tiến hành triển khai và hợp tác với các đối tác trong việc xây dựng hệ thống các dịch vụ, các công cụ tiện ích phục vụ cho việc giao dịch của các đối tác tham gia và người sử dụng trên Website Checktee.com.`,
      text167: `g. Checktee.com có trách nhiệm tiếp nhận phản ánh từ đối tác; khách hàng nếu xảy ra tranh chấp. Ban quản trị sẽ cân nhắc xem xét nhưng phản ánh đó. Tùy theo mức độ Website Checktee.com sẽ có phương án bảo vệ quyền lợi của thành viên.`,
      text168: `h. Checktee.com sẽ cố gắng đến mức cao nhất trong phạm vi và điều kiện có thể để duy trì hoạt động bình thường của Website Checktee.com và khắc phục các sự cố như: sự cố kỹ thuật về máy móc, lỗi phần mềm, hệ thống đường truyền internet, nhân sự, các biến động xã hội, thiên tai, mất điện, các quyết định của cơ quan nhà nước hay một tổ chức liên quan thứ ba. Tuy nhiên nếu những sự cố trên xảy ra nằm ngoài khả năng kiểm soát, là những trường hợp bất khả kháng mà gây thiệt hại cho thành viên thì Website Checktee.com không phải chịu trách nhiệm liên đới.`,
      text169: `V. QUYỀN VÀ TRÁCH NHIỆM CỦA KHÁCH HÀNG (NGƯỜI MUA, NGƯỜI SỬ DỤNG DỊCH VỤ…) TRÊN WEBSITE CHECKTEE.COM`,
      text170: `1. Quyền của Khách Hàng`,
      text171: `a. Quyền Được Thông Tin: Khách hàng có quyền được cung cấp đầy đủ, chính xác về thông tin sản phẩm/dịch vụ bao gồm giá cả, chất lượng, tính năng, điều kiện giao dịch, chính sách đổi trả và bảo hành.`,
      text172: `b. Quyền Bảo Mật Thông Tin: Có quyền được bảo vệ thông tin cá nhân, không bị tiết lộ mà không có sự đồng ý, trừ trường hợp pháp luật có quy định khác.`,
      text173: `c. Quyền Được Bảo Vệ: Được bảo vệ khỏi các sản phẩm và dịch vụ kém chất lượng, lừa đảo, gây hại tới quyền lợi và sức khỏe.`,
      text174: `d. Quyền Khiếu Nại và Giải Quyết Tranh Chấp: Có quyền khiếu nại và yêu cầu giải quyết tranh chấp nếu sản phẩm/dịch vụ không đạt yêu cầu hoặc không như mô tả.`,
      text175: `e. Quyền Được Hỗ Trợ: Có quyền nhận sự hỗ trợ từ ban quản lý website về thông tin sản phẩm, hướng dẫn sử dụng và giải đáp thắc mắc.`,
      text176: `2. Trách Nhiệm của Khách Hàng`,
      text177: `a. Cung Cấp Thông Tin Chính Xác: Cung cấp thông tin cá nhân, thanh toán chính xác và đầy đủ khi đăng ký, thực hiện giao dịch trên website.`,
      text178: `b. Tuân Thủ Quy Định Giao Dịch: Tuân thủ các điều khoản và điều kiện giao dịch đã được công bố trên website khi sử dụng dịch vụ.`,
      text179: `c. Bảo Mật Tài Khoản: Giữ bí mật thông tin tài khoản và mật khẩu, không chia sẻ với người khác để tránh gian lận và mất mát thông tin cá nhân.`,
      text180: `d. Sử Dụng Dịch Vụ Có Trách Nhiệm: Sử dụng dịch vụ một cách có trách nhiệm, không sử dụng vào mục đích bất hợp pháp, gây hại cho hệ thống hoặc quyền lợi của người khác.`,
      text181: `e. Thanh Toán Đúng Hạn: Thực hiện thanh toán đúng hạn và đầy đủ theo quy định khi mua sản phẩm/dịch vụ.`,
      text182: `f. Phản Hồi và Góp Ý: Cung cấp phản hồi, góp ý để cải thiện chất lượng dịch vụ, sản phẩm của website.`
    },
    notiRegistered:
      "Khách hàng đã đăng ký tài khoản với số điện thoại này, Vui lòng thực hiện đăng nhập!",
    skipLower: "Bỏ qua",
    register: "Đăng ký",
    create_acc: "Tạo tài khoản",
    regDone: "Đăng ký thành công",
    update: "Cập nhật",
    welcomeWg: "Chào mừng Quý hội viên đến với wGroup",
    yourVid: "mã vID của bạn là",
    pleaseUpdate: "Hãy cập nhật thông tin cá nhân để bảo vệ tài khoản",
    whenJoinWg:
      "Khi tham gia vào WGHN, quý khách có cơ hội nhận được nhiều ưu đãi đặc quyền",
    seeDetail: "Xem chi tiết",
    here: "Tại đây",
    birth: "Ngày tháng năm sinh",
    emailAddress: "Địa chỉ email",
    updateInfoUser: "Cập nhật thông tin cá nhân",
    infoUpdateDone: "Đã cập nhật thông tin thành công.",
    thankYour:
      "Cảm ơn Quý hội viên đã tin tưởng sử dụng dịch vụ của wGroup. Mọi thắc mắc vui lòng liên hệ 024.7100.1088 hoặc chat với CSKH. Tải ứng dụng WGHN ngay để không bỏ lỡ những ưu đãi dành riêng cho Quý hội viên. Trân trọng!",
    captcha: "Nhập mã captcha",
    phoneNumber2: "Số điện thoại",
    needCancel: "Nếu có nhu cầu HỦY vui lòng liên hệ tổng đài: 02471.001.088",
    rechargePoints: "Nạp tiền vào ví Golf",
    paymentMethod: "Phương thức thanh toán",
    order: "Đơn hàng",
    and: "và",
    our: "Của chúng tôi",
    enterPay: "Nhấn 'Thanh toán' đồng nghĩa với việc bạn đồng ý tuân theo",
    enterBook:
      "Nhấn 'Đặt sân' đồng nghĩa bạn đồng ý Thông tin cá nhân của bạn sẽ được sử dụng để xử lý đơn hàng, tăng trải nghiệm sử dụng website, và cho các mục đích cụ thể khác đã được mô tả trong",
    personalInformationPolicy: "Chính sách thu thập thông tin cá nhân",
    termsTransaction: "Điều khoản giao dịch",
    complaints: "Cơ chế giải quyết tranh chấp, khiếu nại ",
    cusInfoSecurityPolicy: "Chính sách bảo mật thông tin khách hàng",
    accountInfo: "Thông tin tài khoản",
    accountSettings: "Cài đặt tài khoản",
    account: "Tài khoản",
    cancellationPolicy: "Chính sách hoàn hủy",
    privacyPolicy: "Chính sách bảo mật",
    paymentInfoSecurityPolicy: "Chính sách bảo mật thông tin thanh toán",
    deliveryPolicy: "Chính sách giao nhận",
    payPolicy: "Chính sách thanh toán",
    policy: "Chính sách",
    branchAddress: "Địa chỉ chi nhánh",
    certificate:
      "Giấy chứng nhận ĐKDN: 0109147466. Cấp lần đầu 27/3/2020. Cơ quan cấp: Sở kế hoạch và đầu tư thành phố Hà Nội.",
    introduce: "Giới thiệu",
    bookingReqSend: "Đã gửi yêu cầu đặt sân",
    yard: "Sân",
    noti:
      "Quý khách vui lòng nhập thông tin để được báo giá dự kiến cho dịch vụ Đặt sân",
    noti1: "Cảm ơn quý khách. Giá dự kiến của dịch vụ đặt sân là: ",
    noti2:
      " đ/ 1 pax. Hãy gửi yêu cầu đặt sân để được báo giá chính xác nhất và sử dụng những ưu đãi của wGroup cũng như các đối tác.",
    typeInsurance: "Chọn gói HIO",
    typeInsuranceAll: "Chọn gói HIO cho toàn đơn",
    titleHeader: "Đặt sân",
    titleMenuArea: "Chọn theo khu vực",
    titleHotDeal: "Giá tốt",
    nearestDate: "Ngày gần nhất",
    incorrectCode: "Mã code không đúng, vui lòng thử lại.",
    farthestDate: "Lọc theo ngày",
    titleTop10: "Top 10 sân tốt",
    login: "Đăng nhập",
    logout: "Đăng xuất",
    termsAndConditions: "Điều khoản",
    noBooking: "Quý khách chưa có booking nào",
    noOrderBk: "Quý khách chưa có hoặc đã được xác nhận booking",
    hotDealTitle1: "Đặt ngay tee time giá tốt",
    hotDealTitle2: "Sân giá tốt",
    titleTop10Page: "Top 10 sân golf tốt nhất tuần",
    descPageHome: "NHANH CHÓNG - TIỆN LỢI - DỄ DÀNG",
    aboutUs: "Về chúng tôi",
    contact: "Liên hệ",
    quickBookField: "GỬI YÊU CẦU ĐẶT SÂN",
    doNotShareAuthenticationCode:
      "Vui lòng không chia sẻ mã xác thực để tránh mất tài khoản",
    authenticationCodeSentToPhoneNumber:
      "Mã xác thực đã được gửi tới số điện thoại",
    enterAuthenticationCodeBelow: "Nhập mã xác thực vào ô dưới đây",
    pleaseWait: "Vui lòng chờ",
    seconds: "giây",
    toResendNewCode: "để gửi lại mã mới",
    noteCheckMessage: "Lưu ý: kiểm tra tin nhắn để nhận Mã kịp thời",
    authenticationCodeExpired: "Mã xác thực đã hết hạn. Vui lòng Click",
    resend: "Gửi lại",
    toResendCode: "để gửi lại mã.",
    noteCheckMessageAgain: "Lưu ý: kiểm tra tin nhắn để nhận Mã kịp thời",
    bookField: "Đặt sân",
    noTeetimeAvailable:
      "Hiện chưa có teetime ngày này. Quý khách vui lòng chọn ngày khác.",
    downloadApp: "Tải app WGHN",
    all: "Tất cả",
    northern: "Miền Bắc",
    fieldArea: "Khu vực sân",
    priceRange: "Phạm vi giá",
    playTime: "Thời gian chơi",
    servicesAndUtilities: "Dịch vụ & tiện ích",
    lightSnackField: "Sân có ăn nhẹ",
    lightedField: "Sân có đánh đèn",
    crowdedField: "Sân có nhiều người chơi",
    sort: "Sắp xếp",
    default: "Mặc định",
    averagePricePerPax: "Giá trung bình 1 pax",
    priceLowToHigh: "Giá từ thấp đến cao",
    priceHighToLow: "Giá từ cao đến thấp",

    apply: "Áp dụng",
    central: "Miền Trung",
    southern: "Miền Nam",
    evening: "Đèn",
    numberOfPeople: "Số người (*)",
    insuranceRequired: "Có bảo hiểm Hole in One / Eagle",
    timeRequired: "Chọn teetime (*)",
    choosetee: "Chọn teetime",

    searchByField: "Tìm kiếm theo sân",
    waitForConfirmation: "Chờ xác nhận",
    waitForPayment: "Chờ thanh toán",
    ordered: "Đã đặt hàng",
    cancelled: "Đã hủy",
    invoiceInformation: "Thông tin hoá đơn",
    invoiceCode: "Mã hoá đơn:",
    numberOfPaymentServices: "Số dịch vụ thanh toán:",
    booker: "Người đặt:",
    phoneNumber: "Số điện thoại:",
    service: "Dịch vụ",
    quantity: "Số lượng:",
    unpaid: "Chưa thanh toán",
    totalPaymentAmount: "Tổng tiền thanh toán:",
    totalWWalletPoints: "Tổng tích điểm Ví Golf:",
    payment: "Thanh toán",
    support: "Cần hỗ trợ đặt sân,",
    PBX: "TỔNG ĐÀI 0247.100.1088 SẴN SÀNG PHỤC VỤ 24/7",
    viewMore: "Xem thêm",
    shorten: "Rút gọn",
    viewAll: "Xem tất cả",
    numberHolesText: "Số hố",
    totalNumberOfPeople: "Tổng số người",
    describe: "Mô tả",
    addPerson: "Thêm người",
    playerNotFound: "Không tìm thấy người chơi có vID này, vui lòng thử lại !",
    searchByVID: "Theo vID",
    includedServicesAndFees: "Đã bao gồm các dịch vụ và phụ phí",
    electricCarFeeIncluded: "Bao gồm phí xe điện",
    lightMealIncluded: "Bao gồm ăn nhẹ",
    hotelNotIncluded: "Chưa bao gồm khách sạn",
    flightTicketNotIncluded: "Chưa bao gồm vé máy bay",
    iAgreeWith: "Tôi đồng ý với",
    serviceTerms: "điều khoản dịch vụ",
    bookingRequestSentQuickly:
      "Yêu cầu của bạn đã được gửi tới bộ phận kinh doanh của Tổng đài đặt sân golf - wBooking. Chúng tôi sẽ liên hệ với bạn ngay sau đây.",
    bookingRequestSent:
      "Yêu cầu của bạn đã được gửi tới bộ phận kinh doanh của Tổng đài đặt sân golf - wBooking. Chúng tôi sẽ liên hệ với bạn ngay sau đây.",
    fieldName: "Tên sân",
    bookingDate: "Ngày đặt sân",

    playDate: "Ngày chơi",
    numberOfPlayers: "Số lượng người chơi",
    totalAmount: "Tổng tiền",
    thankYouForBooking: "Cảm ơn quý khách đã đặt sân qua wBooking.",
    contactToConfirmBooking:
      "Chúng tôi sẽ liên hệ với quý khách để xác nhận đặt sân này.",
    encounterBookingIssues: "Nếu quý khách gặp vướng mắc khi đặt sân.",
    contactNumber: "Vui lòng liên hệ số: 02471.001.088",
    servicesAndSurchargesAreIncluded: "Đã bao gồm các dịch vụ và phụ phí",
    history: "Lịch sử",
    field: "Chọn sân (*)",
    chooseFacility: "Chọn sân",
    yardDetails: "Chi tiết sân",
    favoritesList: "Danh sách yêu thích",
    superDeal: "Siêu ưu đãi",
    amountToPay: "Số tiền cần thanh toán:",
    billCode: "Mã bill:",
    paymentCode: "Mã thanh toán:",
    addPlayer: "Thêm người chơi",
    orderCode: "Mã đặt sân:",
    orderStatus: "Trạng thái đơn:",
    viewBillDetails: "Xem chi tiết bill",
    billDetails: "Chi tiết bill",
    finishedIn: "Kết thúc trong",
    reserveYourYardNow: "Đặt sân ngay",
    titleContact: "Liên hệ với chúng tôi",
    titleAboutUs: "Giới thiệu về WBooking",
    hole: "hố",
    searchBtn: "Tìm kiếm",
    infoCourse: "Thông tin sân",
    enterNameOrIDToSearch: "Nhập tên, vID để tìm kiếm",
    evaluate: "Đánh giá",
    selectPeopleToAdd: "Chọn người để thêm",
    discount: "Giá ưu đãi",
    areaNorthern: "Sân golf tốt khu vực miền Bắc",
    areaSouth: "Sân golf tốt khu vực miền Nam",
    areaCentral: "Sân golf tốt khu vực miền Trung",
    expired: "Mã đã hết hạn",
    titleTermsAndConditions1: "Điều 1. NGUYÊN TẮC CHUNG",

    contentTermsAndConditions11:
      "1.Trước khi đăng ký sử dụng dịch vụ HIO trên nền tảng Ứng dụng vHandicap, Khách hàng xác nhận đã đọc, hiểu và đồng ý với tất cả các Điều khoản trong Thỏa Thuận Cung Cấp Và Sử Dụng Dịch Vụ HIO này (sau đây gọi tắt là “Thỏa thuận”) thông qua việc đồng ý đăng ký sử dụng dịch vụ HIO, Khách hàng chấp nhận không có bất kỳ giới hạn nào về và/hoặc liên quan tới tất cả các điều khoản và điều kiện dưới đây, kể từ thời điểm đăng ký sử dụng dịch vụ.\n",
    contentTermsAndConditions12:
      "2.Khi tham gia dịch vụ HIO được cung cấp bởi Công ty Cổ phần Dịch Vụ Thể Thao Golf Việt Nam (sau đây gọi tắt là “Chúng tôi” hoặc “VGS SPORT”) trên nền tảng ứng dụng vHandicap, Khách hàng cam kết có đủ tuổi theo luật định để xác lập thỏa thuận có tính ràng buộc, và không phải là người bị ngăn cấm tiếp nhận Dịch vụ theo pháp luật Việt Nam, hoặc đã có sự chấp thuận trước của cha mẹ hoặc người giám hộ hợp pháp để sử dụng Dịch vụ theo quy định và phù hợp với thỏa thuận này.\n",
    contentTermsAndConditions13:
      "3.Chúng tôi có thể chỉnh sửa, cập nhật Thỏa thuận này bất cứ lúc nào mà không cần báo trước. Việc chỉnh sửa này sẽ có hiệu lực ngay khi được cập nhật trên Ứng dụng vHandicap. Khách hàng cần thường xuyên kiểm tra các thay đổi này, và việc khách hàng tiếp tục tham gia dịch vụ này đồng nghĩa với việc đồng ý với các nội dung đã thay đổi đó.",
    titleTermsAndConditions2: "Điều 2. GIẢI THÍCH DỊCH VỤ HIO",
    contentTermsAndConditions21:
      "1.Dịch vụ HIO là Dịch vụ Giải đấu trong môn thể thao Golf, mà ở đó Giải thưởng “Hole-in-One” sẽ được trao cho Người chơi thực hiện thành công đánh bóng xuống lỗ gôn quy định chỉ bằng một (01) cú đánh từ điểm phát bóng (đối với các hố Par3 trên sân gôn trong 1 vòng thi đấu 18 hố gôn) với các giá trị Giải thưởng tùy thuộc vào Dịch vụ HIO mà khách hàng lựa chọn sử dụng.\n",
    contentTermsAndConditions22:
      "2.Giải đấu HIO là Giải đấu Golf được tổ chức bởi Công ty Cổ phần Dịch Vụ Thể Thao Golf Việt Nam mà trong Giải đấu này, khách hàng đã lựa chọn, sử dụng Dịch vụ HIO do Công ty Cổ phần Dịch Vụ Thể Thao Golf Việt Nam cung cấp thông qua ứng dụng vHandicap. Bằng việc đăng ký sử dụng Dịch vụ, khách hàng đồng ý rằng VGS Sport sẽ là đơn vị tổ chức chính thức cho Giải đấu HIO mà khách hàng tham dự.\n",
    contentTermsAndConditions23:
      "3.Giải thưởng HIO chỉ được trao 01 lần/01 khách hàng/01 ngày thi đấu/01 vòng thi đấu 18 hố gôn tiêu chuẩn (Trong trường hợp Khách hàng đánh trúng HIO từ 02 lần trở lên trong 1 ngày thi đấu thì cũng chỉ được nhận 1 lần giải thưởng tương ứng với giá trị Dịch vụ HIO mà khách hàng đã đăng ký).\n",
    contentTermsAndConditions24:
      "4.Trường hợp khách hàng đăng ký tham gia 2 gói dịch vụ HIO cho cùng 1 vòng đấu 18 hố (Gói Bảo Hiểm Theo ngày và gói Hội viên theo năm) khách hàng có thể nhận được đồng thời 2 giải thưởng HIO tương ứng với giá trị giải thưởng của 2 dịch vụ đã đăng ký.",
    search: "TÌM TEE TIME",
    overTeeTime: "Đã hết Tee Time",
    date: "ngày",
    latest: "Gần đây nhất",
    time: "Thời gian",
    filter: "Bộ lọc",
    courseTee: "Tee time sân",
    bookNowBtn: "ĐẶT NGAY",
    bookNow: "Đặt ngay",
    price: "Giá",
    from: "Từ",
    morning: "Sáng",
    afternoon: "Chiều",
    lightHour: "Giờ đèn",
    descTee: "Bao gồm: Green Fee & Caddie Fee & 1/2 Buggy",
    addUser: "Thêm người",
    totalMoney: "Tổng số tiền",
    addUserTee: "Thêm người chơi vào Tee Time",
    listUser: "Danh sách người chơi",
    confirm: "Xác nhận",
    comingSoon: "Ứng dụng đang phát triển",

    notiSendOtp:
      "Quý khách chưa có tài khoản tại WBooking (WGHN). Vui lòng nhập mã OTP vừa được WBooking (WGHN) gửi qua SMS đến Số điện thoại của Quý khách để xác nhận đồng ý mở tài khoản và đồng ý với Điều kiện điều khoản mở tài khoản tại WBooking (WGHN).",
    subSendOtp: "Vui lòng nhập OTP được gửi về số điện thoại của bạn",
    notiSendOtpVGS:
      "Vui lòng nhập mã OTP vừa được WBooking (WGHN) gửi qua SMS đến Số điện thoại của Quý khách để xác thực đăng nhập vào tài khoản của Quý khách tại WBooking (WGHN)",
    fullName: "Họ và tên",
    noData: "Không có dữ liệu",
    pleaseFillInAllInformation: "Vui lòng điền đầy đủ thông tin",
    userVga: "Người chơi có mã vID",
    userOutSystem: "Người chơi ngoài hệ thống",
    note:
      "Lưu ý: Gói BH 20.000.000 VNĐ là khuyến mãi tặng kèm cho tất cả các booking qua WBooking",
    unConfirm: "Chưa xác nhận",
    pay: "Thanh toán",
    paymentGuide: "Hướng dẫn thanh toán",
    bank: "Ngân hàng",
    bookQuicklyToEnsureYouReserveYourSpot:
      "Nhanh tay đặt sân để đảm bảo giữ chỗ",
    content: "Nội dung",
    numberCard: " Số tài khoản",
    amountMoney: "Số tiền",
    accountHolder: "Chủ tài khoản",
    scanQr: "Quét mã QR bằng ứng dụng WGHN",
    unPay: "Chưa thanh toán",
    paid: "Đã thanh toán",
    BookingCode: "Mã đặt chỗ",
    outsideSystem: "Ngoài hệ thống",
    enterFullName: "Nhập họ và tên",
    userBooking: "Người Booking",
    companyName: "CÔNG TY CỔ PHẦN DỊCH VỤ ĐẶT SÂN GOLF WGHN",
    orPay: "Hoặc trả cho từng người",
    payNow: "Thanh toán ngay",
    notify: "Thông báo",
    next: "Đặt sân",
    setUpTheYardQuickly: "Đặt sân nhanh",
    skip: "BỎ QUA",

    notFoundMessage:
      "Chúng tôi không tìm thấy sân. Vui lòng thử lại với sân khác.",
    waitOtpText: "Vui lòng đợi xác nhận OTP",
    paymentReminder:
      "Vui lòng thanh toán trong vòng 30 phút kể từ khi bộ phận của chúng tôi xác nhận đơn",
    enteredOTPConfirmBooking:
      "Quý khách vui lòng nhập mã OTP vừa được WBooking (WGHN) gửi qua SMS đến Số điện thoại của Quý khách để xác nhận giao dịch",
    notiPaymentIn30Minute:
      "Thông tin đặt sân đã được ghi nhận, Quý khách vui lòng chờ WBooking (WGHN) xác nhận và sẽ thông báo tới Quý khách. Vui lòng thanh toán trong vòng 30 phút kể từ khi nhận được thông báo xác nhận.",
    enterOtp: "Vui lòng nhập mã xác nhận vào ô dưới đây",
    notiSuccess:
      "Đặt sân thành công! Vui lòng đợi nhân viên xác nhận booking của bạn.",
    textBookingCourse: "Bạn có chắc chắn muốn đặt sân",
    terrain: "Địa hình sân",
    buyMore: "Mua thêm",
    codeBooking: "Mã Booking",
    bannerContent:
      "Đặt sân, mua sắm, du lịch golf và vô vàn dịch vụ tiện ích khác!",
    bannerSubContent: "Tải app WGHN ngay!",
    bookCourse: "Đặt sân golf",
    shopping: "Mua sắm",
    hio: "Bảo hiểm HIO",
    handee: "Thời trang deHandde",
    for: "cho",
    people: "người",
    at: "vào lúc",
    yes: "Có bảo hiểm Hole in One / Eagle",
    no: "Không bảo hiểm Hole in One / Eagle",
    bookingSwitchboard: "Tổng đài đặt sân golf wBooking",
    suggestions: "Gợi ý cho bạn",
    wap: {
      text1: "Tất cả",
      text2: "Miền Bắc",
      text3: "Miền Trung",
      text4: "Miền Nam",
      text5: "Sáng",
      text6: "Chiều",
      text7: "Đèn",
      text8: "Chờ xác nhận",
      text9: "Chờ thanh toán",
      text10: "Đã thanh toán",
      text11: "Thất bại",
      text12: "Nhập ngày",
      text13: "Nhập địa điểm",
      text14: "Từ ",
      text15: " đánh giá",
      text16: "Nhập ngày",
      text17: "Số người",
      text18: "Sáng",
      text19: "Trưa",
      text20: "Giờ đèn",
      text21: "9 hố",
      text22: "18 hố",
      text23: "27 hố",
      text24: "Số hố",
      text25: "Giá tốt",
      text26: "Trang chủ",
      text27: "Họ tên",
      text28: "Bảo hiểm",
      text29: "Tìm kiếm",
      text30: "Siêu ưu đãi",
      text31: "Đã hủy",
      text32: "Đặt sân",
      text33: "Quý khách chưa có booking nào",
      text34: "Đã thanh toán",
      text35: "Số lượng",
      text36:
        "Vui lòng thanh toán trong vòng 30 phút kể từ khi bộ phận của chúng tôi xác nhận đơn",
      text37: "Thanh toán",
      text38: "Số dư",
      text39: "Số tiền",
      text40: "Số dư ví không đủ để thanh toán",
      text41:
        "Vui lòng nạp thêm tiền vào ví hoặc chọn phương thức thanh toán khác. Xin cảm ơn quý khách!",
      text42: "Đóng",
      text43: "Nạp tiền vào ví Golf",
      text44: "Nhấn giữ và Lưu vào Ảnh",
      text45: "Số tài khoản",
      text46: "Chủ tài khoản",
      text47: "Ngân hàng",
      text48: "Số tiền",
      text49: "Nội dung chuyển khoản",
      text50:
        "(Lưu ý: Bạn phải ghi đúng nội dung chuyển tiền, nếu ghi sai có thể gặp trục trặc hoặc chậm trễ quá trình giao dịch.)",

      text51: "Số dư trên ví của bạn",
      text52: "Nạp tiền vào ví Golf",
      text53: "Lịch sử giao dịch",
      text54: "Điều khoản sử dụng ví Golf",
      text55: "Đơn đặt hàng",
      text56: "Đăng xuất",
      text57: "Ngôn ngữ",
      text58: "Bạn đang đăng nhập bằng vID của wGroup",
      text59: "Xem chi tiết ưu đãi đặc quyền của Hội viên thân thiết",
      text60: "Hạng hội viên",
      text61: "Hoàn điểm trên mỗi đơn hàng",
      text62: "Điểm được hoàn vào ví Gold",
      text63: "(Ngoài hệ thống)",
      text64:
        "Chuyển tiền vào tài khoản Ví Golf của bạn để có số dư chi tiêu cho các dịch vụ của chúng tôi được thuận lợi hơn",
      text65: "Số dư Ví Golf (đ)",
      text66: "Nhập số tiền nạp (đ)",
      text67: "Nhỏ nhất",
      text68: "Tiếp",
      text69: "Số tiền (đ)",
      text70: "Số dư (đ)",
      text71: "Nội dung",
      text72: "Đã hết giao dịch",
      text73: "Đã hết giao dịch",
      text74: "Số dư",
      text75: "Số tiền",
      text76: "Nhấn giữ và Lưu vào Ảnh",
      text77: "Số tài khoản",
      text78: "Chủ tài khoản",
      text79: "Ngân hàng",
      text80: "Số tiền",
      text81: "Nội dung chuyển khoản",
      text82:
        "(Lưu ý: Bạn phải ghi đúng nội dung chuyển tiền, nếu ghi sai có thể gặp trục trặc hoặc chậm trễ quá trình giao dịch.)",
      text83: "Giá tốt",
      text84: "Sân yêu thích",
      text85: "Trang chủ",
      text86: " đánh giá",
      text87: "Nhập ngày",
      text88: "Số người",
      text89: "9 hố",
      text90: "18 hố",
      text91: "27 hố",
      text92: "Giá tốt",
      text93: "Số hố",
      text94: "Từ ",

      text95: "ĐĂNG NHẬP",
      text96: "ĐĂNG XUẤT",
      text97: "Thêm người chơi",
      text98: "Công ty CP dịch vụ đặt sân golf WGHN (wBooking)",
      text99: "Địa chỉ",
      text100: "Số 20 Võ Chí Công, phường Tây Hồ, thành phố Hà Nội.",
      text101: "Miền Trung",
      text102: "368 Trần Hưng Đạo, phường An Hải Tây, quận Sơn Trà, Đà Nẵng",
      text103: "Miền Nam",
      text104:
        "Số 17, Đường số 1, Khu đô thị CityLand Park Hills, Phường Gò Vấp, TP. HCM.",
      text105: "Hệ sinh thái",
      text106: "Liên hệ",
      text107: "Sàn thương mại điện tử WGHN",
      text108: "Sàn thương mại điện tử Handee",

      text109: "Đăng nhập",
      text110: "Sản phẩm",
      text111: "Các sản phẩm của Nam Á Bank",
      text112: "Các sản phẩm của Sacombank",
      text113: "Các sản phẩm của Techcombank",
      text114: "Điều khoản dịch vụ",
      text115: "Chính sách Hội viên thân thiết",
      text116: "Liên hệ",
      text117: "Đã xác nhận",
      text118: "Đã lên đơn",
      text119: "Nhập vào mã xác minh",
      text120: "Dịch vụ Golf",
      text121: "Đã gửi yêu cầu đặt sân nhanh",
      text122: "Chuyển khoản ngân hàng",
      text123: "Số tiền giao dịch tối thiểu",
      text124: "Phương thức thanh toán",
      text125: "Vui lòng nhập số tiền cần nạp.",
      text126: "Nạp tiền vào ví điểm thưởng",
      text127: "Đã sao chép vào clipboard",
      text128: "Lịch sử ví điểm thưởng",
      text129: "Phát sinh phí giao dịch",
      text130: "Ví Golf",
      text131: "Thanh toán thẻ JCB, Mastercard, ... qua cổng EPAY",
      text132: "Thanh toán Sacombank",
      text133: "Tải App WGHN để trải nghiệm tốt hơn",
      text134: "Bảng giá Đặt sân",

      text135: "tại wBooking",
      text136: "Sân Golf",
      text137: "Ngày",
      text138: "Thời gian áp dụng",
      text139: "Khách hàng áp dụng",
      text140: "Giá",
      text141: "Ngày thường",
      text142: "Cuối tuần",
      text143: "KH áp dụng",
      text144: "Ưu đãi đặc biệt",
      text145: "Giá tốt cho bạn",
      text146: "Đặt sân ngay",
      text147: "Sân golf nổi bật",
      text148: "Tin tức",
      text149: "Đừng quên mua bảo hiểm để nhận về 200.000.000đ. Chọn gói",
      text150: "Bảng giá Đặt sân",
      text151: "Nhập vID hoặc số điện thoại hoặc tên",
      text152: "Tên bạn chơi",
      text153: "Mua cho mình bạn",
      text154: "Bạn",
      text155: "và",
      text156: "người khác",
      text157: "Đã đăng ký",
      text158: "Thành tiền",
      text159: "người chơi",

      text160: "Tổng quan",
      text161: "Tên",
      text162: "Chiều dài sân",
      text163: "Tổng số Hole",
      text164: "Thiết kế bởi",
      text165: "Ngày hoạt động",
      text166: "Đường",
      text167: "Số Hole",
      text168: "Số Par",
      text169: "Chọn bảo hiểm",
      text170: "Giá trị bảo hiểm: tối đa",
      text171: "Thêm",
      text172: "Giá dự kiến",
      text173: "Đặt sân thành công.",
      text174: "Bài viết nổi bật",
      text175: "Bảng giá",
      text176: "Đánh giá sân",
      text177: "Mức độ hài lòng",
      text178: "Viết bình luận...",
      text179: "Tạo booking với số điện thoại này",
      text180: "Trạng thái",
      text181: "7 ngày qua",
      text182: "30 ngày qua",
      text183: "Tùy chỉnh",
      text184: "Trả góp và Thanh toán thẻ JCB, Mastercard, ... qua cổng ALEPAY",
      ConfirmRedirectAlePay: "Bạn sẽ được chuyển đến trang thanh toán AlePay. Tiếp tục?",
      ConfirmRedirectEpay: "Bạn sẽ được chuyển đến trang thanh toán Epay. Tiếp tục?",
      Confirm: "Xác nhận",
      back: "Quay lại"
    }
  },
  en: {
    policyObj: {
      text1:
        "The cancellation policy is in accordance with the cancellation policy of each golf course, which is specified in detail in the table below.",
      text2:
        "Each golf course will have regulations on the time allowed for cancellation. If the customer requests to cancel within the time specified by the golf course. We will refund the customer within 02 working days from the time of receiving the customer's valid cancellation request.",
      text3:
        "If the customer books and pays directly on the website, the playing time may have been sold out.",
      text4:
        "Our Company's process: Customer books on the website -> Staff contacts to confirm -> Sales enters information on CMS (to have the booking code and correct information) -> Customer pays.",
      text5:
        "ustomers use 1 of the 2 payment methods below to make payment for the course booking:",
      text6: "1. Bank transfer.",
      text7: `Customers choose this payment method in the payment information section when placing a course booking order on our Platform. Customers
transfer money directly to wBooking's bank account according to the instructions
when choosing this payment method.`,
      text8: `When choosing the payment method by bank transfer, the Customer will make payment according to the following bank account information:`,
      text9: `- Beneficiary account name: WGHN Golf Course Booking Service Joint Stock Company`,
      text10: `- Account number: 888899988`,
      text11: `- Beneficiary bank: Nam A Commercial Joint Stock Bank.`,
      text12: `2. Credit/debit card.`,
      text13: `The Customer chooses this payment method in the payment information section when placing a course booking order on our Platform. After choosing this payment method, the Customer will directly perform the payment steps via the Epay Payment Gateway. When using this payment method, the Customer will have to pay a service fee to the Epay Payment Gateway.`,

      text14: `Service delivery methods and estimated time for service delivery:`,
      text15: `When you successfully book, our staff will receive the information
and contact you to confirm the playing time and price.`,
      text16: `Then, our customer service staff will enter the customer's booking information
into the CMS software, there will be an automatic notification sent to zalo by
phone number or a confirmation call within 1 hour for you to confirm
the information.`,
      text17: `Note.`,
      text18: `In case of delay in
service provision, we will promptly inform the customer
and the customer can choose between canceling or continuing to wait for information
from email.`,

      text19: `Privacy Policy`,
      text20: `Consumer Personal Information Protection Policy`,
      text21: `1. Purpose and scope of information collection`,
      text22: `The Company collects consumer information for the purpose of use
to provide e-commerce services, when users register for an account, the personal information`,
      text23: `Full name`,
      text24: `Email address`,
      text25: `Phone number`,
      text26: `Contact address`,
      text27: `Name and head office address for organizations and enterprises`,
      text28: `Number, date of issue and place of issue of the business registration certificate of
the trader, or number, date of issue and the unit issuing the establishment decision
of the organization, or the personal tax code of the individual.`,
      text29: `Aggregate data on the content used by users.`,
      text30: `Information sent by or related to the device(s) used to access`,
      text31: `2. Scope of information use`,
      text32: `For internal use of the company`,
      text33: `Providing services to Members`,
      text34: `Sending notifications about information exchange activities between members
and the Company`,
      text35: `Providing product information to customers if requested by customers`,
      text36: `Sending marketing and promotional emails about goods sold by us;`,
      text37: `Sending notifications about activities on the website`,
      text38: `Preventing activities that destroy members' user accounts
or activities that impersonate Members;`,
      text39: `Contacting and resolving with members in special cases;`,
      text40: `Not using members' personal information for purposes other than confirmation
and contact related to transactions on the website`,
      text41: `In case of legal requirements`,
      text42: `Responsible for cooperating
in providing members' personal information when requested by judicial agencies including: Procuracy, court, agency police investigation agency related to any illegal behavior of the customer. In addition,
no one has the right to infringe on the personal information of the member`,
      text43: `Information storage time`,
      text44: `For personal information, the Website will only delete this data if
the Customer requests, the Customer requests to send an email to the email
booking@booking.wghn.net;`,
      text45: `Except for the above case, the Member's personal information will be
kept confidential on Booking's server.`,
      text46: `People or organizations that can access personal information`,
      text47: `Subjects that can access the personal information of Customers are in one of the following cases:`,
      text48: `WGHN GOLF COURSE BOOKING SERVICES JOINT STOCK COMPANY`,
      text49: `Partners who have signed a contract to perform a part of the service provided by the Company, these partners will receive information according to the contract agreement (maybe part or all of the information depending on the
terms of the contract) to support users in using the service provided by the Company.`,
      text50: `Address of the unit collecting and managing personal information`,
      text51: `Address: No. 20 Vo Chi Cong, Tay Ho Ward, Hanoi City, Vietnam`,
      text52: `Hotline: 02471001088`,
      text53: `Email: booking@booking.wghn.net`,
      text54: `3. Methods and tools for consumers to access and edit their personal
data on the e-commerce system of the unit collecting
information.`,
      text55: `To edit their personal data on the e-commerce system
the service user logs into his/her account to access the personal page
to update the information that needs to be edited, then saves the information, to
edit personal information.`,
      text56: `Note when members register for an e-commerce account of
Checktee.com`,
      text57: `Members will be responsible for the security and retention of all activities
using the service under their registered name and password. Members are responsible for promptly notifying`,
      text58: `of any unauthorized use, abuse, breach of security, retention of registration names and passwords
when they are violated to take appropriate measures.`,

      text59: `Members do not use the services of,`,

      text60: `for illegal, unreasonable, fraudulent, threatening, illegal information gathering, destructive purposes, creating and spreading viruses that damage the system, configuration, information transmission of the Site`,

      text61: `or use the services of
them for the purpose of speculation, market manipulation, creating fake orders,
offerings, including for the purpose of judging market demand. In case of violation, members must be responsible for their
actions before the law.`,
      text62: `Members are not allowed to act in a way that damages the reputation of the
E-commerce
Site`,
      text63: `in any form such as causing disunity among members by using a second
registered name, through a third party or propagating, disseminating
information that is not beneficial to the reputation of the Website`,
      text64: `4. Commitment to protect customer information:`,
      text65: `When collecting personal information of customers,`,
      text66: `commitment:`,
      text67: `- Do not sell, share or exchange personal information of customers
when collected on the site`,
      text68: `to any other third
party. Except in the following cases:`,
      text69: `Third parties sign a cooperation contract with`,
      text70: `to provide e-commerce services such as: E-wallet providers, payment intermediary service providers.`,
      text71: `At the request of state agencies: Procuracy, court, police agency investigating any violation of the law by the customer.`,
      text72: `When collecting customer information, Booking only uses it to serve the process of providing e-commerce services on Booking. Do not use customer information for any purpose other than providing e-commerce services;`,
      text73: `Members' personal information will be kept confidential on the Booking application's server. Booking will only delete this data if the Customer requests it, the Customer must select the “Delete account” item on the personal page
or send information to the email booking@booking.wghn.net;`,
      text74: `Mechanism for receiving feedback related to the use of personal information
contrary to the announced purpose of collecting information`,
      text75: `When the Customer has grounds to believe that the personal information collected by`,
      text76: `is used
contrary to the announced purpose. Customers complain directly to the
administrator`,
      text77: `through the
following
channels:`,
      text78: `Call the phone number: 02471001088`,
      text79: `Send an email to the address: booking@booking.wghn.net`,
      text80: `Come directly to Handeee's head office or send a letter of feedback,
suggestions to the address: No. 20 Vo Chi Cong, Tay Ho Ward, Hanoi City WGHN GOLF COURSE BOOKING SERVICES JOINT STOCK COMPANY. Address: No. 20 Vo Chi Cong, Tay Ho Ward, Hanoi City, Vietnam.`,
      text81: `5. Process for handling complaints related to the use of personal information contrary to the purpose of collecting information announced by the Checktee.com management board`,
      text82: `Step 1:`,
      text83: `Customer care department receives the complaint.`,
      text84: `Step 2:`,
      text85: `Contact the technical department to check whether the customer information stored on the application server has been
leaked, hacked, or stolen.`,
      text86: `Step 3:`,
      text87: `Report to the General Director - the person
responsible for managing the application and notify the customer within 8 hours of the situation and solution when personal information is used contrary to the purpose of collecting information.`,
      text88: `Step 4:`,
      text89: `For simple cases, arising within the company, Booking will handle and resolve. In case it is beyond Booking's ability and authority, the management board will request the competent police agency to resolve it, and coordinate with the police agency to investigate and resolve it.`,
      text90: `collected includes:`,
      text91: "1. Security commitment.",
      text92: `The card payment system is provided by payment gateway partners ("Payment Gateway Partners") that have been legally licensed to operate in Vietnam. Accordingly, the card payment security standards at the website checkktee.com ensure compliance with industry security standards.`,
      text93: `2. Security regulations.`,
      text94: `2.1. The policy of payment transactions by international and domestic cards (internet banking) ensures compliance with the security standards of the Payment Gateway Partners including: `,
      text95: `- Customer's financial information will be protected throughout the transaction process using SSL (Secure Sockets Layer) protocol. `,
      text96: `- Ensuring payment information data security standards. `,
      text97: `- One-time password (OTP) is sent via SMS to ensure authenticated account access. `,
      text98: `- Principles and regulations on information security in the banking and finance industry according to regulations of the State Bank of Vietnam. `,
      text99: `2.2. Transaction security policy in payment of the website checktee.com applies to Customers: `,
      text100: `- The Company provides token storage utility - only stores the encrypted string provided by the Payment Gateway Partner to the Company. The Company does not directly store customer card information. The security of customer payment card information is performed by the licensed Payment Gateway Partner.`,
      text101: `- For international cards: Customer payment card information that can be used to establish transactions is not stored on the system of the website checktee.com. The Payment Gateway Partner will store and secure it.`,
      text102: `- For international cards: Customer payment card information that can be used to establish transactions is not stored on the system of the website checktee.com. The Payment Gateway Partner will store and secure it.`,
      text103: `- For domestic cards (internet banking), the Company only stores the order code, transaction code and bank name. The Company is committed to ensuring strict implementation of necessary security measures for all payment activities performed on the e-commerce trading floor of the website checktee.com`,
      text104: `Resolve complaints and disputes`,
      text105: `Resolve complaints and disputes mechanism`,
      text106: `Step 1: Receive complaint information:`,
      text107: `Customers can send complaints to wBooking in one of the following ways:`,
      text108: `Call the hotline 02471001088 or email booking@booking.wghn.net`,
      text109: `Customers Provide the following information (phone number, name, playground, playing date and time) and the issue requiring support to resolve the complaint.`,
      text110: `Step 2: Verify information:`,
      text111: `Within 01 day (or sooner if possible), wBooking will verify the complaint information, check, review and notify the relevant parties. `,
      text112: `WBooking will request the Customer to provide evidence related to the complaint content and send the complaint to the Supplier (if any).`,
      text113: `Step 3: Complaint resolution:`,
      text114: `Within 01 day (or sooner if possible), wBooking will contact the Customer and Supplier to resolve the complaint.`,
      text115: `Step 4: Negotiation and mediation:`,
      text116: `If possible, wBooking will support the Customer and Supplier to negotiate and mediate to resolve the dispute within a reasonable time.`,
      text117: `Step 5: Arbitration or Court:`,
      text118: `If negotiation/mediation fails, the dispute will be resolved at a competent Court according to the law.`,
      text119: `Commitment of wBooking:`,
      text120: `WBooking commits to resolve all disputes and complaints on an objective basis, based on agreements and legal regulations in the spirit of ensuring the legitimate rights of Customers.`,
      text121: `Any disputes, complaints or disputes arising from or related to transactions at wBooking will be resolved through negotiation and conciliation between the parties in the spirit of goodwill and mutual benefit. In case it cannot be resolved by negotiation and conciliation, the Parties shall decide to bring the complaint to a competent People's Court for settlement. The Court's decision is the final judgment for the parties to implement.`,
      text122: `Legal basis:`,
      text123: `Law on Consumer Protection 2010, Chapter 4 on Settlement of disputes between consumers and organizations and individuals trading in goods and services.`,
      text124: "General terms and conditions of transaction",
      text125: `I. GENERAL PROVISIONS`,
      text126: `WGHN Golf Course Booking Service Joint Stock Company (wBooking) provides services through the website checktee.com. By accessing, logging in and using the website, the service user (“You” or “User” agrees to these Terms and Conditions, policies related to wBooking’s services and other policies announced on the website from time to time.`,
      text127: `We may modify, add, remove some content of these Terms and Conditions at any time without prior notice. By continuing to log in, access and use the website, using our services, you agree and accept those changes.`,
      text128: `If you use the Services on the website checktee.com to book services for other individuals/organizations that you are legally authorized to perform the request (“End Consumer”), you are obliged to notify these Terms and Conditions to the End Consumer.`,
      text129: `1. Scope of application`,
      text130: `Through the website, We provide online tools for You to search, make requests to use or order products related to golf hours and other products ("Services") with fast, safe and convenient payment methods`,
      text131: `To facilitate You in searching for information, We will display information about golf hours products on the website.`,
      text132: `Your request will be processed and confirmed by Us when You receive a Confirmation Call via the phone number You registered on the website or notified via Zalo OA to Your phone number or notified to Your account on the website.`,
      text133: `2. No guarantee`,
      text134: `We will use professional skills and care in performing the Service. However, We do not confirm and do not guarantee that all information provided is accurate, complete, appropriate and We are not responsible for any errors (including typographical and arrangement errors), obstacles (due to temporary damage, repair or upgrade to the website), confusion, misinformation or failure to deliver information. We will always be responsible for the accuracy, completeness of the relevant information`,
      text135: `If You have a complaint about Our Service, You can contact Our Customer Care department. We will try to find a reasonable solution but do not guarantee a result that meets Your expectations.`,
      text136: `3. Cancellation, change request`,
      text137: `When making a booking for Our Services, You accept and agree to comply with the policies related to that Service including but not limited to: scope of use and provision of the Services, conditions of use, cancellation and change golf course policies. Cancellation and change golf course policies are posted on Our Platform on the cancellation policy information pages, during the process of Your request to use the Services and in the Successful Payment Notification (if any).`,
      text138: `Please note that You may be charged if you cancel, change the service according to the Golf Course's policy and/or You are not entitled to a refund of any pre-paid amount. Some fees or special offers cannot be canceled, refunded or changed. We recommend that You read the cancellation, change Product policies and other policies related to Wbooking Products carefully. If You wish to review, edit or change or cancel a request, please contact Our Customer Care.`,
      text139: `II. PRICES, TAXES, FEES`,
      text140: `1. Product prices`,
      text141: `Product prices may include additional taxes and other charges but in some cases prices may not include taxes and service charges; Users agree that it is their responsibility to verify the total payment cost and the terms and other details when the confirmation notice is sent to Users. The price is displayed in detail so that the User can see the amount to be paid, any additional costs due to the use of credit cards or interbank fees will be charged to the User. If the User has any doubts about the service, the User can contact WBooking's customer service department.`,
      text142: `From time to time We may offer lower prices than the regular price and/or apply other promotional programs. You must comply with certain conditions to participate in the promotion program.`,
      text143: `1. Payment fee`,
      text144: `Payment fee via EPAY payment gateway for domestic international cards issued`,
      text145: `is a successfully recorded CTT Transaction; GTGD: is the total value of successfully recorded CTT Transactions`,
      text146: `3. Cancellation fee, or additional request`,
      text147: `You can cancel your booking request at any time before making payment. However, after you have completed the payment and received the Successful Payment Notice from Us, if you want to cancel, you will not be refunded the Transaction Fee (including the fee calculated as a % of the Transaction value and the fee calculated per Transaction) according to the Supplier's regulations for Transactions using international Cards as payment source. Please read carefully the cancellation policy on our Platform.`,
      text148: `III. PAYMENT BY CREDIT CARD & FRAUD`,
      text149: `1. For payment of bookings made through this Website, your credit card will be charged by Wbooking for the full price at the time of booking and confirmation of the booking (any refunds that may be issued will be subject to the terms of the existing booking). You are required to check your booking details carefully before each booking. Wbooking will process any refunds, if any, within a reasonable time. In order to protect and encrypt your credit card details when they are transmitted to us, we use encryption technology such as PCI DSS (Payment Card Industry Data Security Standard) or Secure Sockets Layer (“SSL”) for our services.`,
      text150: `2. In the event of credit card fraud or unauthorized use of your credit card by another person, it is your responsibility to contact your bank or card issuer immediately upon becoming aware of the fraud or unauthorized use of your credit card. In this case, Wbooking disclaims liability for any credit card fraud or unauthorized use of your credit card by another person, regardless of whether the fraud or unauthorized use is conducted through Wbooking services. Wbooking is not obliged to compensate or refund any payment that is considered to be a result of such fraud. We may consider and agree to compensate you in another form as a way of expressing our goodwill. You may only claim compensation where the booking was made through our secure server and the unauthorised use of your credit card was a result of our absence or negligence and through no fault of your own in using the secure server. We are not liable for fraud or unauthorised use of your credit card where the fraud was made through applications or servers other than ours or the unauthorised use of your credit card was a result of your own negligence or fault. In the event that you suspect any unauthorised booking or fraud has been made on Wbooking, you must contact our Customer Support immediately.`,
      text151: `3. To make a booking, you must be over eighteen (18) years of age and have full legal capacity to make the transaction (or have the authority of your legal guardian). You must use a credit or debit card that you own, issued in your name, and ensure that there are sufficient funds to cover the transaction fees. You are financially responsible for all transactions made on your behalf or on your account.`,
      text152: `4. You must ensure that the details you provide to us are true, correct and accurate. WBooking only accepts credit cards issued in Vietnam. WBooking may add or remove other payment methods at our discretion`,
      text153: `5. In some cases, we may require additional information or verification to validate and confirm the booking, as described in more detail on our Platform. A booking is not confirmed until you have received a confirmation email, and it is possible that the Supplier may implement fraud detection mechanisms during the booking process. If fraud occurs or is determined to have occurred, the booking will no longer exist or automatically become invalid. Wbooking will not be responsible. If you choose not to provide additional information, the booking will not be completed and will become invalid.`,
      text154: `IV. RIGHTS AND RESPONSIBILITIES OF WBOOKING`,
      text155: `1. Rights of the website management board (BQL)`,
      text156: `a. Require partners to perform their rights and obligations in accordance with the content of the Service Provision Contract on the checktee.com website as well as the WBooking Operating Regulations published on the website: Checktee.com`,
      text157: `b. Checktee.com may terminate the right to use one or all of the services of the partner; customer and will notify the partner; customer within at least one (01) month in case the partner; customer violates the Regulations of the Website providing checktee.com services or has behaviors that affect business activities on checktee.com`,
      text158: `c. Checktee.com may immediately terminate the right to use the service and membership rights of the partner; customer if the Checktee.com Website discovers that the partner; customer has been convicted or is serving a sentence, in case the partner; Customers who continue to operate may cause the Checktee.com Website to be legally liable, to have fraudulent, counterfeit activities, to disrupt the market, to cause disunity among partners; other customers of the Checktee.com Website, activities that violate the current laws of Vietnam.`,
      text159: `d. Checktee.com reserves the right to use the services and content on the Checktee.com Website according to the legal regulations on intellectual property protection in Vietnam. All symbols and content in different languages ​​are owned by the Checktee.com Website. Any act of copying, using and illegally disseminating the above ownership rights is strictly prohibited.`,
      text160: `2. Responsibility:`,
      text161: `a. Checktee.com is responsible for developing and implementing an “Inspection and Supervision Mechanism” to ensure that the provision of information on the Checktee.com Website is carried out accurately and completely.`,
      text162: `b. Provide complete, accurate and timely customer information to partners to be able to provide services.`,
      text163: `c. Checktee.com will take timely measures when detecting or receiving feedback on illegal business activities on the website and will support state management agencies in investigating illegal business activities, providing registration information, transaction history and other documents about subjects with illegal behavior on the Checktee.com Website`,
      text164: `d. Checktee.com will be responsible for publicly announcing the mechanism for resolving disputes arising during transactions on the Checktee.com Website. When customers on the Checktee.com website have conflicts with sellers (partners) or damage their legitimate interests. Checktee.com will provide customers with information about sellers (partners), actively support customers to protect their legitimate rights and interests.`,
      text165: `e. Checktee.com is responsible for preventing and removing from the website information providing services that are not in accordance with the provisions of law.`,
      text166: `f. Checktee.com is responsible for building the website, including a number of main tasks such as: Research, design, purchase of hardware and software equipment, Internet connection, building policies to serve the operation of the Checktee.com website under the permitted conditions and scope. Checktee.com website will deploy and cooperate with partners in building a system of services and utility tools to serve the transactions of participating partners and users on the Checktee.com website.`,
      text167: `g. Checktee.com is responsible for receiving feedback from partners; customers if there is a dispute. The Board of Directors will consider reviewing those feedbacks. Depending on the level, Checktee.com website will have a plan to protect the rights of members.`,
      text168: `h. Checktee.com will try its best within its scope and conditions to maintain the normal operation of the Checktee.com website and fix problems such as: technical problems with machinery, software errors, internet transmission systems, personnel, social fluctuations, natural disasters, power outages, decisions of state agencies or a third party related organization. However, if the above incidents occur beyond control, are force majeure events that cause damage to members, the Checktee.com Website is not jointly responsible.`,
      text169: `V. RIGHTS AND RESPONSIBILITIES OF CUSTOMERS (BUYERS, SERVICE USERS...) ON THE CHECKTEE.COM WEBSITE`,
      text170: `1. Rights of Customers`,
      text171: `a. Right to Information: Customers have the right to be provided with complete and accurate information about products/services including price, quality, features, transaction conditions, return and warranty policies.`,
      text172: `b. Right to Information Confidentiality: Have the right to have personal information protected and not disclosed without consent, unless otherwise provided by law.`,
      text173: `c. Right to Protection: Be protected from poor quality, fraudulent products and services that harm rights and health.`,
      text174: `d. Right to Complain and Dispute Resolution: Have the right to complain and request dispute resolution if the product/service does not meet requirements or is not as described.`,
      text175: `e. Right to Support: Have the right to receive support from the website management regarding product information, instructions for use and answers to questions.`,
      text176: `2. Customer Responsibilities`,
      text177: `a. Providing Accurate Information: Providing accurate and complete personal and payment information when registering and making transactions on the website.`,
      text178: `b. Compliance with Transaction Regulations: Comply with the terms and conditions of transactions announced on the website when using the service.`,
      text179: `c. Account Security: Keep account information and password confidential, do not share with others to avoid fraud and loss of personal information.`,
      text180: `d. Responsible Use of Services: Use the service responsibly, do not use it for illegal purposes, harm the system or the rights of others.`,
      text181: `e. Payment on Time: Make payment on time and in full as prescribed when purchasing products/services.`,
      text182: `f. Feedback and Suggestions: Provide feedback and suggestions to improve the quality of services and products of the website.`
    },
    notiRegistered:
      "Customer has registered account with this phone number, Please login!",
    skipLower: "Skip",
    register: "Register",
    create_acc: "Create an account",
    regDone: "Registration successful",
    update: "Update",
    welcomeWg: "Welcome to wGroup",
    yourVid: "Your vID is",
    pleaseUpdate:
      "Please update your personal information to protect your account",
    whenJoinWg:
      "When joining WGHN, you have the opportunity to receive many special offers",
    seeDetail: "See details",
    here: "here",
    birth: "Date of birth",
    emailAddress: "Email address",
    updateInfoUser: "Update personal information",
    infoUpdateDone: "Information has been updated successfully.",
    thankYour:
      "Thank you for trusting and using wGroup's services. For any questions, please contact 024.7100.1088 or chat with customer service. Download the WGHN app now to not miss out on special offers for members. Sincerely!",
    captcha: "Enter captcha code",
    phoneNumber2: "Phone Number",
    needCancel:
      "If you need to CANCEL, please contact the hotline: 02471.001.088",
    rechargePoints: "Recharge Golf wallet",
    paymentMethod: "Payment method",
    order: "Order",
    and: "and",
    enterBook:
      "By clicking 'Book Now' you agree that your personal information will be used to process your order, enhance your website experience, and for other specific purposes described in",
    out: "của chúng tôi",
    enterPay: "Clicking 'Checkout' means you agree to abide by",
    personalInformationPolicy: "Personal information collection policy",

    termsTransaction: "Terms of transaction",
    complaints: "Complaints and Dispute Resolution Mechanism",

    cusInfoSecurityPolicy: "Customer information security policy",
    paymentInfoSecurityPolicy: "Payment information security policy",
    accountInfo: "Account information",
    accountSettings: "Account settings",
    account: "Account",
    cancellationPolicy: "Cancellation policy",
    privacyPolicy: "Privacy Policy",
    deliveryPolicy: "Delivery policy",
    payPolicy: "Payment policy",
    policy: "Policy",
    branchAddress: "Branch address",
    certificate:
      "Business Registration Certificate: 0109147466. First issued on March 27, 2020. Issuing agency: Hanoi Department of Planning and Investment.",
    introduce: "Introduce",
    bookingReqSend: "Booking request sent",
    yard: "Yard",
    suggestions: "Suggestions for you",
    noti:
      "Please provide your information to receive an estimated quote for the golf booking service",
    noti1: "Thank you. The estimated price for the golf booking service is: ",
    noti2:
      " VND per person. Please send a booking request for an accurate quote and to enjoy the benefits of wGroup and our partners.",
    typeInsurance: "Select HIO package",
    typeInsuranceAll: "Select HIO package for the entire booking",
    titleHeader: "Book a field",
    titleMenuArea: "Select by area",
    titleHotDeal: "Hot deal",
    nearestDate: "Nearest date",
    incorrectCode: "Incorrect code, please try again.",
    farthestDate: "Filter by date",
    titleTop10: "Top 10 best fields",
    login: "Login",
    logout: "Logout",
    termsAndConditions: "Terms and conditions",
    noBooking: "You have no booking yet",
    noOrderBk: "You do not have or have confirmed booking",
    hotDealTitle1: "Book the best tee time now",
    hotDealTitle2: "Best-priced fields",
    titleTop10Page: "Top 10 best golf fields of the week",
    descPageHome: "FAST - CONVENIENT - EASY",
    aboutUs: "About us",
    contact: "Contact",
    quickBookField: "SEND REQUEST",
    doNotShareAuthenticationCode:
      "Please do not share the authentication code to avoid losing your account",
    authenticationCodeSentToPhoneNumber:
      "Authentication code has been sent to the phone number",
    enterAuthenticationCodeBelow: "Enter the authentication code below",
    pleaseWait: "Please wait",
    seconds: "seconds",
    toResendNewCode: "to resend a new code",
    noteCheckMessage: "Note: check your messages to receive the code in time",
    authenticationCodeExpired: "Authentication code has expired. Please click",
    resend: "Resend",
    toResendCode: "to resend the code.",
    noteCheckMessageAgain:
      "Note: check your messages to receive the code in time",
    bookField: "Book a field",
    noTeetimeAvailable:
      "No tee time available for this date. Please choose another date.",
    downloadApp: "Download WGHN app",
    all: "All",
    northern: "Northern",
    fieldArea: "Field area",
    priceRange: "Price range",
    playTime: "Play time",
    servicesAndUtilities: "Services & utilities",
    lightSnackField: "Field with light snacks",
    lightedField: "Field with lighting",
    crowdedField: "Crowded field",
    sort: "Sort",
    default: "Default",
    averagePricePerPax: "Average price per pax",
    priceLowToHigh: "Price low to high",
    priceHighToLow: "Price high to low",

    apply: "Apply",
    central: "Central",
    southern: "Southern",
    evening: "Lighting",
    numberOfPeople: "Number of people (*)",
    insuranceRequired: "Hole in One / Eagle insurance available",
    timeRequired: "Select tee time (*)",
    choosetee: "Select tee time",

    searchByField: "Search by field",
    waitForConfirmation: "Waiting for confirmation",
    waitForPayment: "Waiting for payment",
    ordered: "Ordered",
    cancelled: "Cancelled",
    invoiceInformation: "Invoice information",
    invoiceCode: "Invoice code:",
    numberOfPaymentServices: "Number of payment services:",
    booker: "Booker:",
    phoneNumber: "Phone number:",
    service: "Service",
    quantity: "Quantity:",
    unpaid: "Unpaid",
    totalPaymentAmount: "Total payment amount:",
    totalWWalletPoints: "Golf Wallet Points Total:",
    payment: "Payment",
    support: "Need support booking a field,",
    PBX: "HOTLINE 0247.100.1088 AVAILABLE 24/7",
    viewMore: "View more",
    shorten: "Shorten",
    viewAll: "View all",
    numberHolesText: "Number of holes",
    totalNumberOfPeople: "Total number of people",
    describe: "Description",
    addPerson: "Add person",
    playerNotFound: "Player with this vID not found, please try again!",
    searchByVID: "Search by vID",
    includedServicesAndFees: "Included services and fees",
    electricCarFeeIncluded: "Electric car fee included",
    lightMealIncluded: "Light meal included",
    hotelNotIncluded: "Hotel not included",
    flightTicketNotIncluded: "Flight ticket not included",
    iAgreeWith: "I agree with",
    serviceTerms: "service terms",
    bookingRequestSentQuickly:
      "Your request has been sent to the business department of the golf course booking hotline - wBooking. We will contact you shortly.",
    bookingRequestSent:
      "Your request has been sent to the business department of the golf course booking hotline - wBooking. We will contact you shortly.",
    fieldName: "Field name",
    bookingDate: "Booking date",

    playDate: "Play date",
    numberOfPlayers: "Number of players",
    totalAmount: "Total amount",
    thankYouForBooking: "Thank you for booking through wBooking.",
    contactToConfirmBooking: "We will contact you to confirm this booking.",
    encounterBookingIssues: "If you encounter any issues while booking.",
    contactNumber: "Please contact us at: 02471.001.088",
    servicesAndSurchargesAreIncluded: "Services and surcharges are included",
    history: "History",
    field: "Select field (*)",
    chooseFacility: "Select field",
    yardDetails: "Yard details",
    favoritesList: "Favorites list",
    superDeal: "Super deal",
    amountToPay: "Amount to pay:",
    billCode: "Bill code:",
    paymentCode: "Payment code:",
    addPlayer: "Add player",
    orderStatus: "Order status:",
    orderCode: "Booking code:",

    viewBillDetails: "View bill details",
    billDetails: "Bill details",
    finishedIn: "Finished in",
    reserveYourYardNow: "Reserve your yard now",
    titleContact: "Contact us",
    titleAboutUs: "About WBooking",
    hole: "Hole",
    searchBtn: "Search",
    infoCourse: "Course information",
    enterNameOrIDToSearch: "Enter name or vID to search",
    evaluate: "Evaluate",
    selectPeopleToAdd: "Select people to add",
    discount: "Discount",
    areaNorthern: "Best golf courses in the Northern area",
    areaSouth: "Best golf courses in the Southern area",
    areaCentral: "Best golf courses in the Central area",
    expired: "Code has expired",
    titleTermsAndConditions1: "Article 1. GENERAL PRINCIPLES",

    contentTermsAndConditions11:
      "1. Before registering to use the HIO service on the vHandicap application platform, the Customer confirms that they have read, understood, and agreed to all the terms in this Provision and Use of HIO Service Agreement (hereinafter referred to as the “Agreement”) by agreeing to register to use the HIO service. The Customer accepts that there are no limitations on and/or related to all the terms and conditions below from the time of registration to use the service.\n",
    contentTermsAndConditions12:
      "2. When participating in the HIO service provided by Vietnam Golf Sports Services Joint Stock Company (hereinafter referred to as “We” or “VGS SPORT”) on the vHandicap application platform, the Customer commits to being of sufficient legal age to establish a binding agreement and is not prohibited from receiving the Service under Vietnamese law or has obtained prior consent from a parent or legal guardian to use the Service as stipulated and in compliance with this agreement.\n",
    contentTermsAndConditions13:
      "3. We may amend or update this Agreement at any time without prior notice. Such amendments will take effect immediately upon being updated on the vHandicap Application. Customers need to regularly check these changes, and their continued participation in this service means agreeing to the changed content.",
    titleTermsAndConditions2: "Article 2. EXPLANATION OF HIO SERVICE",
    contentTermsAndConditions21:
      "1. The HIO service is a Tournament Service in the sport of Golf, where a “Hole-in-One” Prize will be awarded to a Player who successfully sinks the ball into the specified hole with only one (01) shot from the tee (for Par 3 holes on the golf course in an 18-hole round) with prize values depending on the HIO Service that the customer chooses to use.\n",
    contentTermsAndConditions22:
      "2. The HIO Tournament is a Golf Tournament organized by Vietnam Golf Sports Services Joint Stock Company, in which customers have chosen to use the HIO Service provided by Vietnam Golf Sports Services Joint Stock Company through the vHandicap application. By registering to use the Service, the customer agrees that VGS Sport will be the official organizer for the HIO Tournament that the customer participates in.\n",
    contentTermsAndConditions23:
      "3. The HIO Prize is awarded only once per customer per day of play per 18-hole standard round (In the case that the Customer hits HIO more than 02 times in 1 day of play, they will only receive the prize once corresponding to the value of the HIO Service that the customer has registered).\n",
    contentTermsAndConditions24:
      "4. If the customer registers to participate in 2 HIO service packages for the same 18-hole round (Daily Insurance Package and Annual Membership Package), the customer may receive 2 HIO prizes corresponding to the prize value of the 2 services registered.",
    search: "FIND TEE TIME",
    overTeeTime: "No Tee Time available",
    date: "Date",
    latest: "Latest",
    time: "Time",
    filter: "Filter",
    courseTee: "Course Tee time",
    bookNowBtn: "BOOK NOW",
    bookNow: "Book now",

    price: "Price",
    from: "From",
    morning: "Morning",
    afternoon: "Afternoon",
    lightHour: "Lighting hour",
    descTee: "Includes: Green Fee & Caddie Fee & 1/2 Buggy",
    addUser: "Add user",
    totalMoney: "Total amount",
    addUserTee: "Add player to Tee Time",
    listUser: "Player list",
    confirm: "Confirm",
    comingSoon: "Application under development",

    notiSendOtp:
      "You do not have an account at WBooking (WGHN). Please enter the OTP code that was sent via SMS to your phone number by WBooking (WGHN) to confirm your agreement to open an account and agree to the terms and conditions for opening an account at WBooking (WGHN).",
    subSendOtp: "Please enter the OTP sent to your phone number",
    notiSendOtpVGS:
      "Please enter the OTP code that was sent via SMS to your phone number by WBooking (WGHN) to authenticate your login to your account at WBooking (WGHN).",
    fullName: "Full name",
    noData: "No data",
    pleaseFillInAllInformation: "Please fill in all the information",
    userVga: "Player with vID",
    userOutSystem: "Player outside the system",
    note:
      "Note: The 20,000,000 VND insurance package is a promotional gift for all bookings through WBooking.",
    unConfirm: "Unconfirmed",
    pay: "Pay",
    paymentGuide: "Payment guide",
    bank: "Bank",
    bookQuicklyToEnsureYouReserveYourSpot:
      "Book quickly to ensure you reserve your spot",
    content: "Content",
    numberCard: "Account number",
    amountMoney: "Amount of money",
    accountHolder: "Account holder",
    scanQr: "Scan QR code using the WGHN app",
    unPay: "Unpaid",
    paid: "Paid",
    BookingCode: "Booking code",
    outsideSystem: "Outside the system",
    enterFullName: "Enter full name",
    userBooking: "User Booking",
    companyName: "GOLF BOOKING SERVICES JOINT STOCK COMPANY WGHN",
    orPay: "Or pay for each person",
    payNow: "Pay now",
    notify: "Notify",
    next: "Book a field",
    setUpTheYardQuickly: "Quickly book a field",
    skip: "SKIP",

    notFoundMessage:
      "We couldn't find the course. Please try again with a different course.",
    waitOtpText: "Please wait for OTP confirmation",
    paymentReminder:
      "Please make payment within 30 minutes after our department confirms the order.",
    enteredOTPConfirmBooking:
      "Please enter the OTP code that was sent via SMS to your phone number by WBooking (WGHN) to confirm the transaction.",
    notiPaymentIn30Minute:
      "The booking information has been recorded. Please wait for WBooking (WGHN) to confirm and notify you. Please make payment within 30 minutes after receiving the confirmation notice.",
    enterOtp: "Please enter the confirmation code in the box below",
    notiSuccess:
      "Booking successful! Please wait for staff to confirm your booking.",
    textBookingCourse: "Are you sure you want to book the course?",
    terrain: "Course terrain",
    buyMore: "Buy more",
    codeBooking: "Booking code",
    bannerContent:
      "Book courses, shop, travel for golf, and enjoy many other convenient services!",
    bannerSubContent: "Download the WGHN app now!",
    bookCourse: "Book a golf course",
    shopping: "Shopping",
    hio: "HIO Insurance",
    handee: "deHandde Fashion",
    for: "for",
    people: "people",
    at: "at",
    yes: "Hole in One / Eagle Insurance",
    no: "No Hole in One / Eagle insurance",
    bookingSwitchboard: "wBooking Golf Course Booking Hotline",

    wap: {
      text1: "All",
      text2: "North",
      text3: "Central",
      text4: "South",
      text5: "Morning",
      text6: "Afternoon",
      text7: "Light",
      text8: "Waiting for confirmation",
      text9: "Awaiting payment",
      text10: "Paid",
      text11: "Failed",
      text12: "Enter date",
      text13: "Enter location",
      text14: "From ",
      text15: " review",
      text16: "Enter date",
      text17: "Number of people",
      text18: "Morning",
      text19: "Noon",
      text20: "Light time",
      text21: "9 holes",
      text22: "18 holes",
      text23: "27 holes",
      text24: "Number of holes",
      text25: "Best price",
      text26: "Home",
      text27: "Full name",
      text28: "Insurance",
      text29: "Search",
      text30: "Super deals",
      text31: "Canceled",
      text32: "Book course",
      text33: "You have no bookings",
      text34: "Paid",
      text35: "Quantity",
      text36:
        "Please make the payment within 30 minutes after our team confirms the order",
      text37: "Payment",
      text38: "Balance",
      text39: "Amount",
      text40: "Wallet balance is not enough for payment",
      text41:
        "Please top up your wallet or choose another payment method. Thank you!",
      text42: "Close",
      text43: "Top up wallet",
      text44: "Press and hold to Save to Photos",
      text45: "Account number",
      text46: "Account holder",
      text47: "Bank",
      text48: "Amount",
      text49: "Transfer details",
      text50:
        "(Note: You must enter the correct transfer details, incorrect details may cause issues or delays in the transaction process.)",

      text51: "Your wallet balance",
      text52: "Top up wallet",
      text53: "Transaction history",
      text54: "Wallet terms of use",
      text55: "Order",
      text56: "Log out",
      text57: "Language",
      text58: "You are logged in with wGroup's vID",
      text59: "View details of exclusive offers for Loyal Members",
      text60: "Membership tier",
      text61: "Earn points on every order",
      text62: "Points are returned to Gold wallet",
      text63: "(Outside the system)",
      text64:
        "Transfer money to your Golf Wallet account to have a balance to spend on our services more conveniently",
      text65: "Golf wallet balance (₫)",
      text66: "Enter top-up amount (₫)",
      text67: "Minimum",
      text68: "Next",
      text69: "Amount (₫)",
      text70: "Balance (₫)",
      text71: "Content",
      text72: "No more transactions",
      text73: "No more transactions",
      text74: "Balance",
      text75: "Amount",
      text76: "Press and hold to Save to Photos",
      text77: "Account number",
      text78: "Account holder",
      text79: "Bank",
      text80: "Amount",
      text81: "Transfer details",
      text82:
        "(Note: You must enter the correct transfer details, incorrect details may cause issues or delays in the transaction process.)",
      text83: "Best price",
      text84: "Favorite course",
      text85: "Home",
      text86: " review",
      text87: "Enter date",
      text88: "Number of people",
      text89: "9 holes",
      text90: "18 holes",
      text91: "27 holes",
      text92: "Best price",
      text93: "Number of holes",
      text94: "From ",

      text95: "LOGIN",
      text96: "LOGOUT",
      text97: "Add player",
      text98: "WGHN Golf Course Booking Service JSC (wBooking)",
      text99: "Address",
      text100: "No. 20 Vo Chi Cong, Tay Ho Ward, Hanoi City.",
      text101: "Central",
      text102: "368 Tran Hung Dao, An Hai Tay Ward, Son Tra District, Da Nang",
      text103: "South",
      text104: "377 Tan Son, Ward 14, Tan Binh District, Ho Chi Minh City.",
      text105: "Ecosystem",
      text106: "Contact",
      text107: "WGHN E-commerce platform",
      text108: "Handee E-commerce platform",

      text109: "Login",
      text110: "Products",
      text111: "Products of Nam A Bank",
      text112: "Products of Sacombank",
      text113: "Products of Techcombank",
      text114: "Terms of Service",
      text115: "Loyalty Member Policy",
      text116: "Contact",
      text117: "Confirmed",
      text118: "Ordered",
      text119: "Enter verification code",
      text120: "Golf Services",
      text121: "Booking request sent",
      text122: "Bank transfer",
      text123: "Minimum transaction amount",
      text124: "Payment method",
      text125: "Please enter the amount to deposit.",
      text126: "Top up reward points wallet",
      text127: "Copied to clipboard",
      text128: "Reward points wallet history",
      text129: "Transaction fee applied",
      text130: "Golf wallet",
      text131: "Card Payment (JCB, Mastercard, …) via EPAY",
      text132: "Sacombank Pay",
      text133: "Download WGHN App for better experience",
      text134: "Price List for Golf Course Booking",
      text135: "at wBooking",
      text136: "Golf Course",
      text137: "Date",
      text138: "Applicable Time",
      text139: "Applicable Customers",
      text140: "Price",
      text141: "Weekdays",
      text142: "Weekends",
      text143: "Applicable customers",
      text144: "Special offer",
      text145: "Good price for you",
      text146: "Book the course now",
      text147: "Featured golf course",
      text148: "News",
      text149:
        "Don't forget to buy insurance to receive 200,000,000 VND. Choose a package",
      text150: "Price list Book the course",
      text151: "Enter ID or phone number or name",
      text152: "Player's name",
      text153: "Buy for yourself",
      text154: "You",
      text155: "and",
      text156: "others",
      text157: "Registered",
      text158: "Total",
      text159: "player",

      text160: "Overview",
      text161: "Name",
      text162: "Afternoon Course length",
      text163: "Total Holes",
      text164: "Designed by",
      text165: "Operation Date",
      text166: "Road",
      text167: "Number of Holes",
      text168: "Number of Pars",
      text169: "Select Insurance",
      text170: "Insurance Value: Maximum",
      text171: "Add",
      text172: "Estimated Price",
      text173: "Booking Successfully.",
      text174: "Featured Article",
      text175: "Price List",
      text176: "Course Review",
      text177: "Satisfaction Level",
      text178: "Write a Review...",
      text179: "Create Booking with This Phone Number",
      text180: "Status",
      text181: "Last 7 Days",
      text182: "Last 30 Days",
      text183: "Customize",
      text184: "Installment & Card Payment (JCB, Mastercard, …) via ALEPAY",
      ConfirmRedirectAlePay:
        "You will be redirected to the AlePay payment page. Continue?",
      ConfirmRedirectEpay:
        "You will be redirected to the Epay payment page. Continue?",
      Confirm: "Confirm",
      back: "Back"
    }
  },
  kr: {
    policyObj: {
      text1:
        "취소 정책은 각 골프장의 취소 정책을 따르며, 아래 표에 자세히 나와 있습니다.",
      text2:
        "각 골프장에는 취소 허용 시간에 대한 규정이 있습니다. 고객이 골프장이 지정한 시간 내에 취소를 요청하는 경우 고객의 유효한 취소 요청을 접수한 날로부터 2영업일 이내에 고객에게 환불해드립니다.",
      text3: `고객이 웹사이트에서 직접 예약하고 결제하면 플레이할 수 있습니다.
 그것은 사라졌다`,
      text4: `당사 프로세스 : 홈페이지 고객주문 -> 직원
 직원에게 연락하여 확인 -> 영업팀이 CMS에 정보를 입력합니다(예약 코드와 정확한 정보를 입력하기 위해) -> 고객이 결제를 진행합니다.`,
      text5:
        "고객은 현장 보증금을 지불하기 위해 아래 2가지 결제 방법 중 하나를 사용합니다.",
      text6: "1. 이전.",
      text7: `고객은 결제 정보 섹션에서 해당 결제 방법을 선택합니다.
 당사 플랫폼에서 예약을 할 때 결제합니다. 고객
 wBooking의 은행 계좌로 직접 이체하세요
 이 결제 방법을 선택할 때의 지침입니다.`,
      text8: `고객이 은행 송금 결제 방법을 선택한 경우,
 현재 은행 송금 계좌번호 정보에 따라 다음과 같이 결제가 진행됩니다.
 후에:`,
      text9: `- 수혜자 계좌명 : WGHN 골프장 예약 서비스 주식회사`,
      text10: `- 계좌번호 : 888899988`,
      text11: `- 수혜은행 : 남아상업주식은행.`,
      text12: `2. 신용/직불 카드.`,
      text13: `고객은 결제 정보 섹션에서 해당 결제 방법을 선택합니다.
 당사 플랫폼에서 예약을 할 때 결제합니다. 선택 후
 이 결제 방식을 사용하면 고객은 다음 단계를 직접 수행합니다.
 Epay 결제 게이트웨이를 통한 결제. 결제방법 이용시
 이 경우 고객은 Epay 결제 게이트웨이에 서비스 수수료를 지불해야 합니다.`,

      text14: `서비스 제공 방법 및 서비스 제공 예상 시간:`,
      text15: `주문이 성공적으로 완료되면 당사 직원이 해당 정보를 받게 됩니다.
 다시 연락해서 경기 시간과 가격을 확인해 주세요.`,
      text16: `그러면, 당사 고객 서비스 직원이 현장 예약 정보를 입력해 드립니다.
 고객의 CMS 소프트웨어에 대한 자동 알림이 zalo에 전송됩니다.
 1시간 이내에 전화번호 또는 확인 전화를 주시면 확인해드립니다.
 정보.`,
      text17: `메모.`,
      text18: `지연이 발생하는 경우
 우리는 서비스 제공에 관한 사항을 고객에게 즉시 알려드리겠습니다.
 고객은 취소할지 아니면 알림을 기다릴지 선택할 수 있습니다.
 이메일에서 온 메시지`,

      text19: `개인정보 보호정책`,
      text20: `소비자 개인정보보호정책`,
      text21: `1. 정보 수집 목적 및 범위`,
      text22: `회사는 이용 목적으로 소비자 정보를 수집합니다.
              사용자가 계정을 등록할 때 전자상거래 서비스를 제공하기 위해
              계정, 개인 정보`,
      text23: `성명`,
      text24: `이메일 주소`,
      text25: `전화번호`,
      text26: `연락처`,
      text27: `단체 및 사업체의 명칭 및 본사 주소`,
      text28: `사업자등록증 번호, ​​발급일자 및 발급장소
 거래자 또는 번호, 발행일 및 설립결정을 발행한 단위
 조직의 사업자등록번호 또는 개인의 개인 세금 식별 번호입니다.`,
      text29: `사용자가 사용하는 콘텐츠에 대한 데이터를 집계합니다.`,
      text30: `사용된 기기에서 전송되거나 관련된 정보
 접근하는 데 사용`,
      text31: `2. 정보이용의 범위`,
      text32: `회사 내부용`,
      text33: `회원에게 서비스 제공`,
      text34: `회원간 정보교환 활동에 대한 알림을 보냅니다.
 회원 및 회사`,
      text35: `고객의 요청에 따라 제품 정보를 제공합니다. 고객`,
      text36: `당사가 판매하는 제품에 대한 마케팅 및 홍보 이메일을 보냅니다;`,
      text37: `웹사이트 활동에 대한 알림 보내기`,
      text38: `회원의 사용자 계정을 파괴하는 활동 방지
 회원 또는 회원을 사칭하는 기타 활동;`,
      text39: `특별한 경우 회원과의 접촉 및 해결
 특별한;`,
      text40: `회원의 개인정보는 식별 목적 이외의 목적으로 이용되지 않습니다.
 웹사이트 거래와 관련된 정보를 수신하고 연락합니다.`,
      text41: `법적 요구 사항이 있는 경우`,
      text42: `책임 있는 협력
 사법기관의 요청에 따라 회원 개인정보를 제공합니다.
 이 법률에는 검찰청, 법원 및 관련 경찰 수사 기관이 포함됩니다.
 고객의 불법 행위에 대하여. 게다가,
 누구도 회원의 개인정보를 침해할 권리가 없습니다.`,
      text43: `정보 저장 시간`,
      text44: `개인정보의 경우 웹사이트는 다음의 경우에만 이 데이터를 삭제합니다.
 고객이 요청하는 사항, 고객이 이메일을 보내달라고 요청하는 사항
 예약@booking.wghn.net
- 위의 경우를 제외하고 회원의 개인정보는 보호됩니다.
 Booking 서버의 비밀입니다;`,
      text45: `위의 경우를 제외하고 회원의 개인정보는 보호됩니다.
 Booking 서버의 비밀입니다.`,
      text46: `개인정보에 접근할 수 있는 사람이나 조직`,
      text47: `고객의 개인정보에 접근하는 주체는 다음 각 호에 속합니다.
 다음의 경우:`,
      text48: `WGHN 골프장 예약 서비스 주식회사`,
      text49: `회사가 제공하는 서비스 중 일부를 수행하기 위해 계약을 체결한 파트너.
 이러한 파트너는 계약에 따라 정보를 받게 됩니다.
 계약 동의서 (조건에 따라 일부 또는 전체 정보가 될 수 있음)
 사용자가 제공하는 서비스를 사용할 수 있도록 지원하기 위한 계약)
 회사가 제공함.`,
      text50: `개인정보 수집·관리 기관의 주소`,
      text51: `주소: 베트남 하노이시 떠이호구 보찌콩 20번지`,
      text52: `핫라인 : 02471001088`,
      text53: `이메일: booking@booking.wghn.net`,
      text54: `3. 소비자가 데이터에 접근하고 편집할 수 있는 방법 및 도구
 수집 단위의 전자 상거래 시스템에 대한 개인 데이터
 정보를 수집하다.`,
      text55: `전자상거래 시스템에서 귀하의 개인 데이터를 편집하려면
 서비스 사용자는 자신의 계정에 로그인하여 개인 페이지에 접속합니다.
 편집해야 할 정보를 업데이트한 다음 정보를 저장합니다.
 개인 정보 수정.`,
      text56: `회원이 전자상거래 계정을 등록할 때 참고사항
 체크티닷컴`,
      text57: `회원은 모든 활동의 보안 및 유지에 대해 단독으로 책임을 집니다.
 사용자 이름과 비밀번호로 서비스를 이용하세요. 회원들은
 즉시 통지할 책임`,
      text58: `사용 동작에 관하여
 허가되지 않은, 남용, 보안 위반, 사용자 이름 및 비밀번호 보관
 위반 시 적절한 해결책을 마련해야 합니다.`,
      text59: `서비스를 사용하지 않는 회원`,
      text60: `어떤 목적을 위해서든
 불법, 비합리적, 사기적, 위협적, 불법적 정보 수집
 법률, 방해 행위, 시스템 및 구조를 손상시키는 바이러스 생성 및 확산
 이미지, 페이지의 정보를 전달합니다`,
      text61: `또는 서비스를 사용하세요
 나는 투기, 시장 조작을 목적으로 시장에 진입하여 주문을 생성합니다.
 시장 수요를 판단하는 목적 등을 포함하여 허위 제안.
 위반시 회원은 다음 각 호의 책임을 진다.
 법 앞에서의 그들의 행동.`,
      text62: `회원은 거래 페이지의 신뢰성을 떨어뜨리는 행동을 해서는 안 됩니다.
 전자제품`,
      text63: `어떤 형태로든
 이름을 사용하여 회원 간에 불화를 일으키는 것과 같이
 2차 등록, 제3자 또는 선전, 보급을 통해
 웹사이트의 평판에 도움이 되지 않는 정보`,
      text64: `4. 고객 정보 보안에 대한 약속:`,
      text65: `고객으로부터 개인정보를 수집할 때`,
      text66: `커밋:`,
      text67: `- 고객 개인정보를 판매, 공유 또는 교환하지 마십시오
 페이지에서 수집할 때`,
      text68: `제3자에게
 다른. 다음의 경우는 제외합니다:`,
      text69: `협력계약을 체결하는 제3자`,
      text70: `상업적 서비스를 제공하기 위해
 전자상거래 예: 전자지갑 제공업체, 서비스 제공업체
 결제 중개 서비스입니다.`,
      text71: `국가기관의 요청에 따라: 검찰, 법원, 기관
 불법 행위와 관련된 경찰 조사
 고객의 것`,
      text72: `Booking은 고객 정보를 수집할 때 이를 서비스 제공에만 사용합니다.
 Booking.com에서 전자상거래 서비스를 제공하는 과정입니다. 사용하지 마십시오
 고객 정보를 사업 목적 이외의 다른 목적으로 사용하지 마십시오.
 전자상거래 서비스 제공자;`,
      text73: `회원의 개인정보는 애플리케이션 서버에 비밀로 보관됩니다.
 예약 신청. Booking은 고객이 요청하는 경우에만 이 데이터를 삭제합니다.
 요청, 고객이 개인 페이지에서 "계정 삭제"를 선택하도록 요청합니다.
 또는 booking@booking.wghn.net 이메일로 정보를 보내주세요;`,
      text74: `개인정보 이용과 관련한 피드백을 받기 위한 메커니즘
 정보 수집의 명시된 목적과 달리`,
      text75: `고객이 제공한 개인 정보가 `,
      text76: `사용된 컬렉션
 명시된 목적과 반대로. 고객은 이사회에 직접 불만을 제기합니다.
 관리`,
      text77: `를 통해
 다음 채널:`,
      text78: `전화번호 02471001088로 전화하세요`,
      text79: `booking@booking.wghn.net으로 이메일을 보내세요`,
      text80: `Handeee 본사로 직접 방문하시거나, 피드백이나
제안을 다음 주소로 보내주세요: 하노이시 떠이호구 보찌콩 20번지 WGHN 골프장 예약 서비스 주식회사. 주소: 베트남 하노이시 떠이호구 보찌콩 20번지`,
      text81: `5. 정보이용에 관한 불만처리 절차
 이사회의 공표된 정보 수집 목적에 반하는 개인
 체크티닷컴`,
      text82: `1단계:`,
      text83: `고객 서비스 부서는 계속됩니다
 피드백을 받으십시오.`,
      text84: `2단계:`,
      text85: `기술부에 연락하여 검사를 받으세요
 애플리케이션 서버에 저장된 고객 정보가 손상되었는지 확인하세요.
 유출되었거나, 해킹되었거나, 도난당했거나 그렇지 않은지.`,
      text86: `3단계:`,
      text87: `총괄 이사에게 보고 - 그 사람
 애플리케이션 관리 및 고객과의 소통을 담당합니다.
 개인정보가 있는 경우 상황 및 해결방안 8시간
 해당 개인은 정보 수집 이외의 목적으로 사용되었습니다.`,
      text88: `4단계:`,
      text89: `단순한 경우의 경우
 회사 내에서 발생하는 모든 문제는 Booking에서 처리하고 해결합니다. 학교에서
 예약의 능력과 권한을 넘어서는 경우 관리자가 요청할 것입니다.
 유능한 경찰 기관에 해결을 요청하고 협력합니다.
 경찰기관이 조사하고 해결해야 합니다.`,
      text90: `컬렉션에는 다음이 포함됩니다:`,
      text91: "1. 기밀 유지에 대한 약속.",
      text92: `
      카드 결제 시스템은 베트남에서 합법적으로 운영 허가를 받은 결제 게이트웨이 파트너('결제 게이트웨이 파트너')가 제공합니다. 따라서 checkktee.com 웹사이트의 카드 결제 보안 기준은 업계 보안 기준을 준수합니다.`,
      text93: `2. 개인정보 보호정책.`,
      text94: `2.1. 국제 및 국내 카드(인터넷 뱅킹)를 통한 결제 거래 정책은 다음을 포함한 결제 게이트웨이 파트너의 보안 표준을 준수하도록 보장합니다.`,
      text95: `- 고객의 금융 정보는 SSL(Secure Sockets Layer) 프로토콜을 사용하여 거래 중 보호됩니다.`,
      text96: `- 결제정보 데이터 보안 기준을 확보하세요.`,
      text97: `- 인증된 계정 접근을 보장하기 위해 SMS를 통해 일회용 비밀번호(OTP)가 전송됩니다.`,
      text98: `- 베트남 국가은행 규정에 따른 은행 및 금융 부문의 정보 보안에 대한 원칙 및 규정.`,
      text99: `2.2. 웹사이트 checktee.com의 결제에 대한 거래 보안 정책은 고객에게 적용됩니다:`,
      text100: `- 회사는 토큰 저장 시설을 제공합니다. 결제 게이트웨이 파트너가 회사에 제공한 암호화된 문자열만 저장합니다. 회사는 고객의 카드 정보를 직접 저장하지 않습니다. 고객 결제 카드 정보의 보안은 라이선스가 있는 결제 게이트웨이 파트너에 의해 수행됩니다.`,
      text101: `- 국제 카드의 경우: 거래를 성립하는 데 사용할 수 있는 고객의 지불 카드 정보는 checktee.com 웹사이트의 시스템에 저장되지 않습니다. 지불 게이트웨이 파트너가 honey를 저장하고 보호합니다.`,
      text102: `- 국제 카드의 경우: 거래를 성립하는 데 사용할 수 있는 고객의 지불 카드 정보는 checktee.com 웹사이트의 시스템에 저장되지 않습니다. 지불 게이트웨이 파트너가 honey를 저장하고 보호합니다.`,
      text103: `- 국내카드(인터넷뱅킹)의 경우, 회사는 주문코드, 거래코드, 은행명만 저장합니다. 회사는 전자상거래 거래소 웹사이트 checktee.com에서 수행되는 모든 지불 활동에 대해 필요한 보안 조치를 엄격히 이행하는 데 전념하고 있습니다.`,
      text104: `불만 및 분쟁 해결`,
      text105: `불만 및 분쟁 해결 메커니즘`,
      text106: `1단계: 불만 정보 수신:`,
      text107: `고객은 다음 방법 중 하나로 wBooking에 불만을 보낼 수 있습니다:`,
      text108: `핫라인 02471001088로 전화하거나 booking@booking.wghn.net으로 이메일을 보내세요`,
      text109: `고객은 불만 사항을 해결하기 위해 다음 정보(전화번호, 이름, 놀이터, 플레이 날짜 및 시간)와 지원이 필요한 문제를 제공하세요.`,
      text110: `2단계: 정보 확인:`,
      text111: ` 01일 이내(가능하면 더 빨리) wBooking은 불만 정보를 확인하고, 검토하고, 관련 당사자에게 통보합니다.`,
      text112: `WBooking은 고객에게 불만 내용과 관련된 증거를 제공하도록 요청하고 불만 사항을 공급업체(있는 경우)에 전달합니다.`,
      text113: `3단계: 불만 해결:`,
      text114: `1일 이내(가능하면 더 빨리) wBooking은 고객과 공급업체에 연락하여 불만 사항을 해결합니다.`,
      text115: `4단계: 협상 및 화해:`,
      text116: `가능하다면 wBooking은 고객과 공급업체가 합리적인 시간 내에 분쟁을 해결하기 위해 협상하고 중재하도록 도울 것입니다.`,
      text117: `5단계: 중재 또는 법원:`,
      text118: `협상/중재가 실패할 경우 분쟁은 법률에 따라 유능한 법원에서 해결됩니다.`,
      text119: `wBooking의 약속:`,
      text120: `WBooking은 고객의 합법적 권리를 보장하는 정신으로 계약 및 법적 규정에 따라 모든 분쟁 및 불만을 객관적으로 해결하기 위해 노력합니다.`,
      text121: `wBooking에서의 거래로 인해 발생하거나 관련된 모든 논란, 불만 또는 분쟁은 선의와 상호 이익의 정신에 따라 당사자 간의 협상과 화해를 통해 해결됩니다. 불만 사항이 협상이나 조정을 통해 해결되지 않을 경우, 당사자들은 불만 사항을 관할 인민법원에 제소하여 해결하도록 결정해야 합니다. 법원의 결정은 최종적이며 당사자에게 구속력을 가집니다.`,
      text122: `법적 근거:`,
      text123: ` 2010년 소비자 보호법, 상품 및 서비스를 거래하는 조직 및 개인과 소비자 간 분쟁 해결에 관한 제4장.`,
      text124: "거래 일반 약관",
      text125: `나. 일반 조항`,
      text126: `WGHN 골프장 예약 서비스 주식회사(wBooking)는 웹사이트 checktee.com을 통해 서비스를 제공합니다. 웹사이트에 접속, 로그인 및 사용함으로써 서비스 사용자("귀하" 또는 "사용자"는 이 약관, wBooking 서비스와 관련된 정책 및 기타 정책에 동의합니다. 다른 책은 수시로 웹사이트에 발표됩니다.`,
      text127: `우리는 사전 통지 없이 언제든지 이 이용 약관의 특정 부분을 수정, 추가 또는 삭제할 수 있습니다. 계속해서 로그인하고 웹사이트에 접속하여 사용하고 서비스를 이용함으로써 귀하는 해당 변경 사항에 동의하고 수락하는 것으로 간주됩니다.`,
      text128: `귀하가 checktee.com 웹사이트의 서비스를 사용하여 귀하가 합법적으로 요청할 수 있는 권한이 있는 다른 개인/조직을 위해 주문을 하는 경우("최종 사용자"), 귀하는 이러한 약관을 전달할 의무가 있음에 동의합니다. 최종 소비자에게 제공되는 조건.`,
      text129: `1. 적용범위`,
      text130: `웹사이트를 통해, 우리는 귀하가 골프 시간 및 기타 제품("서비스")과 관련된 제품을 검색, 사용 요청 또는 주문할 수 있는 온라인 도구를 빠르고 안전하고 편리한 지불 방법으로 제공합니다.`,
      text131: `귀하의 정보 검색을 용이하게 하기 위해, 저희는 웹사이트에 골프타임 상품에 대한 정보를 표시하겠습니다.`,
      text132: `귀하의 요청은 귀하가 웹사이트에 등록한 전화번호 또는 Zalo OA를 통해 귀하의 전화번호로 통지받은 확인 전화를 받거나 웹사이트에 있는 귀하의 계정에 입금된 알림을 받을 때 당사에서 처리 및 확인합니다.`,
      text133: `2. 보장은 없다`,
      text134: `우리는 전문적인 기술과 주의를 기울여 서비스를 제공할 것입니다. 그러나 당사는 제공된 모든 정보가 정확하고, 완전하며, 적합하다는 것을 확인하거나 보장하지 않으며, 당사는 모든 오류(배열 오류 및 인쇄 오류 포함), 오류, 오해의 소지 또는 정보 전달 실패에 대해 책임을 지지 않습니다. 우리는 항상 관련 정보의 정확성과 완전성에 대해 책임을 질 것입니다.`,
      text135: `저희 서비스에 대해 불만이 있으시면 저희 고객 서비스 부서에 문의해주시기 바랍니다. 우리는 합리적인 해결책을 찾기 위해 노력할 것이지만 귀하의 희망에 부합하는 결과를 보장하지는 않습니다.`,
      text136: `3. 취소, 변경 요청`,
      text137: `당사 서비스를 주문할 경우, 귀하는 해당 서비스와 관련된 정책을 수락하고 준수하는 데 동의하게 됩니다. 여기에는 서비스의 이용 범위 및 제공, 골프장 이용 조건, 취소 및 변경 정책이 포함되나 이에 국한되지 않습니다. 골프장 취소 및 변경 정책은 당사 플랫폼의 취소 정책 정보 페이지, 서비스 이용 요청 시, 그리고 결제 알림(해당되는 경우)에 게시됩니다.`,
      text138: `골프장 정책에 따라 취소 및 서비스 변경 시 요금이 부과될 수 있으며, 선불한 금액은 환불되지 않습니다. 일부 수수료 또는 특별 혜택은 취소, 환불 또는 변경할 수 없습니다. Wbooking의 취소, 상품 변경 및 기타 상품 관련 정책을 주의 깊게 읽어보시기 바랍니다. 요청을 검토, 편집, 변경 또는 취소하려면 고객 서비스 부서에 문의하세요.`,
      text139: `II. 가격, 세금, 수수료`,
      text140: `1. 제품 가격`,
      text141: `제품 가격에는 추가 세금 및 기타 요금이 포함될 수 있지만, 경우에 따라 가격에는 세금 및 서비스 요금이 포함되지 않을 수 있습니다. 사용자는 확인 알림이 사용자에게 전송될 때 총 지불 금액, 조건 및 기타 세부 사항을 확인하는 것이 자신의 책임이라는 데 동의합니다. 가격은 사용자가 지불해야 할 금액을 확인할 수 있도록 자세히 표시되며, 신용카드 사용이나 은행 간 수수료로 인한 추가 비용은 사용자에게 청구됩니다. 사용자에게 의심이 있는 경우 의심이 있는 경우 서비스를 이용하려면 사용자는 WBooking 고객 서비스 부서에 문의할 수 있습니다.`,
      text142: `때때로 우리는 정상 가격보다 낮은 가격을 제시하거나 다른 프로모션을 적용할 수 있습니다. 프로모션에 참여하려면 특정 조건을 준수해야 합니다.`,
      text143: `1. 지불수수료`,
      text144: `국내 발행 국제카드에 대한 EPAY 결제 게이트웨이를 통한 결제 수수료`,
      text145: `CTT 거래가 성공적으로 기록되었나요? GTGD: 성공적으로 기록된 CTT 거래의 총 가치입니다.`,
      text146: `3. 취소 수수료 또는 추가 요청`,
      text147: `결제 전이라면 언제든지 예약을 취소할 수 있습니다. 그러나 귀하가 결제를 완료하고 당사로부터 성공적인 결제 통지를 받은 후 취소를 원하시면 당사에서 규정한 거래 수수료(거래 가치의 %로 계산된 수수료 및 거래 수수료 포함)는 환불되지 않습니다. 국제 카드를 결제 수단으로 사용하는 거래의 공급자. 저희 플랫폼의 취소 정책을 주의 깊게 읽어주세요.`,
      text148: `III. 신용 카드 결제 및 사기`,
      text149: `1. 이 웹사이트를 통해 예약한 경우, 예약 및 예약 확인 시 Wbooking에서 전체 가격을 귀하의 신용카드로 청구합니다(환불은 기존 피치의 조건에 따라 달라질 수 있음). 각 예약을 하기 전에 반드시 예약 세부 정보를 주의 깊게 확인하세요. Wbooking은 합리적인 기간 내에 환불을 처리할 것입니다. 귀하의 신용카드 정보가 당사에 전송되는 동안 이를 보호하고 암호화하기 위해 당사는 당사 서비스에 PCI DSS(Payment Card Industry Data Security Standard) 또는 SSL(Secure Sockets Layer)과 같은 암호화 기술을 사용합니다.`,
      text150: `2. 신용카드 사기가 발생하거나 신용카드의 무단 사용이 발생한 경우, 사기 행위 또는 신용카드의 무단 사용을 알게 된 즉시 은행이나 카드 발급사에 연락하는 것은 귀하의 책임입니다. 이 경우, Wbooking은 타인에 의한 귀하의 신용카드 사기 또는 무단 사용 사례에 대해 책임을 지지 않습니다. 이는 사기 사례나 무단 사용 사례와 관계없이 적용됩니다. 이러한 허가는 Wbooking 서비스를 통해 수행됩니다. Wbooking은 이러한 사기로 인해 발생한 것으로 간주되는 결제에 대해 보상하거나 환불할 의무가 없습니다. 우리는 선의의 표시로 다른 형태로 보상하는 것을 고려하고 이에 동의할 수도 있습니다. 당사의 보안 서버를 통해 예약이 이루어졌고 당사의 부재 또는 과실로 인해 귀하의 신용 카드가 무단 사용된 경우에만 보상을 청구할 수 있으며, 보안 서버를 사용하는 동안 귀하가 오류를 일으켰습니까? 사기가 당사가 아닌 다른 애플리케이션이나 서버를 통해 저질러지거나, 귀하의 신용카드가 귀하의 부주의와 잘못으로 인해 무단 사용된 경우, 당사는 사기 또는 귀하의 신용카드의 무단 사용에 대해 책임을 지지 않습니다. Wbooking에서 승인되지 않은 예약이나 사기 행위가 의심되는 경우 즉시 고객 지원팀에 연락해야 합니다.`,
      text151: `3. 예약을 하려면 열여덟(18) 세 이상이어야 하며 거래를 진행할 수 있는 법적 능력이 있어야 합니다(또는 법적 보호자의 승인을 받아야 합니다). 본인 명의로 발급된 신용카드나 직불카드를 사용해야 하며, 거래 수수료를 충당할 수 있는 충분한 금액이 있는지 확인하세요. 귀하는 귀하를 대신하여 또는 귀하의 계좌에서 이루어지는 모든 거래에 대해 재정적으로 책임을 져야 합니다.`,
      text152: `4. 귀하가 당사에 제공하는 세부 정보가 사실이며, 정확하고 완전한지 확인해야 합니다. WBooking은 베트남에서 발급된 신용카드만 허용합니다. Wbooking은 자체 재량에 따라 다른 결제 방법을 추가하거나 제거할 수 있습니다.`,
      text153: `5. 어떤 경우에는 예약을 검증하고 확인하기 위해 추가 정보를 요청할 수 있습니다. 자세한 내용은 당사 플랫폼에 설명되어 있습니다. 예약은 확인 이메일을 받기 전까지는 확정되지 않으며, 공급업체가 예약 과정에서 사기 감지 메커니즘을 구현했을 가능성이 있습니다. 사기가 발생하거나 발생한 것으로 판명될 경우 베팅은 더 이상 존재하지 않거나 자동으로 무효화됩니다. Wbooking에서는 책임을 지지 않습니다. 추가 정보를 제공하지 않으시면 예약이 완료되지 않으며 무효화됩니다.`,
      text154: `4. WBOOKING의 권리 및 책임`,
      text155: `1. 홈페이지 관리위원회의 권한`,
      text156: `a. checktee.com 웹사이트의 서비스 제공 계약 내용 및 Checktee.com 웹사이트에 공개적으로 게시된 WBooking 운영 규정에 따라 파트너가 권리 및 의무를 이행하도록 요구합니다.`,
      text157: `b. Checktee.com은 귀하가 파트너의 서비스 중 하나 또는 전부를 사용할 수 있는 권한을 종료할 수 있습니다. 고객에게 알리고 파트너에게 알립니다. 파트너의 경우 최소 한 달(01) 동안 고객입니다. 고객이 checktee.com 서비스를 제공하는 웹사이트의 규정을 위반하거나 checktee.com의 사업 활동에 영향을 미치는 행동을 하는 경우`,
      text158: `c. Checktee.com은 파트너의 서비스 이용권 및 멤버십을 즉시 종료할 수 있습니다. 고객이 Checktee.com 웹사이트에서 파트너를 감지한 경우; 파트너의 경우, 의뢰인이 유죄 판결을 받았거나 형을 선고받고 있는 경우 고객이 계속해서 운영할 경우 Checktee.com 웹사이트에 법적 책임이 발생할 수 있으며, 사기 행위, 위조, 시장 혼란, 파트너 간의 불화를 초래할 수 있습니다. Checktee.com 웹사이트의 다른 고객, 베트남의 현행 법률을 위반하는 활동.`,
      text159: `d. Checktee.com은 베트남의 지적재산권 보호에 관한 법률에 따라 Checktee.com 웹사이트의 서비스와 콘텐츠를 사용할 수 있는 저작권을 보유합니다. 다양한 언어로 된 모든 아이콘과 콘텐츠는 Checktee.com 웹사이트의 소유입니다. 위의 소유권을 무단 복제, 이용 및 불법 배포하는 행위는 엄격히 금지되어 있습니다.`,
      text160: `2. 책임 :`,
      text161: `a. Checktee.com은 Checktee.com 웹사이트에 제공된 정보가 정확하고 완전한지 확인하기 위해 "검사 및 모니터링 메커니즘"을 구축하고 구현할 책임이 있습니다.`,
      text162: `b. 파트너에게 완전하고 정확하며 시기적절한 고객 정보를 제공하여 서비스를 제공할 수 있습니다.`,
      text163: `c. Checktee.com은 웹사이트에서 불법적인 사업 활동을 감지하거나 이에 대한 피드백을 받으면 적시에 조치를 취하고 국가 관리 기관이 불법적인 사업 활동을 조사하도록 지원합니다. 법률 위반 주제에 대한 등록 정보, 거래 내역 및 기타 문서를 제공합니다. 웹사이트 Checktee.com`,
      text164: `d. Checktee.com은 Checktee.com 웹사이트에서의 거래 과정에서 발생하는 분쟁을 해결하기 위한 메커니즘을 공개적으로 발표할 책임을 집니다. Checktee.com 웹사이트의 고객이 판매자(파트너)와 갈등이 있거나 합법적 이익을 침해하는 경우 Checktee.com은 고객에게 판매자(파트너)에 대한 정보를 제공하고, 고객의 합법적 권익을 보호하기 위해 적극적으로 지원합니다.`,
      text165: `e. Checktee.com은 법률 규정에 어긋나는 정보 제공 서비스를 웹사이트에서 차단하고 삭제할 책임을 집니다.`,
      text166: `f. Checktee.com은 다음과 같은 주요 업무를 포함하여 웹사이트 구축을 담당합니다. 연구, 설계, 하드웨어 및 소프트웨어 구매, 인터넷 연결, 웹사이트 운영을 위한 정책 구축. Checktee.com은 허용된 약관에 따라. 웹사이트 Checktee.com은 웹사이트 Checktee.com에 참여하는 파트너와 사용자의 거래를 지원하기 위한 서비스 및 유틸리티 도구 시스템을 구축하기 위해 파트너와 협력하고 배포할 것입니다.`,
      text167: `g. Checktee.com은 파트너로부터 피드백을 수집할 책임이 있습니다. 분쟁이 발생할 경우 고객에게 연락하세요. 이사회는 이러한 피드백을 고려할 것입니다. Checktee.com 웹사이트는 회원의 권리 보호에 대한 계획을 레벨에 따라 마련하고 있습니다.`,
      text168: `h. Checktee.com은 Checktee.com 웹사이트의 정상적인 운영을 유지하고 다음과 같은 문제를 해결하기 위해 범위와 조건 내에서 최선을 다할 것입니다: 기계의 기술적 문제, 소프트웨어 오류, 인터넷 전송 시스템, 인력, 사회적 변동, 자연 재해, 전력 정전, 정부 기관 또는 제3자 기관의 결정. 그러나 상기 사건이 통제할 수 없이 발생하는 경우, 회원에게 손해를 입히는 불가항력 사건인 경우, Checktee.com 웹사이트는 책임을 지지 않습니다.`,
      text169: `V. CHECKTEE.COM 웹사이트에서의 고객(구매자, 서비스 이용자...)의 권리 및 책임`,
      text170: `1. 고객 권리`,
      text171: `a. 정보에 대한 권리: 고객은 가격, 품질, 기능, 거래 조건, 반품 및 보증 정책을 포함하여 제품/서비스에 대한 완전하고 정확한 정보를 제공받을 권리가 있습니다.`,
      text172: `b. 정보 비밀 유지 권리: 법률에 다른 규정이 없는 한, 개인 정보를 보호하고 동의 없이 공개되지 않을 권리가 있습니다.`,
      text173: `c. 보호받을 권리: 귀하의 권리와 건강에 해로운 품질이 좋지 않은 사기성 제품 및 서비스로부터 보호받을 권리.`,
      text174: `d. 불만 제기 및 분쟁 해결 권리: 제품/서비스가 요구 사항을 충족하지 못하거나 설명과 다를 경우 불만을 제기하고 분쟁 해결을 요청할 권리가 있습니다.`,
      text175: `e. 지원 권리: 제품 정보, 사용 지침, 질문에 대한 답변과 관련하여 웹사이트 관리자로부터 지원을 받을 권리가 있습니다.`,
      text176: `2. 고객 책임`,
      text177: `a. 정확한 정보 제공: 웹사이트에 등록하고 거래를 할 때 정확하고 완전한 개인 정보 및 지불 정보를 제공하세요.`,
      text178: `b. 거래 규정 준수: 서비스를 이용할 때 웹사이트에 게시된 거래 약관을 준수하세요.`,
      text179: `c. 계정 보안: 사기를 방지하고 개인 정보 유출을 방지하기 위해 계정 정보와 비밀번호를 비밀로 유지하고 다른 사람과 공유하지 마세요.`,
      text180: `d. 서비스의 책임 있는 사용: 서비스를 책임감 있게 사용하고, 불법적인 목적으로 사용하거나, 시스템이나 다른 사람의 권리를 침해하지 마십시오.`,
      text181: `e. 정시 지불: 제품/서비스를 구매할 때 요구되는 대로 정시에 전액을 지불하세요.`,
      text182: `f. 피드백 및 제안: 웹사이트의 서비스와 제품의 품질을 개선하기 위한 피드백과 제안을 제공합니다.`
    },
    notiRegistered:
      "고객님께서 이 전화번호로 계정을 등록하셨습니다. 로그인해주세요!",
    skipLower: "소문자",
    register: "등록하다",
    create_acc: "계정 만들기",
    regDone: "성공적으로 등록되었습니다",
    update: "업데이트",
    welcomeWg: "wGroup에 오신 것을 환영합니다",
    yourVid: "귀하의 vID 코드는 다음과 같습니다",
    pleaseUpdate: "귀하의 계정을 보호하려면 개인 정보를 업데이트하십시오",
    whenJoinWg: "WGHN에 참여하시면 다양한 독점 혜택을 받으실 수 있습니다.",
    seeDetail: "세부정보 보기",
    here: "여기",
    birth: "생일",
    emailAddress: "이메일 주소",
    updateInfoUser: "개인정보 업데이트",
    infoUpdateDone: "정보가 성공적으로 업데이트되었습니다.",
    thankYour:
      "wGroup의 서비스를 믿고 이용해주셔서 감사드립니다. 궁금하신 사항은 024.7100.1088로 연락하시거나 고객센터로 채팅주세요. 지금 WGHN 앱을 다운로드하여 회원을 위한 독점 혜택을 놓치지 마세요. 감사합니다!",
    captcha: "보안 문자 코드를 입력하세요",
    phoneNumber2: "전화 번호",
    needCancel: "취소하려면 핫라인(02471.001.088)으로 문의하세요.",
    rechargePoints: "골프 지갑 충전",
    paymentMethod: "결제수단",

    order: "주문하다",
    and: "그리고",
    enterBook:
      "'주문하기'를 클릭하면 귀하의 개인 정보가 주문 처리, 웹사이트 사용 경험 향상 및 이 섹션에 설명된 기타 특정 목적을 위해 사용된다는 데 동의한다는 의미입니다.",
    out: "우리의.",
    enterPay: "'결제'를 클릭하면 준수에 동의한다는 의미입니다.",
    personalInformationPolicy: "개인정보 수집방침",
    termsTransaction: "거래 조건",
    complaints: "불만사항 분쟁 해결 메커니즘",

    paymentInfoSecurityPolicy: "결제정보 보안정책",
    cusInfoSecurityPolicy: "고객정보보호정책",

    accountInfo: "계정 정보",
    accountSettings: "계정 설정",
    account: "계정",
    cancellationPolicy: "환불 및 취소 정책",
    privacyPolicy: "개인 정보 보호 정책",
    deliveryPolicy: "배송 정책",
    payPolicy: "지불 정책",
    policy: "정책",
    branchAddress: "지점 주소",
    certificate:
      "사업자등록증 : 0109147466. 2020년 3월 27일 최초 발급. 발행 기관: 하노이 기획투자부.",
    introduce: "소개하다",
    bookingReqSend: "피치 요청이 전송되었습니다",
    yard: "마당",
    suggestions: "당신을 위한 제안",
    noti: "골프 예약 서비스의 예상 견적을 받으려면 정보를 입력해 주세요.",
    noti1: "감사합니다. 골프 예약 서비스의 예상 가격은 다음과 같습니다: ",
    noti2:
      " VND / 1인입니다. 정확한 견적을 받으려면 예약 요청을 보내시고, wGroup 및 파트너의 혜택을 누리세요.",
    typeInsurance: "HIO 패키지 선택",
    typeInsuranceAll: "전체 예약에 대해 HIO 패키지 선택",
    titleHeader: "필드 예약",
    titleMenuArea: "지역별 선택",
    titleHotDeal: "핫딜",
    nearestDate: "가장 가까운 날짜",
    incorrectCode: "잘못된 코드입니다. 다시 시도해주세요.",
    farthestDate: "가장 먼 날짜",
    titleTop10: "최고의 필드 Top 10",
    login: "로그인",
    logout: "로그아웃",
    termsAndConditions: "이용 약관",
    noBooking: "예약이 없습니다",
    noOrderBk: "아직 예약이 없거나 확정된 예약이 없습니다.",
    hotDealTitle1: "지금 최고의 티타임 예약하세요",
    hotDealTitle2: "최고 가격의 필드",
    titleTop10Page: "이번 주 최고의 골프 필드 Top 10",
    descPageHome: "빠르고 - 편리하고 - 쉽다",
    aboutUs: "회사 소개",
    contact: "문의하기",
    quickBookField: "필드 예약 요청 보내기",
    doNotShareAuthenticationCode:
      "계정을 보호하기 위해 인증 코드를 공유하지 마세요",
    authenticationCodeSentToPhoneNumber:
      "인증 코드가 전화번호로 전송되었습니다",
    enterAuthenticationCodeBelow: "아래에 인증 코드를 입력하세요",
    pleaseWait: "기다려주세요",
    seconds: "초",
    toResendNewCode: "새 코드를 다시 보내려면",
    noteCheckMessage: "참고: 제때 코드를 받기 위해 메시지를 확인하세요",
    authenticationCodeExpired: "인증 코드가 만료되었습니다. 클릭하세요",
    resend: "다시 보내기",
    toResendCode: "코드를 다시 보내려면",
    noteCheckMessageAgain: "참고: 제때 코드를 받기 위해 메시지를 확인하세요",
    bookField: "필드 예약",
    noTeetimeAvailable: "이 날짜에 티타임이 없습니다. 다른 날짜를 선택하세요.",
    downloadApp: "WGHN 앱 다운로드",
    all: "모두",
    northern: "북부",
    fieldArea: "필드 지역",
    priceRange: "가격 범위",
    playTime: "플레이 시간",
    servicesAndUtilities: "서비스 및 편의시설",
    lightSnackField: "간단한 스낵이 있는 필드",
    lightedField: "조명이 있는 필드",
    crowdedField: "혼잡한 필드",
    sort: "정렬",
    default: "기본",
    averagePricePerPax: "1인당 평균 가격",
    priceLowToHigh: "낮은 가격 순",
    priceHighToLow: "높은 가격 순",

    apply: "적용",
    central: "중부",
    southern: "남부",
    evening: "조명",
    numberOfPeople: "인원수 (*)",
    insuranceRequired: "홀인원 보험 필수",
    timeRequired: "티타임 선택 (*)",
    choosetee: "티타임 선택",
    searchByField: "필드로 검색",
    waitForConfirmation: "확인 대기 중",
    waitForPayment: "주문하다",
    cancelled: "취소됨",
    invoiceInformation: "청구서 정보",
    invoiceCode: "청구서 코드:",
    numberOfPaymentServices: "결제 서비스 수:",
    booker: "예약자:",
    phoneNumber: "전화번호:",
    service: "서비스",
    quantity: "수량:",
    unpaid: "미결제",
    totalPaymentAmount: "총 결제 금액:",
    totalWWalletPoints: "골프월렛에 적립된 총 포인트:",
    payment: "결제",
    support: "필드 예약 지원이 필요하시면,",
    PBX: "24/7 서비스 가능한 전화번호 0247.100.1088",
    viewMore: "더보기",
    shorten: "간략히",
    viewAll: "모두 보기",
    numberHolesText: "홀 수",
    totalNumberOfPeople: "총 인원수",
    describe: "설명",
    addPerson: "사람 추가",
    playerNotFound: "이 vID로 플레이어를 찾을 수 없습니다. 다시 시도해주세요!",
    searchByVID: "vID로 검색",
    includedServicesAndFees: "포함된 서비스 및 수수료",
    electricCarFeeIncluded: "전기차 요금 포함",
    lightMealIncluded: "간단한 식사 포함",
    hotelNotIncluded: "호텔 포함되지 않음",
    flightTicketNotIncluded: "항공권 포함되지 않음",
    iAgreeWith: "동의합니다",
    serviceTerms: "서비스 약관",
    bookingRequestSentQuickly:
      "귀하의 요청이 국제 골프 코스 예약 핫라인 wBooking의 영업부로 전송되었습니다. 곧 연락드리겠습니다.",
    bookingRequestSent:
      "귀하의 요청이 국제 골프 코스 예약 핫라인 wBooking의 영업부로 전송되었습니다. 곧 연락드리겠습니다.",
    fieldName: "필드 이름",
    bookingDate: "예약 날짜",

    playDate: "플레이 날짜",
    numberOfPlayers: "플레이어 수",
    totalAmount: "총 금액",
    thankYouForBooking: "wBooking을 통해 예약해 주셔서 감사합니다.",
    contactToConfirmBooking: "이 예약을 확인하기 위해 연락드리겠습니다.",
    encounterBookingIssues: "예약 중 문제가 발생한 경우.",
    contactNumber: "다음 번호로 연락하십시오: 02471.001.088",
    servicesAndSurchargesAreIncluded: "서비스 및 추가 요금이 포함되어 있습니다",
    history: "히스토리",
    field: "필드 선택 (*)",
    chooseFacility: "필드 선택",
    yardDetails: "야드 세부 사항",
    favoritesList: "즐겨찾기 목록",
    superDeal: "슈퍼 딜",
    amountToPay: "결제 금액:",
    billCode: "청구서 코드:",
    paymentCode: "결제 코드:",
    addPlayer: "플레이어 추가",
    orderStatus: "주문 상태:",
    orderCode: "야드 예약 코드",
    viewBillDetails: "청구서 세부 정보 보기",
    billDetails: "청구서 세부 사항",
    finishedIn: "종료 시간",
    reserveYourYardNow: "지금 바로 야드를 예약하세요",
    titleContact: "문의하기",
    titleAboutUs: "WBooking 소개",
    hole: "홀",
    searchBtn: "검색",
    infoCourse: "코스 정보",
    enterNameOrIDToSearch: "이름 또는 vID를 입력하여 검색",
    evaluate: "평가하다",
    selectPeopleToAdd: "추가할 사람 선택",
    discount: "할인",
    areaNorthern: "북부 지역 최고의 골프 코스",
    areaSouth: "남부 지역 최고의 골프 코스",
    areaCentral: "중부 지역 최고의 골프 코스",
    expired: "코드가 만료되었습니다",
    titleTermsAndConditions1: "제 1조. 일반 원칙",

    contentTermsAndConditions11:
      "1. vHandicap 애플리케이션 플랫폼에서 HIO 서비스를 등록하기 전에 고객은 이 HIO 서비스 제공 및 사용 계약(이하 '계약'이라 함)의 모든 조건을 읽고 이해하고 동의했음을 확인하며, HIO 서비스 등록을 통해 아래 모든 조건에 대한 제한이 없음을 수락합니다.\n",
    contentTermsAndConditions12:
      "2. vHandicap 애플리케이션 플랫폼에서 베트남 골프 스포츠 서비스 주식회사(이하 '저희' 또는 'VGS SPORT'라 함)가 제공하는 HIO 서비스를 이용할 때, 고객은 법적 구속력이 있는 계약을 체결할 수 있는 법적 나이가 되었음을 약속하며, 베트남 법률에 따라 서비스를 받는 것이 금지되지 않거나, 부모 또는 법적 보호자의 사전 동의를 받아 본 계약에 따라 서비스를 이용할 수 있음을 약속합니다.\n",
    contentTermsAndConditions13:
      "3. 저희는 언제든지 사전 통보 없이 본 계약을 수정하거나 업데이트할 수 있습니다. 이러한 수정 사항은 vHandicap 애플리케이션에 업데이트되는 즉시 효력을 발휘합니다. 고객은 이러한 변경 사항을 정기적으로 확인해야 하며, 이 서비스를 계속 이용하는 것은 변경된 내용에 동의함을 의미합니다.",
    titleTermsAndConditions2: "제2조. HIO 서비스 설명",
    contentTermsAndConditions21:
      "1. HIO 서비스는 골프 스포츠에서 '홀인원' 상이 주어지는 토너먼트 서비스로, 고객이 선택한 HIO 서비스에 따라 상금 가치가 달라지는 18홀 라운드에서 파3 홀에서 티에서 한 번의 샷으로 지정된 홀에 공을 성공적으로 넣은 플레이어에게 수여됩니다.\n",
    contentTermsAndConditions22:
      "2. HIO 토너먼트는 베트남 골프 스포츠 서비스 주식회사가 주최하는 골프 토너먼트로, 고객이 vHandicap 애플리케이션을 통해 제공된 HIO 서비스를 선택한 대회입니다. 서비스를 등록함으로써 고객은 VGS Sport가 고객이 참가하는 HIO 토너먼트의 공식 주최자가 될 것에 동의합니다.\n",
    contentTermsAndConditions23:
      "3. HIO 상은 고객 1명당 하루에 한 번만, 18홀 표준 라운드당 한 번만 수여됩니다(하루에 두 번 이상 HIO를 친 경우에도 고객은 등록한 HIO 서비스의 가치에 상응하는 상을 한 번만 받게 됩니다).\n",
    contentTermsAndConditions24:
      "4. 고객이 같은 18홀 라운드에 대해 두 개의 HIO 서비스 패키지(일일 보험 패키지 및 연간 회원 패키지)를 등록한 경우, 고객은 등록한 두 개의 서비스 상금에 해당하는 두 개의 HIO 상을 받을 수 있습니다.",
    search: "티타임 찾기",
    overTeeTime: "티타임이 없습니다",
    date: "날짜",
    latest: "최근",
    time: "시간",
    filter: "필터",
    courseTee: "코스 티타임",
    bookNowBtn: "지금 예약",
    bookNow: "지금 예약",
    price: "가격",
    from: "부터",
    morning: "아침",
    afternoon: "오후",
    lightHour: "조명 시간",
    descTee: "포함: 그린 피 & 캐디 피 & 1/2 버기",
    addUser: "사용자 추가",
    totalMoney: "총 금액",
    addUserTee: "티타임에 플레이어 추가",
    listUser: "플레이어 목록",
    confirm: "확인",
    comingSoon: "애플리케이션 개발 중",

    notiSendOtp:
      "WBooking (WGHN)에 계정이 없습니다. WBooking (WGHN)이 SMS로 보낸 OTP 코드를 입력하여 계정을 개설하고 WBooking (WGHN)에서 계정을 개설하기 위한 조건 및 약관에 동의하십시오.",
    subSendOtp: "휴대전화로 전송된 OTP를 입력해 주세요",
    notiSendOtpVGS:
      "WBooking (WGHN)이 SMS로 보낸 OTP 코드를 입력하여 WBooking (WGHN) 계정에 로그인하십시오.",
    fullName: "성명",
    noData: "데이터 없음",
    pleaseFillInAllInformation: "모든 정보를 입력해 주세요",
    userVga: "vID를 가진 플레이어",
    userOutSystem: "시스템 외부의 플레이어",
    note:
      "참고: 20,000,000 VND 보험 패키지는 WBooking을 통해 예약하는 모든 예약에 대한 프로모션 선물입니다.",
    unConfirm: "미확인",
    pay: "결제",
    paymentGuide: "결제 안내",
    bank: "은행",
    bookQuicklyToEnsureYouReserveYourSpot:
      "자리를 확보하기 위해 빠르게 예약하세요",
    content: "내용",
    numberCard: "계좌 번호",
    amountMoney: "금액",
    accountHolder: "계좌 소유자",
    scanQr: "WGHN 앱을 사용하여 QR 코드를 스캔하세요",
    unPay: "미결제",
    paid: "결제 완료",
    BookingCode: "예약 코드",
    outsideSystem: "시스템 외부",
    enterFullName: "성명을 입력하세요",
    userBooking: "사용자 예약",
    companyName: "골프 예약 서비스 주식회사 WGHN",
    orPay: "또는 각 사람에게 지불",
    payNow: "지금 결제",
    notify: "알림",
    next: "필드 예약",
    setUpTheYardQuickly: "빠른 필드 예약",
    skip: "건너뛰기",

    notFoundMessage:
      "해당 코스를 찾을 수 없습니다. 다른 코스로 다시 시도해 주세요.",
    waitOtpText: "OTP 확인을 기다려주세요",
    paymentReminder: "주문 확인 후 30분 이내에 결제해 주세요.",
    enteredOTPConfirmBooking:
      "WBooking (WGHN)이 SMS로 보낸 OTP 코드를 입력하여 거래를 확인해 주세요.",
    notiPaymentIn30Minute:
      "예약 정보가 기록되었습니다. WBooking (WGHN)이 확인 후 고객님께 알림을 드립니다. 확인 통지를 받은 후 30분 이내에 결제해 주세요.",
    enterOtp: "아래 상자에 확인 코드를 입력해 주세요",
    notiSuccess: "예약 성공! 직원의 예약 확인을 기다려주세요.",
    textBookingCourse: "코스를 예약하시겠습니까?",
    terrain: "코스 지형",
    buyMore: "추가 구매",
    codeBooking: "예약 코드",
    bannerContent:
      "코스 예약, 쇼핑, 골프 여행 및 다양한 편리한 서비스를 즐기세요!",
    bannerSubContent: "지금 WGHN 앱을 다운로드하세요!",
    bookCourse: "골프 코스 예약",
    shopping: "쇼핑",
    hio: "HIO 보험",
    handee: "deHandde 패션",
    for: "대상",
    people: "명",
    at: "시",
    yes: "홀인원/이글 보험 가능",
    no: "홀인원 / 이글은 커버되지 않음",
    bookingSwitchboard: "wBooking 국제 골프 코스 예약 핫라인",

    wap: {
      text1: "전체",
      text2: "북부",
      text3: "중부",
      text4: "남부",
      text5: "아침",
      text6: "오후",
      text7: "조명",
      text8: "확인 대기 중",
      text9: "결제 대기 중",
      text10: "결제 완료",
      text11: "실패",
      text12: "날짜 입력",
      text13: "장소 입력",
      text14: "부터",
      text15: " 리뷰",
      text16: "날짜 입력",
      text17: "인원 수",
      text18: "아침",
      text19: "정오",
      text20: "조명 시간",
      text21: "9홀",
      text22: "18홀",
      text23: "27홀",
      text24: "홀 수",
      text25: "최고 가격",
      text26: "홈",
      text27: "이름",
      text28: "보험",
      text29: "검색",
      text30: "특가 상품",
      text31: "취소됨",
      text32: "코스 예약",
      text33: "예약이 없습니다",
      text34: "결제 완료",
      text35: "수량",
      text36: "저희 팀이 주문을 확인한 후 30분 이내에 결제해 주세요",
      text37: "결제",
      text38: "잔액",
      text39: "금액",
      text40: "지갑 잔액이 결제에 충분하지 않습니다",
      text41:
        "지갑에 돈을 더 충전하거나 다른 결제 방법을 선택해 주세요. 감사합니다!",
      text42: "닫기",
      text43: "지갑 충전",
      text44: "길게 눌러 사진에 저장",
      text45: "계좌 번호",
      text46: "계좌 소유자",
      text47: "은행",
      text48: "금액",
      text49: "이체 내용",
      text50:
        "(참고: 올바른 이체 내용을 입력해야 합니다. 잘못된 내용은 거래 과정에서 문제나 지연을 초래할 수 있습니다.)",

      text51: "지갑 잔액",
      text52: "지갑 충전",
      text53: "거래 내역",
      text54: "지갑 이용 약관",
      text55: "주문",
      text56: "로그아웃",
      text57: "언어",
      text58: "wGroup의 vID로 로그인 중입니다",
      text59: "충성 회원의 독점 혜택 세부 정보 보기",
      text60: "회원 등급",
      text61: "모든 주문에서 포인트 적립",
      text62: "포인트는 보상 지갑에 적립됩니다",
      text63: "(시스템 외부)",
      text64:
        "우리의 서비스를 보다 편리하게 이용하기 위해 보상 지갑 계정으로 돈을 이체하세요",
      text65: "골프 지갑 잔액 (₫)",
      text66: "충전 금액 입력 (₫)",
      text67: "최소",
      text68: "다음",
      text69: "금액 (₫)",
      text70: "잔액 (₫)",
      text71: "내용",
      text72: "더 이상 거래 없음",
      text73: "더 이상 거래 없음",
      text74: "잔액",
      text75: "금액",
      text76: "길게 눌러 사진에 저장",
      text77: "계좌 번호",
      text78: "계좌 소유자",
      text79: "은행",
      text80: "금액",
      text81: "이체 내용",
      text82:
        "(참고: 올바른 이체 내용을 입력해야 합니다. 잘못된 내용은 거래 과정에서 문제나 지연을 초래할 수 있습니다.)",
      text83: "최고 가격",
      text84: "좋아하는 코스",
      text85: "홈",
      text86: " 리뷰",
      text87: "날짜 입력",
      text88: "인원 수",
      text89: "9홀",
      text90: "18홀",
      text91: "27홀",
      text92: "최고 가격",
      text93: "홀 수",
      text94: "부터",

      text95: "로그인",
      text96: "로그아웃",
      text97: "플레이어 추가",
      text98: "WGHN 골프 코스 예약 서비스 JSC (wBooking)",
      text99: "주소",
      text100: "하노이시 떠이호구 보찌콩 20번지.",
      text101: "중부",
      text102: "368 Tran Hung Dao, An Hai Tay 동, Son Tra 구, 다낭",
      text103: "남부",
      text104: "호치민시 고밥구 시티랜드 파크 힐즈 도시 지역 1번 도로 17번지.",
      text105: "생태계",
      text106: "연락처",
      text107: "WGHN 전자 상거래 플랫폼",
      text108: "Handee 전자 상거래 플랫폼",

      text109: "로그인",
      text110: "제품",
      text111: "Nam A Bank의 제품",
      text112: "Sacombank의 제품",
      text113: "Techcombank의 제품",
      text114: "서비스 약관",
      text115: "로열티 회원 정책",
      text116: "연락처",
      text117: "확인됨",
      text118: "신청서가 제출되었습니다",
      text119: "인증코드를 입력하세요",
      text120: "골프 서비스",
      text121: "피치 요청이 전송되었습니다",
      text122: "은행 송금",
      text123: "최소 거래 금액",
      text124: "결제 방법",
      text125: "충전할 금액을 입력하세요.",
      text126: "리워드 포인트 지갑 충전",
      text127: "클립보드에 복사됨",
      text128: "리워드 포인트 지갑 역사",
      text129: "거래 수수료 발생",
      text130: "골프 지갑",
      text131: "카드 결제(JCB, Mastercard 등) – EPAY를 통해",
      text132: "사콤방크를 통한 결제",
      text133: "더 나은 경험을 위해 WGHN 앱을 다운로드하세요",
      text143: "해당 고객",
      text144: "특별 혜택",
      text145: "합격 가격",
      text146: "지금 코스 예약",
      text147: "추천 골프 코스",
      text148: "뉴스",
      text149: "2억 VND 보험 가입을 잊지 마세요. 패키지를 선택하세요",
      text150: "가격표 코스 예약",
      text151: "ID, 전화번호 또는 이름을 입력하세요",
      text152: "선수 이름",
      text153: "본인 구매",
      text154: "본인",
      text155: "및",
      text156: "기타",
      text157: "등록됨",
      text158: "총액",
      text159: "선수",

      text160: "개요",
      text161: "이름",
      text162: "오후 코스 길이",
      text163: "총 홀 수",
      text164: "설계자",
      text165: "작업일",
      text166: "도로",
      text167: "홀 수",
      text168: "파 수",
      text169: "보험 선택",
      text170: "보험가: 최대",
      text171: "추가",
      text172: "예상 가격",
      text173: "예약 완료",
      text174: "추천 기사",
      text175: "가격표",
      text176: "코스 리뷰",
      text177: "만족도",
      text178: "리뷰 작성...",
      text179: "이 휴대폰으로 예약하기 숫자",
      text180: "상태",
      text181: "지난 7일",
      text182: "지난 30일",
      text183: "맞춤 설정",
      text184: "할부 및 카드 결제(JCB, Mastercard 등) – ALEPAY를 통해",
      ConfirmRedirectAlePay:
        "AlePay 결제 페이지로 이동합니다. 계속하시겠습니까?",
      ConfirmRedirectEpay:
        "Epay 결제 페이지로 이동합니다. 계속하시겠습니까?",
      Confirm: "확인",
      back: "돌아와"
    }
  },
  jp: {
    policyObj: {
      text1:
        "キャンセルポリシーは各ゴルフコースのキャンセルポリシーに準拠します。詳細は以下の表をご覧ください。",
      text2:
        "各ゴルフコースにはキャンセルが可能な時間に関する規定があります。ゴルフ場指定時間内にお客様よりキャンセルの申し出があった場合。当社は、お客様からの有効なキャンセル要求を受領してから 2 営業日以内に返金いたします。",
      text3: `お客様がウェブサイトで直接予約して支払いをした場合、
 それは消えた`,
      text4: `当社のプロセス：ウェブサイトでの顧客注文 -> スタッフ
 スタッフが確認のために連絡 -> 営業が CMS に情報を入力 (予約コードと正しい情報を取得するため) -> 顧客が支払いを行う。`,
      text5:
        "お客様は、以下の 2 つの支払い方法のいずれかを使用して、フィールドデポジットの支払いを行います。",
      text6: "1. 転送。",
      text7: `顧客は支払い情報セクションでこの支払い方法を選択します。
 当社のプラットフォームで予約を行う際の支払い。クライアント
 wBookingの銀行口座に直接送金してください。
 この支払い方法を選択する際の手順。`,
      text8: `顧客が銀行振込による支払い方法を選択した場合、
 現在、お支払いは銀行振込口座番号情報に従って以下のように行われます。
 後：`,
      text9: `- 受取人口座名義：WGHNゴルフコース予約サービス株式会社`,
      text10: `- 口座番号: 888899988`,
      text11: `- 受取銀行：Nam A Commercial Joint Stock Bank。`,
      text12: `2. クレジットカード/デビットカード。`,
      text13: `顧客は支払い情報セクションでこの支払い方法を選択します。
 当社のプラットフォームで予約を行う際の支払い。選択後
 この支払い方法では、顧客は直接手順を実行します。
 Epay 決済ゲートウェイ経由の支払い。お支払い方法
 この場合、顧客はEpay 決済ゲートウェイにサービス料金を支払う必要があります。`,

      text14: `サービス提供方法およびサービス提供にかかる推定時間：`,
      text15: `ご注文が正常に完了すると、弊社スタッフが情報を受け取ります。
 再度ご連絡いただき、プレイ時間と料金をご確認ください。`,
      text16: `その後、弊社のカスタマーサービススタッフが現地予約情報を入力します。
 顧客がCMSソフトウェアにサインアップすると、zaloに自動通知が送信されます。
 確認のため1時間以内に電話番号または確認の電話をお願いします
 情報。`,
      text17: `注記。`,
      text18: `遅延の場合
 サービス提供に関しては速やかにお客様にお知らせいたします。
 顧客はキャンセルするか、通知を待ち続けるかを選択できます。
 メールからのメッセージ`,

      text19: `プライバシーポリシー`,
      text20: `消費者個人情報保護方針`,
      text21: `1. 情報収集の目的と範囲`,
      text22: `当社は、利用目的の範囲内で消費者情報を収集します。
 ユーザーがアカウントを登録する際に電子商取引サービスを提供するため
 アカウント、個人情報`,
      text23: `フルネーム`,
      text24: `電子メールアドレス`,
      text25: `電話番号`,
      text26: `連絡先`,
      text27: `組織や企業の名称と本社住所`,
      text28: `事業登録証明書の番号、発行日、発行場所
 設立決定を発行した業者、または番号、発行日、および発行単位
 組織の、または個人の個人納税者番号。`,
      text29: `ユーザーが使用するコンテンツに関するデータを集計します。`,
      text30: `使用されたデバイスによって送信された情報または使用されたデバイスに関連する情報
 アクセスするために使用する`,
      text31: `2. 情報の利用範囲`,
      text32: `社内向け`,
      text33: `会員へのサービスの提供`,
      text34: `メンバー間の情報交換活動に関する通知を送信します。
 会員と会社`,
      text35: `顧客の要求に応じて製品情報を提供します。
 クライアント`,
      text36: `当社が販売する製品に関するマーケティングおよびプロモーションメールを送信します;`,
      text37: `ウェブサイト上のアクティビティに関する通知を送信する`,
      text38: `メンバーのユーザーアカウントを破壊する行為を防止する
 会員または会員になりすますその他の行為;`,
      text39: `特別な場合にはメンバーと連絡を取り、解決する
 特別;`,
      text40: `会員の個人情報を本人確認以外の目的で使用しないでください。
 ウェブサイト上の取引に関連する受信および連絡`,
      text41: `法的要求がある場合`,
      text42: `責任ある協力
 司法機関からの要請に応じて会員の個人情報を提供します。
 法律には、検察院、裁判所、および関連する警察捜査機関が含まれます。
 お客様による違法行為に関して。その上、
 会員の個人情報を侵害する権利は誰にもありません。`,
      text43: `情報保存時間`,
      text44: `個人情報については、ウェブサイトは、以下の場合にのみこのデータを削除します。
 顧客からのリクエストがあり、顧客から電子メールの送信をリクエストされています
 予約@booking.wghn.net;`,
      text45: `上記の場合を除き、会員の個人情報は保護されます。
 予約サーバー上の秘密。`,
      text46: `個人情報にアクセスする可能性のある個人または組織`,
      text47: `顧客の個人情報にアクセスできる主体は、
 以下の場合:`,
      text48: `WGHN ゴルフコース予約サービス株式会社`,
      text49: `・当社が提供するサービスの一部を遂行する契約を締結したパートナー。
 ただし、これらのパートナーは契約に従って情報を受け取ることになります。
 契約合意書（条件に応じて情報の一部または全部となる場合があります）
 契約）は、ユーザーが当社が提供するサービスを利用できるように支援するものです。
 会社提供。`,
      text50: `個人情報の収集・管理を行う部署の住所`,
      text51: `住所: No. 20 Vo Chi Cong, Tay Ho Ward, Hanoi City, Vietnam`,
      text52: `ホットライン: 02471001088`,
      text53: `メール: booking@booking.wghn.net`,
      text54: `3. 消費者がデータにアクセスし編集するための方法とツール
 収集ユニットの電子商取引システム上の個人データ
 情報を収集する`,
      text55: `電子商取引システム上の個人データを編集するため
 サービス利用者は自分のアカウントにログインし、個人ページにアクセスします。
 編集が必要な情報を更新し、情報を保存して、
 個人情報を編集する.`,
      text56: `メンバーがeコマースアカウントに登録する際の注意
 Checktee.com`,
      text57: `「会員はすべての活動のセキュリティと保持について単独で責任を負う。
 ユーザー名とパスワードでサービスをご利用ください。メンバーは
 速やかに通知する責任`,
      text58: `使用行動について
 不正、不正使用、セキュリティ侵害、ユーザー名とパスワードの保持
 違反した場合には適切な解決策が講じられる。`,
      text59: `メンバーはサービスを使用していません`,
      text60: `いかなる目的であっても
 違法、不当、詐欺、脅迫、違法な情報収集
 法律、妨害行為、システムや構造に損害を与えるウイルスの作成と拡散
 画像、ページの情報を伝える`,
      text61: `またはのサービスを利用する
 私は投機、注文を生み出すための市場操作の目的で市場に参入します。
 市場の需要を判断する目的を含む虚偽のオファー。
 違反した場合、会員は
 法の前での彼らの行動。
 text62: 「メンバーはトレードページの信用を傷つけるような行動をとることはできません。」
 エレクトロニクス、`,
      text63: `いかなる形式でも
 名前の使用によってメンバー間の不和を引き起こすなど
 第三者または宣伝、流布を通じての二次登録
 ウェブサイトの評判に有益でない情報`,
      text64: `4.顧客情報セキュリティへの取り組み:`,
      text65: `「お客様から個人情報を収集する場合、」`,
      text66: `コミット:`,
      text67: `- 顧客の個人情報を販売、共有、交換しないでください
 ページで収集する場合、`,
      text68: `第三者に
 他の。 ただし、次の場合は除きます:`,
      text69: `「協力契約を締結した第三者」`,
      text70: `商業サービスを提供する
 電子商取引：電子ウォレットプロバイダー、サービスプロバイダー
 決済仲介サービス。`,
      text71: `「国家機関の要請により：検察庁、裁判所、機関
 違法行為に関する警察の捜査
 顧客のそれです。`,
      text72: `Bookingは顧客情報を収集する際に、その情報をサービス提供の目的にのみ使用します。
 Booking で電子商取引サービスを提供するプロセス。使用しないでください
 顧客情報を業務目的以外の目的で使用しない。
 電子商取引サービスプロバイダー;`,
      text73: `「メンバーの個人情報はアプリケーションのサーバー上で秘密に保持されます。」
 予約申し込み。 Booking は、顧客からの要求があった場合にのみこのデータを削除します。
 リクエスト、顧客は個人ページで「アカウントの削除」を選択するよう要求します
 または、booking@booking.wghn.netにメールを送ってください。`,
      text74: ` 個人情報の利用に関するフィードバックを受け取る仕組み
 情報収集の目的に反して、`,
      text75: `「顧客が、提供された個人情報が、`,
      text76: `コレクションが使用されました
 述べられた目的に反する。顧客は理事会に直接苦情を申し立てます。
 管理`,
      text77: ` 「を通じて
 次のチャンネル:`,
      text78: `電話番号: 02471001088`,
      text79: `メールをbooking@booking.wghn.netに送信`,
      text80: `Handeee本社まで直接お越しいただくか、ご意見・ご提案を下記までお送りください。住所: No. 20 Vo Chi Cong, Tay Ho Ward, Hanoi City, Vietnam.`,
      text81: `5.情報の利用に関する苦情処理手順
 管理委員会の公表された情報収集目的に反する個人
 Checktee.com `,
      text82: `ステップ1:`,
      text83: `カスタマーサービス部門は継続
 フィードバックを受け取ります。`,
      text84: `ステップ2:`,
      text85: `検査については技術部門にお問い合わせください
 アプリケーションサーバーに保存されている顧客情報が侵害されていないか確認する
 漏洩、ハッキング、盗難の有無にかかわらず。`,
      text86: `ステップ3:`,
      text87: ` 「総局長への報告 - 人物
 アプリケーションの管理と顧客とのコミュニケーションを担当します。
 個人情報が漏洩した場合の状況と解決策について8時間
 当該人物は情報収集以外の目的で利用されました。`,
      text88: `ステップ4:`,
      text89: `「単純なケースでは
 社内で発生したトラブルについては、Bookingが対応・解決いたします。学校で
 Bookingの能力と権限を超えた場合、管理者は
 管轄の警察機関に解決を要請し、調整する
 警察機関が捜査し解決する。`,
      text90: `コレクションには以下が含まれます:`,
      text91: `「1. 機密保持への取り組み。」`,
      text92: `カード決済システムは、ベトナムで合法的に運営するライセンスを取得した決済ゲートウェイ パートナー (「決済ゲートウェイ パートナー」) によって提供されます。したがって、ウェブサイト checkktee.com のカード決済セキュリティ標準は、業界のセキュリティ標準への準拠を保証します。`,
      text93: `2.プライバシーポリシー。`,
      text94: `2.1.国際カードおよび国内カード（インターネット バンキング）による支払い取引のポリシーでは、次のような支払いゲートウェイ パートナーのセキュリティ標準に準拠していることが保証されています。`,
      text95: `- 顧客の財務情報は、取引中に SSL (Secure Sockets Layer) プロトコルを使用して保護されます。`,
      text96: `- 支払情報データのセキュリティ基準を確保する。`,
      text97: `- 認証されたアカウントアクセスを確実にするために、ワンタイムパスワード (OTP) が SMS 経由で送信されます。`,
      text98: `- ベトナム国家銀行の規制に従った銀行および金融部門における情報セキュリティに関する原則と規制。`,
      text99: `2.2.ウェブサイト checktee.com の支払いにおける取引セキュリティ ポリシーは、以下の顧客に適用されます。`,
      text100: `- 当社はトークン ストレージ機能を提供します - 支払いゲートウェイ パートナーから当社に提供された暗号化された文字列のみを保存します。当社は顧客のカード情報を直接保管しません。顧客の支払いカード情報のセキュリティは、認可を受けた支払いゲートウェイ パートナーによって実行されます。`,
      text101: `- 国際カードの場合: 取引の確立に使用できる顧客の支払いカード情報は、ウェブサイト checktee.com のシステムには保存されません。支払いゲートウェイ パートナーがハニーを保存し、保護します。`,
      text102: `- 国際カードの場合: 取引の確立に使用できる顧客の支払いカード情報は、ウェブサイト checktee.com のシステムには保存されません。支払いゲートウェイ パートナーがハニーを保存して保護します。`,
      text103: `- 国内カード（インターネットバンキング）の場合、当社は注文コード、取引コード、銀行名のみを保存します。当社は、電子商取引の取引フロアウェブサイトchecktee.comで行われるすべての支払い活動に必要なセキュリティ対策を厳格に実施することに尽力しています。`,

      text104: `「苦情や紛争を解決する」`,
      text105: `「苦情および紛争解決メカニズム」`,
      text106: `ステップ1: 苦情情報の受信:`,
      text107: `お客様は以下のいずれかの方法でwBookingに苦情を送信できます:`,
      text108: `ホットライン02471001088に電話するか、booking@booking.wghn.netにメールしてください`,
      text109: `顧客は、苦情を解決するために、次の情報（電話番号、名前、プレイグラウンド、プレイ日時）とサポートが必要な問題を提供します。`,
      text110: `ステップ 2: 情報を確認する:`,
      text111: ` 1日以内（可能な場合はそれより早く）に、wBookingは苦情情報を確認し、確認、検討し、関係者に通知します。`,
      text112: `WBooking は、顧客に苦情の内容に関連する証拠を提供するよう要求し、苦情をサプライヤー (存在する場合) に送信します。`,
      text113: `ステップ3: 苦情解決:`,
      text114: `01日以内（可能であればそれより早く）、wBookingは顧客とサプライヤーに連絡して苦情を解決します。`,
      text115: `ステップ4: 交渉と和解:`,
      text116: `「可能であれば、wBooking は顧客とサプライヤーの交渉と調停を支援し、合理的な時間内に紛争を解決します。」`,
      text117: `ステップ5: 仲裁または裁判所:`,
      text118: `「交渉/調停が失敗した場合、紛争は法律に従って管轄裁判所で解決されます。」`,
      text119: `wBookingのコミットメント:`,
      text120: `「WBooking は、顧客の正当な権利を保障するという精神のもと、合意と法的規制に基づいて、すべての紛争と苦情を客観的に解決することを約束します。」`,
      text121: `「wBooking での取引から生じる、またはそれに関連するあらゆる論争、苦情、紛争は、善意と相互利益の精神に基づき、当事者間の交渉と調停を通じて解決されます。」苦情が交渉または調停によって解決できない場合、当事者は苦情を管轄の人民法院に持ち込んで解決することを決定するものとする。裁判所の決定は最終的なものであり、当事者に対して拘束力を持ちます。`,
      text122: `法的根拠:`,
      text123: `「2010 年消費者保護法、第 4 章 消費者と商品およびサービスの取引を行う組織および個人間の紛争解決について」`,
      text124: `「取引の一般条件」`,
      text125: `「私は。一般規定`,
      text126: `WGHN ゴルフコース予約サービス株式会社 (wBooking) は、ウェブサイト checktee.com を通じてサービスを提供しています。ウェブサイトにアクセスし、ログインし、使用することにより、サービスユーザー（「あなた」または「ユーザー」）は、これらの利用規約、wBookingサービスに関連するポリシー、およびその他のポリシーに同意するものとします。その他の書籍は、ウェブサイトで随時発表されます。`,
      text127: `「当社は、事前の通知なしにいつでも本利用規約の特定の部分を変更、追加、または削除することがあります。」引き続きログインし、ウェブサイトにアクセスして使用し、当社のサービスを利用することにより、お客様はこれらの変更に同意し、承諾することになります。`,
      text128: `お客様がウェブサイトchecktee.comのサービスを利用して、お客様が法的にリクエストを行う権限を有する他の個人/組織（「エンドユーザー」）のために注文を行う場合、お客様は、本規約および本利用規約を伝達する義務を負うことに同意するものとします。最終消費者に対する条件。`,
      text129: `1.適用範囲`,
      text130: `ウェブサイトを通じて、当社は、ゴルフ時間やその他の製品（「サービス」）に関連する製品を検索、使用リクエスト、注文するためのオンラインツールを、迅速、安全、便利な支払い方法で提供します。`,
      text131: `情報の検索を容易にするために、ウェブサイトにゴルフタイム製品に関する情報を表示します。`,
      text132: `「お客様のリクエストは、お客様がウェブサイトに登録した電話番号、またはZalo OA経由でお客様の電話番号に通知した電話番号、またはウェブサイトのお客様のアカウントに預けられた通知を通じて確認の電話を受けた時点で、当社によって処理され、確認されます。」`,
      text133: `2.保証なし`,
      text134: `「当社は、専門的なスキルと注意をもってサービスを遂行します。」ただし、当社は、提供されるすべての情報が正確、完全、適切であることを確認または保証するものではなく、いかなる誤り（配置の誤りや誤植を含む）、エラー、誤解、または情報の提供の失敗についても責任を負いません。当社は、関連情報の正確性と完全性について常に責任を負います。`,
      text135: `当社のサービスに関して苦情がある場合は、当社のカスタマーケア部門にご連絡ください。当社は合理的な解決策を見つけるよう努めますが、お客様のご希望に沿う結果を保証するものではありません。`,
      text136: `3.キャンセル、変更リクエスト`,
      text137: `当社のサービスを注文する場合、お客様は、サービスの使用範囲と提供、ゴルフコースの利用条件、キャンセルおよび変更ポリシーなど、当該サービスに関連するポリシーを承諾し、遵守することに同意するものとします。ゴルフコースのキャンセルおよび変更ポリシーは、当社のプラットフォームのキャンセルポリシー情報ページ、サービスの利用リクエスト時、および支払い通知（該当する場合）に掲載されます。`,
      text138: `ゴルフコースのポリシーに従って、キャンセルやサービスの変更に対して料金が請求される場合があり、また、事前に支払った金額は返金されないことにご注意ください。一部の料金や特別オファーはキャンセル、返金、変更できません。 Wbooking のキャンセル、製品変更、その他の製品関連のポリシーを注意深くお読みになることをお勧めします。リクエストを確認、編集、変更、またはキャンセルしたい場合は、カスタマーケア部門にお問い合わせください。`,
      text139: `II.価格、税金、手数料`,
      text140: `1.商品価格`,
      text141: `製品価格には追加の税金やその他の料金が含まれる場合がありますが、場合によっては価格に税金やサービス料が含まれていないこともあります。ユーザーは、確認通知がユーザーに送信されたときに、合計支払額、条件、およびその他の詳細を確認する責任があることに同意します。価格はユーザーが支払う金額を確認できるように詳細に表示されますが、クレジットカードの使用や銀行間手数料による追加費用はユーザーに請求されます。ユーザーが疑問がある場合サービスに関して、ユーザーはWBookingのカスタマーサービス部門に連絡することができます。`,
      text142: `当社は随時、通常価格よりも低い価格を提供したり、その他のプロモーションを適用したりすることがあります。プロモーションに参加するには、特定の条件を遵守する必要があります。`,
      text143: `1.支払手数料`,
      text144: `「国内発行国際カードのEPAY決済ゲートウェイ経由の支払い手数料」`,
      text145: `CTTトランザクションが正常に記録されました。 GTGD: 正常に記録されたCTT取引の合計値です。`,
      text146: `3.キャンセル料、または追加リクエスト`,
      text147: `支払い前であればいつでも予約をキャンセルできます。ただし、お客様が支払いを完了し、当社から支払い完了通知を受け取った後にキャンセルを希望する場合、当社が定める取引手数料（取引額の％として計算された手数料および取引手数料を含む）は返金されません。国際カードを支払い元として使用する取引のサプライヤー。当社のプラットフォーム上のキャンセルポリシーをよくお読みください。`,
      text148: `III.クレジットカード決済と詐欺`,
      text149: `1.このウェブサイトを通じて行われた予約の支払いについては、予約時および予約確認時に、Wbooking からクレジットカードに全額請求されます (払い戻しがある場合は、既存のピッチの条件に従います)。予約する前に必ず予約の詳細を注意深く確認してください。 Wbooking は、払い戻しがある場合には、合理的な期間内に払い戻しを処理します。当社に送信されるお客様のクレジットカード情報を保護し暗号化するために、当社はサービスにPCI DSS（Payment Card Industry Data Security Standard）やSSL（Secure Sockets Layer）などの暗号化技術を使用しています。`,
      text150: `2.クレジットカード詐欺やクレジットカードの不正使用が発生した場合、詐欺行為またはクレジットカードの不正使用に気付いた時点で、直ちに銀行またはカード発行会社に連絡するのはお客様の責任です。この場合、Wbooking は、詐欺または不正使用のケースであるかどうかにかかわらず、クレジットカード詐欺または他人によるクレジットカードの不正使用のケースについて責任を負いません。この許可は Wbooking サービスを通じて実行されます。 Wbooking は、このような詐欺の結果であるとみなされる支払いに対して補償または返金する義務を負いません。当社は、善意の表れとして、別の形で補償することを検討し、それに同意する場合があります。補償を請求できるのは、予約が当社の安全なサーバーを通じて行われ、クレジットカードの不正使用が当社の不在または過失によって発生した場合のみであり、安全なサーバーの使用中にお客様が引き起こしたエラーが原因ではありません。当社以外のアプリケーションまたはサーバーを通じて不正行為が行われた場合、またはお客様のクレジットカードの不正使用がお客様自身の過失や落ち度の結果である場合、当社はお客様のクレジットカードの不正使用または不正使用について責任を負いません。 Wbooking で不正な予約や詐欺行為が行われている疑いがある場合は、直ちにカスタマー サポートにご連絡ください。`,
      text151: `3.予約を行うには、18歳以上であり、取引を行う完全な法的行為能力を有している（または法定後見人からの許可を得ている）必要があります。ご自身の名義で発行された、ご自身が所有するクレジットカードまたはデビットカードを使用し、取引手数料をカバーするのに十分な資金があることを確認する必要があります。お客様は、お客様に代わって、またはお客様のアカウントで行われたすべての取引に対して金銭的な責任を負います。`,
      text152: `4.当社に提供する詳細情報が真実、正確かつ完全であることを保証する必要があります。 WBooking ではベトナムで発行されたクレジットカードのみ受け付けております。 Wbookingは当社の裁量により他の支払い方法を追加または削除する場合があります。`,
      text153: `5.場合によっては、当社のプラットフォームで詳しく説明されているように、予約を検証および確認するために追加情報を要求されることがあります。予約は確認メールを受信するまで確定されません。また、プロバイダーが予約プロセス中に不正行為検出メカニズムを実装する可能性があります。不正行為が発生した場合、または発生したと判断された場合、賭けは消滅するか、自動的に無効になります。 Wbookingは責任を負いません。追加情報を提供しない場合は、予約は完了せず無効になります。`,
      text154: `IV. WBOOKINGの権利と責任`,
      text155: `1.ウェブサイト管理委員会の権利`,
      text156: `a.パートナーは、checktee.comウェブサイト上のサービス提供契約の内容、およびウェブサイトChecktee.comに公開されているWBooking運営規則に従って権利と義務を履行する必要があります。`,
      text157: `b. Checktee.com は、パートナーのサービスのうち 1 つまたはすべてを使用する権利を終了する場合があります。顧客およびパートナーに通知します。パートナーの場合、少なくとも1か月間の顧客。顧客がchecktee.comサービスを提供するウェブサイトの規則に違反したり、checktee.comでのビジネス活動に影響を与える行為を行ったりした場合、`,
      text158: `c. Checktee.com は、パートナーのサービスの利用権およびメンバーシップを直ちに終了することができます。ウェブサイト Checktee.com がパートナーを検出した場合の顧客;依頼人がパートナーの場合、有罪判決を受けているか、刑に服している。運営を継続する顧客は、ウェブサイト Checktee.com に法的責任を負わせたり、詐欺行為や偽造を行ったり、市場を混乱させたり、パートナー間の不和を引き起こしたりする可能性があります。ウェブサイト Checktee.com の他の顧客、現在のベトナムの法律に違反する活動。`,
      text159: `d. Checktee.com は、ベトナムの知的財産保護に関する法律に従って、Checktee.com ウェブサイト上のサービスおよびコンテンツを使用する著作権を留保します。さまざまな言語のすべてのアイコンとコンテンツは、Checktee.com ウェブサイトが所有しています。上記の所有権を複製、使用、違法に配布する行為は固く禁じます。`,
      text160: `2.責任:`,
      text161: `a. Checktee.com は、Checktee.com Web サイトで提供される情報が正確かつ完全であることを保証するために、「検査および監視メカニズム」を構築および実装する責任を負います。`,
      text162: `b.サービスを提供できるように、パートナーに完全かつ正確でタイムリーな顧客情報を提供します。`,
      text163: `c. Checktee.comは、ウェブサイト上で違法なビジネス活動を発見したり、フィードバックを受け取ったりした場合には、タイムリーな措置を講じ、違法なビジネス活動の調査において州の管理機関を支援します。法律、登録情報、取引履歴、および法律違反の対象に関するその他の文書を提供します。ウェブサイト Checktee.com`,
      text164: `d. Checktee.com は、Checktee.com ウェブサイトでの取引中に生じる紛争を解決するためのメカニズムを公表する責任を負います。 Checktee.comウェブサイト上の顧客が販売者（パートナー）と対立したり、正当な利益を損なったりした場合。 Checktee.comは、販売者（パートナー）に関する情報をお客様に提供し、お客様の正当な権利と利益を保護するために積極的にサポートします。`,
      text165: `e. Checktee.com は、法律の規定に従わないサービスを提供するウェブサイト情報を防止し、削除する責任を負います。`,
      text166: `f. Checktee.com は、ウェブサイトの構築を担当しており、調査、設計、ハードウェアとソフトウェアの購入、インターネット接続、ウェブサイトの運営に役立つポリシーの構築など、いくつかの主要なタスクが含まれます。Checktee.com は、利用規約に従ってこれを行います。ウェブサイト Checktee.com は、ウェブサイト Checktee. .com に参加するパートナーとユーザーの取引に対応するためのサービスとユーティリティ ツールのシステムの構築においてパートナーと協力し、展開します。`,
      text167: `g. Checktee.com はパートナーからのフィードバックを受け取る責任を負います。紛争が発生した場合の顧客。取締役会はそのようなフィードバックを検討します。 Checktee.com ウェブサイトでは、レベルに応じて会員の権利を保護するための計画を立てています。`,
      text168: `h. Checktee.comは、その範囲と条件の範囲内で、Checktee.comウェブサイトの正常な動作を維持し、機械の技術的問題、ソフトウェアエラー、インターネット伝送システム、人員、社会的変動、自然災害、電力などの問題を解決するために最善を尽くします。停電、政府機関または第三者組織の決定。ただし、上記の事象が制御不能に発生し、会員に損害を与える不可抗力の事象である場合、Checktee.com ウェブサイトは責任を負いません。`,
      text169: `V. CHECKTEE.COMウェブサイト上の顧客（購入者、サービス利用者など）の権利と責任`,
      text170: `1.顧客の権利`,
      text171: `a.情報に対する権利: 顧客には、価格、品質、機能、取引条件、返品および保証ポリシーを含む製品/サービスに関する完全かつ正確な情報が提供される権利があります。`,
      text172: `b.情報機密保持の権利: 法律で別段の定めがない限り、個人情報を保護し、同意なしに開示されない権利を有します。`,
      text173: `c.保護を受ける権利: あなたの権利や健康に害を及ぼす低品質で詐欺的な製品やサービスから保護される権利。`,
      text174: `d.苦情および紛争解決の権利: 製品/サービスが要件を満たしていない場合、または説明どおりでない場合は、苦情を申し立て、紛争解決を要求する権利があります。`,
      text175: `e.サポートを受ける権利: 製品情報、使用方法、質問への回答に関して、Web サイト管理者からサポートを受ける権利があります。`,
      text176: `2.顧客の責任`,
      text177: `a.正確な情報を提供する: ウェブサイトで登録および取引を行う際には、正確かつ完全な個人情報と支払い情報を提供します。`,
      text178: `b.取引規制の遵守: サービスを利用する際は、ウェブサイトに掲載されている取引条件を遵守してください。`,
      text179: `c.アカウントのセキュリティ: 詐欺や個人情報の紛失を防ぐため、アカウント情報とパスワードを秘密に保ち、他人と共有しないでください。`,
      text180: `d.サービスの責任ある使用: 責任を持ってサービスを使用し、違法な目的で使用したり、システムや他人の権利を害したりしないでください。`,
      text181: `e.期限通りに支払う: 製品/サービスを購入する際は、必要に応じて期限通りに全額支払います。`,
      text182: `f.フィードバックと提案: ウェブサイトのサービスと製品の品質を向上させるために、フィードバックと提案を提供します。`
    },
    notiRegistered:
      "お客様はこの電話番号でアカウントを登録しています。ログインしてください。",
    skipLower: "小文字",

    create_acc: "アカウントを作成する",
    regDone: "正常に登録されました",
    update: "アップデート",
    welcomeWg: "メンバーを wGroup にようこそ",
    yourVid: "あなたのvIDコードは",
    pleaseUpdate: "アカウントを保護するために個人情報を更新してください",
    whenJoinWg: "WGHN に参加すると、多くの限定オファーを受け取る機会があります",
    seeDetail: "詳細を見る",
    here: "ここ",
    birth: "生年月日",
    emailAddress: "電子メールアドレス",
    updateInfoUser: "個人情報を更新する",
    infoUpdateDone: "情報が正常に更新されました。",
    thankYour:
      "メンバーの皆様、wGroup のサービスを信頼してご利用いただきありがとうございます。ご不明な点がございましたら、024.7100.1088 またはカスタマーサービスまでお問い合わせください。今すぐ WGHN アプリをダウンロードして、メンバー限定のオファーをお見逃しなく。よろしくお願いします！",
    captcha: "キャプチャコードを入力してください",
    phoneNumber2: "電話番号",
    needCancel:
      "キャンセルする必要がある場合は、ホットライン: 02471.001.088 までご連絡ください。",
    rechargePoints: "ゴルフウォレットのリチャージ",
    paymentMethod: "支払方法",
    order: "注文",
    and: "そして",
    enterBook:
      "「注文する」をクリックすると、注文の処理、Web サイトの使用体験の向上、およびこのセクションで説明されているその他の特定の目的のために個人情報が使用されることに同意したことになります。",
    out: "私たちの。",
    enterPay: "「支払う」をクリックすると、従うことに同意したことになります",

    personalInformationPolicy: "個人情報収集方針",

    termsTransaction: "取引条件",
    complaints: "苦情紛争解決メカニズム",

    paymentInfoSecurityPolicy: "決済情報セキュリティポリシー",
    cusInfoSecurityPolicy: "お客様情報セキュリティポリシー",
    accountInfo: "アカウント情報",
    accountSettings: "アカウント設定",
    account: "アカウント",
    cancellationPolicy: "返金とキャンセルポリシー",
    privacyPolicy: "プライバシーポリシー",
    deliveryPolicy: "配送ポリシー",
    payPolicy: "支払いポリシー",

    policy: "ポリシー",
    branchAddress: "支店住所",
    certificate:
      "事業者登録証：0109147466。2020年3月27日初発行。発行機関: ハノイ計画投資局。",
    introduce: "導入",
    bookingReqSend: "ピッチリクエストが送信されました",
    yard: "サン",
    suggestions: "あなたへのご提案",
    noti:
      "ゴルフ予約サービスの見積もりを受け取るために、お客様の情報をご入力ください。",
    noti1: "ありがとうございます。ゴルフ予約サービスの予想価格は： ",
    noti2:
      " VND / 1人です。正確な見積もりを受け取り、wGroupおよびパートナーの特典を利用するために予約リクエストを送信してください。",
    typeInsurance: "HIOパッケージを選択",
    typeInsuranceAll: "全体予約のためにHIOパッケージを選択",
    titleHeader: "フィールド予約",
    titleMenuArea: "エリアで選択",
    titleHotDeal: "お得な取引",
    nearestDate: "最も近い日付",
    incorrectCode: "コードが間違っています。もう一度やり直してください。",
    farthestDate: "最も遠い日付",
    titleTop10: "トップ10の最高のフィールド",
    login: "ログイン",
    logout: "ログアウト",
    termsAndConditions: "利用規約",
    noBooking: "予約はまだありません",
    noOrderBk: "予約がないか、まだ予約が確定していません",
    hotDealTitle1: "今すぐ最高のティータイムを予約",
    hotDealTitle2: "お得な価格のフィールド",
    titleTop10Page: "今週のトップ10最高のゴルフフィールド",
    descPageHome: "早い - 便利 - 簡単",
    aboutUs: "私たちについて",
    contact: "お問い合わせ",
    quickBookField: "リクエストを送信",
    doNotShareAuthenticationCode:
      "アカウントが盗まれないように認証コードを共有しないでください",
    authenticationCodeSentToPhoneNumber: "認証コードが電話番号に送信されました",
    enterAuthenticationCodeBelow: "下に認証コードを入力してください",
    pleaseWait: "お待ちください",
    seconds: "秒",
    toResendNewCode: "新しいコードを再送信するには",
    noteCheckMessage:
      "注意：タイムリーにコードを受信するにはメッセージを確認してください",
    authenticationCodeExpired:
      "認証コードの有効期限が切れています。クリックしてください",
    resend: "再送信",
    toResendCode: "コードを再送信するには",
    noteCheckMessageAgain:
      "注意：タイムリーにコードを受信するにはメッセージを確認してください",
    bookField: "フィールド予約",
    noTeetimeAvailable:
      "この日に利用可能なティータイムはありません。別の日を選んでください。",
    downloadApp: "WGHNアプリをダウンロード",
    all: "全て",
    northern: "北部",
    fieldArea: "フィールドエリア",
    priceRange: "価格帯",
    playTime: "プレイ時間",
    servicesAndUtilities: "サービスと設備",
    lightSnackField: "軽食があるフィールド",
    lightedField: "照明付きフィールド",
    crowdedField: "混雑したフィールド",
    sort: "並び替え",
    default: "デフォルト",
    averagePricePerPax: "1人当たりの平均価格",
    priceLowToHigh: "低い順に並べ替え",
    priceHighToLow: "高い順に並べ替え",

    apply: "適用",
    central: "中央",
    southern: "南部",
    evening: "照明",
    numberOfPeople: "人数 (*)",
    insuranceRequired: "ホールインワン・イーグル保険あり",
    timeRequired: "ティータイムを選択 (*)",
    choosetee: "ティータイムを選択",

    searchByField: "フィールドで検索",
    waitForConfirmation: "確認待ち",
    waitForPayment: "注文済み",
    cancelled: "キャンセルされました",
    invoiceInformation: "請求書情報",
    invoiceCode: "請求書コード:",
    numberOfPaymentServices: "支払いサービスの数:",
    booker: "予約者:",
    phoneNumber: "電話番号:",
    service: "サービス",
    quantity: "数量:",
    unpaid: "未払い",
    totalPaymentAmount: "支払い総額:",
    totalWWalletPoints: "ゴルフウォレットに貯まったポイントの合計:",
    payment: "支払い",
    support: "フィールド予約のサポートが必要な場合、",
    PBX: "24/7対応ホットライン 0247.100.1088",
    viewMore: "もっと見る",
    shorten: "短くする",
    viewAll: "すべて見る",
    numberHolesText: "ホール数",
    totalNumberOfPeople: "合計人数",
    describe: "説明",
    addPerson: "人を追加",
    playerNotFound:
      "このvIDでプレーヤーが見つかりません。もう一度お試しください！",
    searchByVID: "vIDで検索",
    includedServicesAndFees: "含まれるサービスと料金",
    electricCarFeeIncluded: "電動カーフィー込み",
    lightMealIncluded: "軽食込み",
    hotelNotIncluded: "ホテルは含まれていません",
    flightTicketNotIncluded: "航空券は含まれていません",
    iAgreeWith: "私は同意します",
    serviceTerms: "サービス規約",
    bookingRequestSentQuickly:
      "ご依頼は国際ゴルフ場予約ホットラインwBookingの営業部に送信されました。すぐにご連絡いたします。",
    bookingRequestSent:
      "ご依頼は国際ゴルフ場予約ホットラインwBookingの営業部に送信されました。すぐにご連絡いたします。",
    fieldName: "フィールド名",
    bookingDate: "予約日",

    playDate: "プレイ日",
    numberOfPlayers: "プレイヤー数",
    totalAmount: "合計金額",
    thankYouForBooking: "wBookingでのご予約ありがとうございます。",
    contactToConfirmBooking: "この予約を確認するためにご連絡いたします。",
    encounterBookingIssues: "予約中に問題が発生した場合。",
    contactNumber: "以下の番号にご連絡ください: 02471.001.088",
    servicesAndSurchargesAreIncluded: "サービスと追加料金が含まれています",
    history: "履歴",
    field: "フィールドを選択 (*)",
    chooseFacility: "フィールドを選択",
    yardDetails: "ヤードの詳細",
    favoritesList: "お気に入りリスト",
    superDeal: "スーパーお得",
    amountToPay: "支払う金額:",
    billCode: "請求書コード:",
    paymentCode: "支払いコード:",
    addPlayer: "プレイヤーを追加",
    orderStatus: "注文状況:",
    orderCode: "ヤード予約コード",
    viewBillDetails: "請求書の詳細を見る",
    billDetails: "請求書の詳細",
    finishedIn: "終了まで",
    reserveYourYardNow: "今すぐヤードを予約",
    titleContact: "お問い合わせ",
    titleAboutUs: "WBookingについて",
    hole: "ホール",
    searchBtn: "検索",
    infoCourse: "コース情報",
    enterNameOrIDToSearch: "名前またはvIDを入力して検索",
    evaluate: "評価",
    selectPeopleToAdd: "追加する人を選択",
    discount: "割引",
    areaNorthern: "北部地域のベストゴルフコース",
    areaSouth: "南部地域のベストゴルフコース",
    areaCentral: "中央地域のベストゴルフコース",
    expired: "コードの有効期限が切れています",
    titleTermsAndConditions1: "第1条. 一般原則",

    contentTermsAndConditions11:
      "1. vHandicapアプリケーションプラットフォームでHIOサービスを登録する前に、お客様はこのHIOサービス提供および使用契約（以下、「契約」と呼びます）のすべての条項を読み、理解し、同意したことを確認します。HIOサービスの登録に同意することにより、お客様は以下のすべての条項および条件に関して何の制限も受けないことを認めます。\n",
    contentTermsAndConditions12:
      "2. vHandicapアプリケーションプラットフォームでベトナムゴルフスポーツサービス株式会社（以下、「当社」または「VGS SPORT」と呼びます）が提供するHIOサービスに参加する際、お客様は法的拘束力のある契約を締結するための法定年齢に達していることを約束し、ベトナムの法律によりサービスの受け取りが禁止されていない、または親または法定後見人から事前の同意を得て本契約に基づきサービスを利用することができます。\n",
    contentTermsAndConditions13:
      "3. 当社は、本契約をいつでも予告なしに修正または更新することができます。これらの修正は、vHandicapアプリケーションに更新された時点で直ちに有効となります。お客様はこれらの変更を定期的に確認する必要があり、このサービスの利用を継続することは、変更された内容に同意したものと見なされます。",
    titleTermsAndConditions2: "第2条. HIOサービスの説明",
    contentTermsAndConditions21:
      "1. HIOサービスはゴルフ競技におけるトーナメントサービスであり、HIOサービスを選択したお客様に対して、ゴルフコースの18ホールラウンドでパー3ホールで1回のショットで規定のホールにボールを成功させたプレイヤーに「ホールインワン」賞が授与されます。\n",
    contentTermsAndConditions22:
      "2. HIOトーナメントは、ベトナムゴルフスポーツサービス株式会社が主催するゴルフトーナメントであり、vHandicapアプリケーションを通じて提供されたHIOサービスを使用することを選択した大会です。サービスを登録することで、お客様はVGS Sportが参加するHIOトーナメントの公式主催者となることに同意します。\n",
    contentTermsAndConditions23:
      "3. HIO賞は、お客様1人あたり、1日1回、18ホールの標準ラウンドごとに1回のみ授与されます（お客様が1日に2回以上HIOを達成した場合でも、登録したHIOサービスの価値に相当する賞を1回のみ受け取ることができます）。\n",
    contentTermsAndConditions24:
      "4. お客様が同じ18ホールラウンドに対して2つのHIOサービスパッケージ（デイリー保険パッケージおよび年間会員パッケージ）に登録した場合、お客様は登録した2つのサービスの賞金に対応する2つのHIO賞を受け取ることができます。",
    search: "ティータイム検索",
    overTeeTime: "ティータイムがありません",
    date: "日付",
    latest: "最新",
    time: "時間",
    filter: "フィルター",
    courseTee: "コースティータイム",
    bookNowBtn: "今すぐ予約",
    bookNow: "今すぐ予約",
    price: "価格",
    from: "から",
    morning: "朝",
    afternoon: "午後",
    lightHour: "照明時間",
    descTee: "含まれるもの: グリーンフィー & キャディフィー & 1/2バギー",
    addUser: "ユーザー追加",
    totalMoney: "合計金額",
    addUserTee: "ティータイムにプレイヤーを追加",
    listUser: "プレイヤーリスト",
    confirm: "確認",
    comingSoon: "アプリケーション開発中",

    notiSendOtp:
      "WBooking (WGHN)にアカウントがありません。WBooking (WGHN)からSMSで送信されたOTPコードを入力して、アカウント開設に同意し、WBooking (WGHN)でアカウントを開設するための条件と規約に同意してください。",
    subSendOtp: "電話番号に送信されたOTPを入力してください",
    notiSendOtpVGS:
      "WBooking (WGHN)がSMSで送信したOTPコードを入力して、WBooking (WGHN)のアカウントにログインを認証してください。",
    fullName: "氏名",
    noData: "データなし",
    pleaseFillInAllInformation: "すべての情報を入力してください",
    userVga: "vIDを持つプレイヤー",
    userOutSystem: "システム外のプレイヤー",
    note:
      "注意: 20,000,000 VNDの保険パッケージは、WBookingを通じて予約したすべての予約に対するプロモーションギフトです。",
    unConfirm: "未確認",
    pay: "支払い",
    paymentGuide: "支払いガイド",
    bank: "銀行",
    bookQuicklyToEnsureYouReserveYourSpot:
      "席を確保するために早めに予約してください",
    content: "内容",
    numberCard: "口座番号",
    amountMoney: "金額",
    accountHolder: "口座名義人",
    scanQr: "WGHNアプリを使用してQRコードをスキャンしてください",
    unPay: "未払い",
    paid: "支払済み",
    BookingCode: "予約コード",
    outsideSystem: "システム外",
    enterFullName: "氏名を入力してください",
    userBooking: "ユーザーブッキング",
    companyName: "ゴルフ予約サービス株式会社 WGHN",
    orPay: "または各人に支払う",
    payNow: "今すぐ支払う",
    notify: "通知",
    next: "フィールド予約",
    setUpTheYardQuickly: "迅速なフィールド予約",
    skip: "スキップ",

    notFoundMessage:
      "コースが見つかりませんでした。別のコースで再試行してください。",
    waitOtpText: "OTP確認をお待ちください",
    paymentReminder: "注文確認後30分以内にお支払いください。",
    enteredOTPConfirmBooking:
      "WBooking (WGHN)からSMSで送信されたOTPコードを入力して取引を確認してください。",
    notiPaymentIn30Minute:
      "予約情報が記録されました。WBooking (WGHN)からの確認をお待ちください。確認通知を受け取ってから30分以内にお支払いください。",
    enterOtp: "下のボックスに確認コードを入力してください",
    notiSuccess: "予約が成功しました！スタッフの予約確認をお待ちください。",
    textBookingCourse: "コースを予約してもよろしいですか？",
    terrain: "コースの地形",
    buyMore: "追加購入",
    codeBooking: "予約コード",
    bannerContent:
      "コースの予約、ショッピング、ゴルフ旅行、その他の便利なサービスをお楽しみください！",
    bannerSubContent: "今すぐWGHNアプリをダウンロード！",
    bookCourse: "ゴルフコースを予約する",
    shopping: "ショッピング",
    hio: "HIO保険",
    handee: "deHanddeファッション",
    for: "対象",
    people: "人",
    at: "時",
    yes: "ホールインワン・イーグル保険あり",
    no: "ホールインワン/イーグルは対象外",
    bookingSwitchboard: "wBooking国際ゴルフコース予約ホットライン",

    wap: {
      text1: "すべて",
      text2: "北部",
      text3: "中部",
      text4: "南部",
      text5: "朝",
      text6: "午後",
      text7: "ライト",
      text8: "確認待ち",
      text9: "支払い待ち",
      text10: "支払い済み",
      text11: "失敗",
      text12: "日付を入力",
      text13: "場所を入力",
      text14: "から",
      text15: " レビュー",
      text16: "日付を入力",
      text17: "人数",
      text18: "朝",
      text19: "正午",
      text20: "ライト時間",
      text21: "9ホール",
      text22: "18ホール",
      text23: "27ホール",
      text24: "ホール数",
      text25: "お得な価格",
      text26: "ホーム",
      text27: "氏名",
      text28: "保険",
      text29: "検索",
      text30: "特別割引",
      text31: "キャンセル済み",
      text32: "コース予約",
      text33: "予約がありません",
      text34: "支払い済み",
      text35: "数量",
      text36: "当チームが注文を確認してから30分以内にお支払いください",
      text37: "支払い",
      text38: "残高",
      text39: "金額",
      text40: "ウォレットの残高が支払いに不足しています",
      text41:
        "ウォレットにチャージするか、他の支払い方法を選択してください。ありがとうございます！",
      text42: "閉じる",
      text43: "ウォレットにチャージ",
      text44: "押し続けて写真に保存",
      text45: "口座番号",
      text46: "口座名義",
      text47: "銀行",
      text48: "金額",
      text49: "振込内容",
      text50:
        "（注意: 振込内容を正確に入力する必要があります。不正確な場合、取引の過程で問題や遅延が発生する可能性があります。）",

      text51: "ウォレットの残高",
      text52: "ウォレットにチャージ",
      text53: "取引履歴",
      text54: "ウォレット利用規約",
      text55: "注文",
      text56: "ログアウト",
      text57: "言語",
      text58: "wGroupのvIDでログイン中です",
      text59: "ロイヤルメンバーの特別オファーの詳細を確認",
      text60: "会員ランク",
      text61: "すべての注文でポイントを獲得",
      text62: "ポイントは報酬ウォレットにクレジットされます",
      text63: "（システム外）",
      text64:
        "当社のサービスをより便利に利用するために、報酬ウォレットアカウントにお金を振り込みます",
      text65: "ゴルフウォレット残高 (₫)",
      text66: "チャージ額を入力 (₫)",
      text67: "最小",
      text68: "次へ",
      text69: "金額 (₫)",
      text70: "残高 (₫)",
      text71: "内容",
      text72: "これ以上の取引はありません",
      text73: "これ以上の取引はありません",
      text74: "残高",
      text75: "金額",
      text76: "押し続けて写真に保存",
      text77: "口座番号",
      text78: "口座名義",
      text79: "銀行",
      text80: "金額",
      text81: "振込内容",
      text82:
        "（注意: 振込内容を正確に入力する必要があります。不正確な場合、取引の過程で問題や遅延が発生する可能性があります。）",
      text83: "お得な価格",
      text84: "お気に入りのコース",
      text85: "ホーム",
      text86: " レビュー",
      text87: "日付を入力",
      text88: "人数",
      text89: "9ホール",
      text90: "18ホール",
      text91: "27ホール",
      text92: "お得な価格",
      text93: "ホール数",
      text94: "から",

      text95: "ログイン",
      text96: "ログアウト",
      text97: "プレイヤー追加",
      text98: "WGHN ゴルフコース予約サービス JSC (wBooking)",
      text99: "住所",
      text100: "No. 20 Vo Chi Cong, Tay Ho Ward, Hanoi City.",
      text101: "中部",
      text102: "368 Tran Hung Dao, An Hai Tay 区, Son Tra 地区, ダナン",
      text103: "南部",
      text104:
        "No. 1, Road No. 17, CityLand Park Hills Urban Area, Go Vap Ward, Ho Chi Minh City.",
      text105: "エコシステム",
      text106: "連絡先",
      text107: "WGHN 電子商取引プラットフォーム",
      text108: "Handee 電子商取引プラットフォーム",

      text109: "ログイン",
      text110: "製品",
      text111: "Nam A Bankの製品",
      text112: "Sacombankの製品",
      text113: "Techcombankの製品",
      text114: "利用規約",
      text115: "ロイヤルティメンバーポリシー",
      text116: "連絡先",
      text117: "確認済み",
      text118: "申請書が提出されました",
      text119: "確認コードを入力してください",
      text120: "ゴルフサービス",
      text121: "ピッチリクエストが送信されました",
      text122: "銀行振込",
      text123: "最低取引金額",
      text124: "支払方法",
      text125: "入金する金額を入力してください。",
      text126: "ポイントウォレットにチャージ",
      text127: "クリップボードにコピーしました",
      text128: "ポイントウォレットの履歴",
      text129: "取引手数料が発生",
      text130: "ゴルフウォレット",
      text131: "カード決済（JCB、Mastercard など）– EPAY 経由",
      text132: "サコムバンクでの支払い",
      text133: "より良い体験のためにWGHNアプリをダウンロードしてください",
      text134: "予約フィールドの価格表",
      text135: "wBookingで",
      text136: "ゴルフコース",
      text137: "日付",
      text138: "適用時間",
      text139: "顧客が申請",
      text140: "価格",
      text141: "週刊",
      text142: "週末",
      text143: "対象のお客様",

      text144: "特別オファー",

      text145: "お得な価格",

      text146: "今すぐコースを予約",

      text147: "おすすめのゴルフコース",

      text148: "ニュース",

      text149: "2億ドンの保険加入をお忘れなく。パッケージをお選びください",

      text150: "コースを予約する料金表",

      text151: "ID、電話番号、または名前を入力してください",

      text152: "プレーヤー名",

      text153: "ご自身で購入",

      text154: "お客様",

      text155: "および",

      text156: "その他",

      text157: "登録済み",

      text158: "合計",

      text159: "プレーヤー",

      text160: "概要",

      text161: "名前",

      text162: "午後 コースの長さ",
      text163: "ホール数",

      text164: "設計者",

      text165: "運営日",

      text166: "道路",

      text167: "ホール数",

      text168: "パー数",

      text169: "保険を選択",

      text170: "保険金額：最大",

      text171: "追加",

      text172: "見積もり価格",

      text173: "予約完了",

      text174: "特集記事",

      text175: "料金表",

      text176: "コースレビュー",

      text177: "満足度",

      text178: "レビューを書く…",

      text179: "この電話番号で予約を作成",

      text180: "ステータス",

      text181: "過去7日間",

      text182: "過去30日間",

      text183: "カスタマイズ",
      text184: "分割払い・カード決済（JCB、Mastercard など）– ALEPAY 経由",
      ConfirmRedirectAlePay: "AlePayの決済ページに移動します。よろしいですか？",
      ConfirmRedirectEpay: "Epayの決済ページに移動します。よろしいですか？",
      Confirm: "確認",
      back: "戻ってくる"
    }
  }
};

const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "vi", // set locale
  fallbackLng: "vi", // set fallback locale
  messages // set locale messages,
});

export default i18n;
